import $ from "jquery";
import _ from "underscore";
import Backbone from "backbone";
import RSVP from "rsvp";
import ti18n from "i18n!nls/helperi18n";

//"models/helper/FeatureRolloutHelper",
/*"controllers/login/LoginControllerNew", */
import Utils from "models/helper/Utils";
import ExpectedError, {
  EXPECTED_ERROR_CATEGORY,
  EXPECTED_ERROR_CLASSIFICATION,
} from "models/helper/ExpectedError";

import LocalStorageHelper from "models/helper/LocalStorageHelper";
import { isLocalhostHostname, getDefaultLocalApiBaseUrl } from "models/helper/LocalhostHelper";

const httpOrHttpsPrefix = "https://";

//const Rollout = FeatureRolloutHelper.getInstance();
const playTrebbleServerUrl = "mysterious-fortress-7412.herokuapp.com";
// API_BASE_URL is injected by webpack DefinePlugin at compile time.
// DefinePlugin replaces `process.env.API_BASE_URL` with a string literal,
// so no runtime `typeof process` guard is needed (it would short-circuit).
const _apiBaseOverride = (process.env.API_BASE_URL || "").replace(/\/+$/, "");
const _resolvedApiBaseUrl = _apiBaseOverride || (isLocalhostHostname(window.location.hostname) ? getDefaultLocalApiBaseUrl() : "");
const _apiBaseOverrideHasProtocol = /^https?:\/\//.test(_resolvedApiBaseUrl);
const trebbleServerUrl = _resolvedApiBaseUrl ? _resolvedApiBaseUrl.replace(/^https?:\/\//, '') : "s.trebble.fm";
// When API_BASE_URL specified a protocol explicitly, preserve it so bare
// `_getApiBaseUrl()` call sites don't force HTTPS on a plain HTTP backend.
function _getApiBaseUrl() {
  if (_apiBaseOverrideHasProtocol) return _resolvedApiBaseUrl.replace(/\/$/, '');
  return window.trebble.usedProtocolPrefix + trebbleServerUrl;
}
//const trebbleServerUrl = "localhost:8888"; //maison
//const trebbleServerUrl = Utils.getInstance().getTestServerEndpoint();
//const trebbleServerUrl = "192.168.1.14:8888"; //
//const trebbleServerUrl = "192.168.1.16:8888";//Douala
function getApiServerBaseUrl() {
  return _getApiBaseUrl();
}
const isEmbeddedInIframe = window.top !== window.self;
const isEmbedded = isEmbeddedInIframe || $("body").hasClass("embedded");
const WORKOS_AUTH_PROVIDER_MAP = Object.freeze({
  APPLE: "AppleOAuth",
  GOOGLE: "GoogleOAuth",
});
const WORKOS_UNSUPPORTED_FACEBOOK_ERROR =
  "Facebook authentication is not available in the new Trebble hosted auth flow yet. Please use email, Google, or Apple.";
const DEFAULT_WORKOS_STUDIO_CLIENT_ID = (process.env.WORKOS_STUDIO_CLIENT_ID || "").trim() || "motion-studio";
const DEFAULT_WORKOS_STUDIO_REDIRECT_URI =
  (process.env.WORKOS_STUDIO_REDIRECT_URI || "").trim() || "https://exp-studio.trebble.fm/callback";
const WORKOS_MOBILE_REFRESH_LEEWAY_IN_MILLISECONDS = 60 * 1000;
const WORKOS_MOBILE_IN_APP_BROWSER_FEATURES =
  "location=yes,toolbar=yes,hardwareback=yes,clearcache=yes,clearsessioncache=yes,hidenavigationbuttons=no,hideurlbar=yes,zoom=no";
const HOSTED_AUTH_PENDING_ACTION_SESSION_KEY = "trebblePendingHostedAuthAction";
const HOSTED_AUTH_PENDING_ACTION_TTL_IN_MILLISECONDS = 30 * 60 * 1000;
const FORCE_STORED_BEARER_SESSION_KEY = "trebbleForceStoredBearerSession";

const ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING = false;

const TrebbleClientAPIModel = Backbone.Model.extend({
  default: {},

  initialize: function () {
    this._loginSuccessfull = false;
    this._loginDone = false;
    this._loginSuccessfullWithToken = false;
    this._loginDoneWithToken = false;
    this.username = null;
    this.password = null;
  },

  _getApiBaseUrl: function () {
    if (_apiBaseOverrideHasProtocol) {
      return _resolvedApiBaseUrl;
    }
    return window.trebble.usedProtocolPrefix + trebbleServerUrl;
  },

  _isBrowserHostedAuthEnvironment: function () {
    return Utils.getInstance().isBrowserHostedAuthEnvironment();
  },

  _isLocalhostHostname: function (hostname) {
    return isLocalhostHostname(hostname);
  },

  _sanitizeHostedBrowserReturnUrl: function (returnUrl, fallbackUrl) {
    const resolvedFallbackUrl = fallbackUrl || this._getHostedBrowserAppBaseUrl();
    const trimmedReturnUrl = typeof returnUrl === "string" ? returnUrl.trim() : "";

    if (!trimmedReturnUrl || trimmedReturnUrl === "undefined" || trimmedReturnUrl === "null") {
      return resolvedFallbackUrl;
    }

    if (trimmedReturnUrl.indexOf("#") === 0) {
      const fragmentValue = trimmedReturnUrl.substring(1).trim();

      if (!fragmentValue || fragmentValue === "undefined" || fragmentValue === "null") {
        return resolvedFallbackUrl;
      }

      if (/^https?:\/\//i.test(fragmentValue)) {
        try {
          const fragmentUrl = new URL(fragmentValue);
          if (
            this._isLocalhostHostname(window.location.hostname) &&
            this._isLocalhostHostname(fragmentUrl.hostname) &&
            fragmentUrl.origin !== window.location.origin
          ) {
            return resolvedFallbackUrl + "#" + fragmentUrl.pathname.replace(/^\/+/, "") + fragmentUrl.search + fragmentUrl.hash;
          }
        } catch (error) {
          console.error("Failed sanitizing hosted browser hash return URL. Error:" + error);
          return resolvedFallbackUrl;
        }
      }

      return resolvedFallbackUrl + trimmedReturnUrl;
    }

    if (trimmedReturnUrl.indexOf("/") === 0) {
      return window.location.origin + trimmedReturnUrl;
    }

    try {
      const parsedReturnUrl = new URL(trimmedReturnUrl);

      if (
        this._isLocalhostHostname(window.location.hostname) &&
        this._isLocalhostHostname(parsedReturnUrl.hostname) &&
        parsedReturnUrl.origin !== window.location.origin
      ) {
        parsedReturnUrl.protocol = window.location.protocol;
        parsedReturnUrl.host = window.location.host;
      }

      return parsedReturnUrl.toString();
    } catch (error) {
      return resolvedFallbackUrl;
    }
  },

  _shouldUseCookieBackedBrowserSession: function (tokenInfo) {
    const resolvedTokenInfo = tokenInfo || LocalStorageHelper.getInstance().retrieveAuthentificationToken();
    return this._isBrowserHostedAuthEnvironment() && LocalStorageHelper.getInstance().isCookieBackedWebSessionTokenInfo(resolvedTokenInfo);
  },

  _shouldSkipStoredAuthTokenForApiPath: function (apiNameOrUrl) {
    const resolvedApiPath = typeof apiNameOrUrl === "string" ? apiNameOrUrl.replace(/^https?:\/\/[^/]+\/?/, "") : "";

    return (
      resolvedApiPath === "auth/session" ||
      resolvedApiPath === "auth/logout" ||
      resolvedApiPath === "auth/password/login" ||
      resolvedApiPath === "auth/password/signup" ||
      resolvedApiPath === "auth/password-reset/request" ||
      resolvedApiPath === "auth/password-reset/complete" ||
      resolvedApiPath === "auth/magic/start" ||
      resolvedApiPath === "auth/magic/verify" ||
      resolvedApiPath === "auth/verification/verify" ||
      resolvedApiPath === "loginWithFacebookToken" ||
      resolvedApiPath === "loginWithAppleToken" ||
      resolvedApiPath === "loginWithGoogleToken"
    );
  },

  _buildServerAjaxOptions: function (method, apiNameOrUrl, params, options) {
    const resolvedOptions = options || {};
    const shouldSkipStoredAuthToken =
      !!resolvedOptions.skipStoredAuthToken || this._shouldSkipStoredAuthTokenForApiPath(apiNameOrUrl);
    const sanitizedGlobalHeaders = Object.assign({}, ($.ajaxSettings && $.ajaxSettings.headers) || {});
    delete sanitizedGlobalHeaders.Authorization;
    delete sanitizedGlobalHeaders.authorization;
    const ajaxOptions = {
      type: method,
      url: apiNameOrUrl.indexOf("http://") === 0 || apiNameOrUrl.indexOf("https://") === 0 ? apiNameOrUrl : this._getApiBaseUrl() + "/" + apiNameOrUrl,
      data: params,
      headers: sanitizedGlobalHeaders,
    };

    if (this._isBrowserHostedAuthEnvironment()) {
      ajaxOptions.xhrFields = {
        withCredentials: true,
      };
      ajaxOptions.crossDomain = true;
    }

    if (resolvedOptions.async === false) {
      ajaxOptions.async = false;
    }

    if (!shouldSkipStoredAuthToken) {
      const tokenInfo = LocalStorageHelper.getInstance().retrieveAuthentificationToken();
      if (tokenInfo && tokenInfo.token && !this._shouldUseCookieBackedBrowserSession(tokenInfo)) {
        ajaxOptions.headers = Object.assign({}, ajaxOptions.headers, {
          Authorization: "Bearer " + tokenInfo.token,
        });
      }
    }

    if (resolvedOptions.headers) {
      ajaxOptions.headers = Object.assign({}, ajaxOptions.headers || {}, resolvedOptions.headers);
    }

    return ajaxOptions;
  },

  _applyAuthenticatedAjaxContext: function (tokenInfo) {
    const sanitizedGlobalHeaders = Object.assign({}, ($.ajaxSettings && $.ajaxSettings.headers) || {});
    delete sanitizedGlobalHeaders.Authorization;
    delete sanitizedGlobalHeaders.authorization;
    const ajaxSetupOptions = {
      headers: sanitizedGlobalHeaders,
    };

    if (this._isBrowserHostedAuthEnvironment()) {
      ajaxSetupOptions.xhrFields = {
        withCredentials: true,
      };
      ajaxSetupOptions.crossDomain = true;
    }

    if (tokenInfo && tokenInfo.token && !this._shouldUseCookieBackedBrowserSession(tokenInfo)) {
      ajaxSetupOptions.headers.Authorization = "Bearer " + tokenInfo.token;
    }

    $.ajaxSetup(ajaxSetupOptions);
  },

  _handleAuthenticatedTokenInfo: function (tokenInfo) {
    if (!tokenInfo) {
      return null;
    }

    const resolvedUserInfo = tokenInfo && tokenInfo.userInfo ? tokenInfo.userInfo : null;
    const cachedUserInfo = LocalStorageHelper.getInstance().getUserInfo();
    if (
      resolvedUserInfo &&
      !resolvedUserInfo.username &&
      cachedUserInfo &&
      cachedUserInfo._id === resolvedUserInfo._id &&
      cachedUserInfo.username
    ) {
      resolvedUserInfo.username = cachedUserInfo.username;
    }

    if (!tokenInfo.authProvider && (tokenInfo.refreshToken || tokenInfo.sessionTransport === "cookie")) {
      tokenInfo.authProvider = "workos";
    }

    LocalStorageHelper.getInstance().setUsingNewLoginModule();
    LocalStorageHelper.getInstance().saveAuthentificationToken(tokenInfo);
    const userInfo = tokenInfo && tokenInfo.userInfo ? tokenInfo.userInfo : {};
    if (userInfo && userInfo._id) {
      window.saveUserIdForTracking(
        userInfo._id,
        userInfo.email,
        userInfo.lastName,
        userInfo.firstName,
        userInfo.creationDate,
        userInfo,
      );
    }
    this._applyAuthenticatedAjaxContext(tokenInfo);
    return tokenInfo;
  },

  _hydrateAuthenticatedUserInfoIfUsernameMissing: function (tokenInfo) {
    const userInfo = tokenInfo && tokenInfo.userInfo ? tokenInfo.userInfo : null;
    if (!userInfo || userInfo.temporary || userInfo.username) {
      return RSVP.Promise.resolve(tokenInfo);
    }

    if (this._missingUsernameHydrationPromise) {
      return this._missingUsernameHydrationPromise;
    }

    this._missingUsernameHydrationPromise = this._makeApiServerCall(
      "getCompleteUserInfo",
      {},
      "Get my complete user info",
      true,
    )
      .then(function (completeUserInfo) {
        if (completeUserInfo && completeUserInfo.userInfo && completeUserInfo.userInfo.username) {
          LocalStorageHelper.getInstance().updateUserInfo(completeUserInfo.userInfo);
          const refreshedTokenInfo = LocalStorageHelper.getInstance().retrieveAuthentificationToken();
          return refreshedTokenInfo || tokenInfo;
        }

        return tokenInfo;
      })
      .catch(function (error) {
        console.error("Failed hydrating authenticated user info after login. Error:" + error);
        return tokenInfo;
      })
      .finally(
        function () {
          this._missingUsernameHydrationPromise = null;
        }.bind(this),
      );

    return this._missingUsernameHydrationPromise;
  },

  _finalizeAuthenticatedTokenInfo: function (tokenInfo) {
    const normalizedTokenInfo = this._handleAuthenticatedTokenInfo(tokenInfo);
    return this._hydrateAuthenticatedUserInfoIfUsernameMissing(normalizedTokenInfo).then(function (resolvedTokenInfo) {
      return resolvedTokenInfo || normalizedTokenInfo;
    });
  },

  _buildWorkOSReturnUrl: function () {
    const hostedAppBaseUrl = this._getHostedBrowserAppBaseUrl();

    if (window.location.protocol === "http:" || window.location.protocol === "https:") {
      const currentHash = window.location.hash || "";

      if (currentHash && currentHash !== "#") {
        return this._sanitizeHostedBrowserReturnUrl(currentHash, hostedAppBaseUrl);
      }

      const appBaseUrl = window.getAppBaseUrl ? window.getAppBaseUrl() : "/";
      let currentRoutePath = window.location.pathname || "";

      if (appBaseUrl && currentRoutePath.indexOf(appBaseUrl) === 0) {
        currentRoutePath = currentRoutePath.substring(appBaseUrl.length);
      }

      currentRoutePath = currentRoutePath.replace(/^\/+/, "");
      if (currentRoutePath || window.location.search) {
        return this._sanitizeHostedBrowserReturnUrl("#" + currentRoutePath + (window.location.search || ""), hostedAppBaseUrl);
      }

      return hostedAppBaseUrl;
    }

    return window.location.href;
  },

  _getHostedBrowserLoginReturnUrl: function () {
    return this._buildWorkOSReturnUrl();
  },

  _getHostedBrowserAppBaseUrl: function () {
    if (window.location.protocol == "http:" || window.location.protocol == "https:") {
      return location.origin + window.getAppBaseUrl();
    }

    return this._buildWorkOSReturnUrl();
  },

  _getHostedBrowserSignupReturnUrl: function () {
    const defaultSignupReturnUrl = this._getHostedBrowserAppBaseUrl() + "#afterSignup";
    if (window.trebble && window.trebble.signupSuccessRedirectUrl) {
      return this._sanitizeHostedBrowserReturnUrl(window.trebble.signupSuccessRedirectUrl, defaultSignupReturnUrl);
    }

    return defaultSignupReturnUrl;
  },

  _buildHostedBrowserSignupContext: function (signupContext) {
    if (!signupContext || typeof signupContext !== "object") {
      return null;
    }

    const normalizedSignupContext = {};
    const derivedSignupIntent =
      signupContext.signupIntent ||
      (signupContext.context && typeof signupContext.context === "object" ? signupContext.context.signupIntent : null);
    [
      "accessCode",
      "profileType",
      "signupIntent",
      "trebbleName",
      "trebbleDescription",
      "trebbleCategoryId",
      "trebbleCityId",
      "trebbleCustomUrl",
      "trebbleTimezone",
      "trebbleLanguage",
      "rssFeedUrlContentSource",
    ].forEach(function (fieldName) {
      const value = fieldName === "signupIntent" ? derivedSignupIntent : signupContext[fieldName];
      if (value !== undefined && value !== null && value !== "") {
        normalizedSignupContext[fieldName] = value;
      }
    });

    if (signupContext.context && typeof signupContext.context === "object") {
      normalizedSignupContext.context = signupContext.context;
    }

    return Object.keys(normalizedSignupContext).length ? normalizedSignupContext : null;
  },

  _buildHostedBrowserAuthUrl: function (authPath, options) {
    const resolvedOptions = options || {};
    const authUrl = new URL(this._getApiBaseUrl() + "/auth/" + authPath);
    const defaultReturnToUrl =
      authPath === "signup" ? this._getHostedBrowserSignupReturnUrl() : this._buildWorkOSReturnUrl();
    const sanitizedReturnToUrl = this._sanitizeHostedBrowserReturnUrl(resolvedOptions.returnToUrl || defaultReturnToUrl, defaultReturnToUrl);

    authUrl.searchParams.set("returnTo", sanitizedReturnToUrl);

    if (this._isLocalhostHostname(window.location.hostname)) {
      authUrl.searchParams.set("redirect_uri", this._getApiBaseUrl() + "/auth/callback");
    }

    if (resolvedOptions.provider) {
      authUrl.searchParams.set("provider", resolvedOptions.provider);
    }

    if (resolvedOptions.loginHint) {
      authUrl.searchParams.set("loginHint", resolvedOptions.loginHint);
    }

    if (resolvedOptions.domainHint) {
      authUrl.searchParams.set("domainHint", resolvedOptions.domainHint);
    }

    const signupContext = this._buildHostedBrowserSignupContext(resolvedOptions.signupContext);
    if (signupContext) {
      Object.keys(signupContext).forEach(function (fieldName) {
        if (fieldName === "context") {
          authUrl.searchParams.set("context", JSON.stringify(signupContext.context));
          return;
        }

        authUrl.searchParams.set(fieldName, signupContext[fieldName]);
      });
    }

    return authUrl.toString();
  },

  _startHostedBrowserAuthRedirect: function (authPath, returnToUrl, options) {
    const resolvedOptions = Object.assign({}, options || {});
    if (returnToUrl) {
      resolvedOptions.returnToUrl = returnToUrl;
    }

    if (resolvedOptions.pendingAction) {
      this._persistPendingHostedAuthAction(resolvedOptions.pendingAction);
    }

    const authUrl = this._buildHostedBrowserAuthUrl(authPath, resolvedOptions);
    document.location.assign(authUrl);
    return new RSVP.Promise(function () {});
  },

  _shouldUseHostedBrowserAuthPopup: function (hostedAuthOptions) {
    return !!(this._isBrowserHostedAuthEnvironment() && hostedAuthOptions && hostedAuthOptions.usePopup);
  },

  _normalizePendingHostedAuthAction: function (pendingAction) {
    if (!pendingAction || typeof pendingAction !== "object") {
      return null;
    }

    const resolvedActionType = typeof pendingAction.type === "string" ? pendingAction.type.trim() : "";
    if (!resolvedActionType) {
      return null;
    }

    const normalizedPendingAction = {
      type: resolvedActionType,
      createdAt:
        typeof pendingAction.createdAt === "number" && pendingAction.createdAt > 0
          ? pendingAction.createdAt
          : new Date().getTime(),
    };

    if (typeof pendingAction.trebbleId === "string" && pendingAction.trebbleId.trim()) {
      normalizedPendingAction.trebbleId = pendingAction.trebbleId.trim();
    }

    if (typeof pendingAction.journeyRadioId === "string" && pendingAction.journeyRadioId.trim()) {
      normalizedPendingAction.journeyRadioId = pendingAction.journeyRadioId.trim();
    }

    if (typeof pendingAction.showThankYouMessage === "boolean") {
      normalizedPendingAction.showThankYouMessage = pendingAction.showThankYouMessage;
    }

    if (typeof pendingAction.usePopup === "boolean") {
      normalizedPendingAction.usePopup = pendingAction.usePopup;
    }

    return normalizedPendingAction;
  },

  clearPendingHostedAuthAction: function () {
    try {
      window.sessionStorage.removeItem(HOSTED_AUTH_PENDING_ACTION_SESSION_KEY);
    } catch (error) {
      console.error("Failed clearing pending hosted auth action. Error:" + error);
    }
  },

  peekPendingHostedAuthAction: function () {
    try {
      const rawPendingHostedAuthAction = window.sessionStorage.getItem(HOSTED_AUTH_PENDING_ACTION_SESSION_KEY);
      if (!rawPendingHostedAuthAction) {
        return null;
      }

      const parsedPendingHostedAuthAction = JSON.parse(rawPendingHostedAuthAction);
      const normalizedPendingHostedAuthAction = this._normalizePendingHostedAuthAction(parsedPendingHostedAuthAction);
      const pendingActionCreatedAt = normalizedPendingHostedAuthAction ? normalizedPendingHostedAuthAction.createdAt : 0;
      const isPendingActionExpired =
        !!pendingActionCreatedAt &&
        new Date().getTime() - pendingActionCreatedAt > HOSTED_AUTH_PENDING_ACTION_TTL_IN_MILLISECONDS;

      if (!normalizedPendingHostedAuthAction || isPendingActionExpired) {
        this.clearPendingHostedAuthAction();
        return null;
      }

      return normalizedPendingHostedAuthAction;
    } catch (error) {
      console.error("Failed reading pending hosted auth action. Error:" + error);
      this.clearPendingHostedAuthAction();
      return null;
    }
  },

  consumePendingHostedAuthAction: function () {
    const pendingHostedAuthAction = this.peekPendingHostedAuthAction();
    if (pendingHostedAuthAction) {
      this.clearPendingHostedAuthAction();
    }

    return pendingHostedAuthAction;
  },

  _persistPendingHostedAuthAction: function (pendingAction) {
    const normalizedPendingHostedAuthAction = this._normalizePendingHostedAuthAction(pendingAction);
    if (!normalizedPendingHostedAuthAction) {
      this.clearPendingHostedAuthAction();
      return null;
    }

    try {
      window.sessionStorage.setItem(
        HOSTED_AUTH_PENDING_ACTION_SESSION_KEY,
        JSON.stringify(normalizedPendingHostedAuthAction),
      );
    } catch (error) {
      console.error("Failed saving pending hosted auth action. Error:" + error);
    }

    return normalizedPendingHostedAuthAction;
  },

  _rejectUnsupportedHostedBrowserProvider: function (providerName) {
    return RSVP.Promise.reject(
      providerName === "Facebook" ? WORKOS_UNSUPPORTED_FACEBOOK_ERROR : providerName + " authentication is not available right now.",
    );
  },

  _isCordovaHostedAuthEnvironment: function () {
    return !!window.waitForCordovaToLoad;
  },

  _usesHostedWorkOSSocialAuth: function () {
    return this._isBrowserHostedAuthEnvironment() || this._isCordovaHostedAuthEnvironment();
  },

  _getWorkOSStudioClientId: function () {
    if (window.trebble && window.trebble.workosStudioClientId) {
      return window.trebble.workosStudioClientId;
    }

    return DEFAULT_WORKOS_STUDIO_CLIENT_ID;
  },

  _getWorkOSStudioRedirectUri: function () {
    if (window.trebble && window.trebble.workosStudioRedirectUri) {
      return window.trebble.workosStudioRedirectUri;
    }

    return DEFAULT_WORKOS_STUDIO_REDIRECT_URI;
  },

  _generateSecureRandomString: function (length) {
    const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
    const resolvedLength = length || 64;

    if (window.crypto && window.crypto.getRandomValues) {
      const randomBytes = new Uint8Array(resolvedLength);
      window.crypto.getRandomValues(randomBytes);
      return Array.from(randomBytes)
        .map(function (value) {
          return alphabet.charAt(value % alphabet.length);
        })
        .join("");
    }

    let randomString = "";
    while (randomString.length < resolvedLength) {
      randomString += Math.random().toString(36).substring(2);
    }

    return randomString.substring(0, resolvedLength);
  },

  _encodeBytesAsBase64Url: function (byteArray) {
    let binaryString = "";
    for (let index = 0; index < byteArray.length; index++) {
      binaryString += String.fromCharCode(byteArray[index]);
    }

    return btoa(binaryString).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
  },

  _createPKCECodeChallenge: function (codeVerifier) {
    if (!window.crypto || !window.crypto.subtle || typeof TextEncoder === "undefined") {
      return RSVP.Promise.reject(
        "This device does not support secure hosted sign-in yet. Please update the app or use email and password for now.",
      );
    }

    const encodedVerifier = new TextEncoder().encode(codeVerifier);
    return RSVP.Promise.resolve(window.crypto.subtle.digest("SHA-256", encodedVerifier)).then(
      function (digestBuffer) {
        return this._encodeBytesAsBase64Url(new Uint8Array(digestBuffer));
      }.bind(this),
    );
  },

  /**
   * Resolve the active workspaceId so callers don't have to thread it through
   * every write path. Returns null when the user is in personal space.
   * Backend will still validate access via WorkspaceAccessHelper.
   */
  _resolveActiveWorkspaceId: function () {
    try {
      return LocalStorageHelper.getInstance().getCurrentWorkspaceId() || null;
    } catch (err) {
      return null;
    }
  },

  _resolveActiveWorkspaceIdForUpload: function () {
    return this._resolveActiveWorkspaceId();
  },

  _resolveWorkspaceIdForScopedMutation: function (workspaceId) {
    return workspaceId === undefined ? this._resolveActiveWorkspaceId() : workspaceId;
  },

  _appendWorkspaceIdParam: function (params, workspaceId) {
    const requestParams = Object.assign({}, params || {});
    if (workspaceId !== undefined && workspaceId !== null) {
      requestParams.workspaceId = workspaceId;
    }
    return requestParams;
  },

  _buildStudioHostedAuthUrl: function (authPath, options) {
    const resolvedOptions = options || {};
    const authUrl = new URL(this._getApiBaseUrl() + "/api/studio/auth/" + authPath);
    authUrl.searchParams.set("client_id", this._getWorkOSStudioClientId());
    authUrl.searchParams.set("redirect_uri", this._getWorkOSStudioRedirectUri());
    authUrl.searchParams.set("code_challenge", resolvedOptions.codeChallenge);

    if (resolvedOptions.state) {
      authUrl.searchParams.set("state", resolvedOptions.state);
    }

    if (resolvedOptions.provider) {
      authUrl.searchParams.set("provider", resolvedOptions.provider);
    }

    if (resolvedOptions.loginHint) {
      authUrl.searchParams.set("login_hint", resolvedOptions.loginHint);
    }

    if (resolvedOptions.domainHint) {
      authUrl.searchParams.set("domain_hint", resolvedOptions.domainHint);
    }

    return authUrl.toString();
  },

  _isStudioHostedAuthCallbackUrl: function (urlValue) {
    try {
      const callbackUrl = new URL(this._getWorkOSStudioRedirectUri());
      const loadedUrl = new URL(urlValue);
      return loadedUrl.origin === callbackUrl.origin && loadedUrl.pathname === callbackUrl.pathname;
    } catch (error) {
      return false;
    }
  },

  _extractAuthParamsFromUrlValue: function (urlValue) {
    const extractedParams = {};

    try {
      const parsedUrl = new URL(urlValue);
      parsedUrl.searchParams.forEach(function (value, key) {
        extractedParams[key] = value;
      });

      if (parsedUrl.hash && parsedUrl.hash.length > 1) {
        const hashParams = new URLSearchParams(parsedUrl.hash.substring(1));
        hashParams.forEach(function (value, key) {
          if (extractedParams[key] === undefined) {
            extractedParams[key] = value;
          }
        });
      }
    } catch (error) {
      return extractedParams;
    }

    return extractedParams;
  },

  _hasRefreshableWorkOSAccessToken: function (tokenInfo) {
    const resolvedTokenInfo = tokenInfo || LocalStorageHelper.getInstance().retrieveAuthentificationToken();
    return !!(
      this._isCordovaHostedAuthEnvironment() &&
      resolvedTokenInfo &&
      resolvedTokenInfo.refreshToken &&
      resolvedTokenInfo.userInfo
    );
  },

  _isRefreshableAccessTokenExpiredOrExpiringSoon: function (tokenInfo, leewayInMilliseconds) {
    const resolvedTokenInfo = tokenInfo || LocalStorageHelper.getInstance().retrieveAuthentificationToken();
    if (!resolvedTokenInfo || !resolvedTokenInfo.tokenExpirationTimestamp) {
      return false;
    }

    const refreshLeeway = leewayInMilliseconds === undefined ? WORKOS_MOBILE_REFRESH_LEEWAY_IN_MILLISECONDS : leewayInMilliseconds;
    return new Date().getTime() + refreshLeeway >= resolvedTokenInfo.tokenExpirationTimestamp;
  },

  _isImmediatelyUsableAccessToken: function (tokenInfo) {
    const resolvedTokenInfo = tokenInfo || LocalStorageHelper.getInstance().retrieveAuthentificationToken();
    if (!resolvedTokenInfo || !resolvedTokenInfo.token) {
      return false;
    }

    if (!resolvedTokenInfo.tokenExpirationTimestamp) {
      return true;
    }

    return new Date().getTime() < resolvedTokenInfo.tokenExpirationTimestamp;
  },

  _normalizeStudioTokenInfoResponse: function (response, fallbackTokenInfo) {
    const existingTokenInfo = fallbackTokenInfo || {};
    const tokenInfo = Object.assign({}, response && response.tokenInfo ? response.tokenInfo : {});
    const now = new Date().getTime();

    if (!tokenInfo.token && response && response.access_token) {
      tokenInfo.token = response.access_token;
    }

    if (!tokenInfo.refreshToken) {
      if (response && response.refresh_token) {
        tokenInfo.refreshToken = response.refresh_token;
      } else if (existingTokenInfo.refreshToken) {
        tokenInfo.refreshToken = existingTokenInfo.refreshToken;
      }
    }

    if (!tokenInfo.userInfo && existingTokenInfo.userInfo) {
      tokenInfo.userInfo = existingTokenInfo.userInfo;
    }

    if (!tokenInfo.tokenGenerationTimestamp) {
      tokenInfo.tokenGenerationTimestamp = now;
    }

    if (!tokenInfo.tokenExpirationTimestamp && response && response.expires_in) {
      tokenInfo.tokenExpirationTimestamp = now + response.expires_in * 1000;
    }

    if (!tokenInfo.tokenTTLInSeconds && response && response.expires_in) {
      tokenInfo.tokenTTLInSeconds = response.expires_in;
    }

    if (!tokenInfo.authProvider) {
      tokenInfo.authProvider = "workos";
    }

    return tokenInfo;
  },

  _shouldClearTokenAfterRefreshFailure: function (error) {
    if (!error) {
      return false;
    }

    if (error.status == 400 || error.status == "400" || error.status == 401 || error.status == "401") {
      return true;
    }

    return !!(
      error.responseJSON &&
      (error.responseJSON.error === "invalid_grant" || error.responseJSON.error_description === "invalid_grant")
    );
  },

  _exchangeStudioAuthorizationCode: function (code, pendingFlow) {
    const apiSelf = this;
    const params = {
      grant_type: "authorization_code",
      code: code,
      redirect_uri: this._getWorkOSStudioRedirectUri(),
      code_verifier: pendingFlow.codeVerifier,
      client_id: this._getWorkOSStudioClientId(),
      environment: window.getAppEnvironment(),
    };

    if (pendingFlow && pendingFlow.signupContext) {
      params.signupContext = JSON.stringify(pendingFlow.signupContext);
    }

    return new RSVP.Promise(function (resolve, reject) {
      $.ajax(apiSelf._buildServerAjaxOptions("POST", "api/studio/auth/token", params, { skipStoredAuthToken: true }))
        .done(function (response) {
          try {
            const normalizedTokenInfo = apiSelf._normalizeStudioTokenInfoResponse(response);
            apiSelf._handleAuthenticatedTokenInfo(normalizedTokenInfo);
            resolve({
              tokenInfo: normalizedTokenInfo,
              userCreated: !!(response && response.userCreated),
            });
          } catch (error) {
            reject(error);
          }
        })
        .fail(function (error) {
          reject(error);
        });
    });
  },

  _beginMobileHostedAuthFlow: function (authPath, options) {
    if (!this._isCordovaHostedAuthEnvironment()) {
      return RSVP.Promise.reject("Hosted mobile authentication is only available in the Trebble app.");
    }

    if (this._pendingMobileHostedAuthPromise) {
      return this._pendingMobileHostedAuthPromise;
    }

    const pendingFlow = Object.assign({}, options || {});
    pendingFlow.codeVerifier = this._generateSecureRandomString(64);
    pendingFlow.state = this._generateSecureRandomString(48);

    this._pendingMobileHostedAuthPromise = this._createPKCECodeChallenge(pendingFlow.codeVerifier)
      .then(
        function (codeChallenge) {
          pendingFlow.codeChallenge = codeChallenge;
          this._pendingMobileHostedAuthContext = pendingFlow;

          return new RSVP.Promise(
            function (resolve, reject) {
              if (!window.cordova || !window.cordova.InAppBrowser || !window.cordova.InAppBrowser.open) {
                reject("Secure hosted sign-in is not available because the in-app browser plugin is missing.");
                return;
              }

              const authUrl = this._buildStudioHostedAuthUrl(authPath, pendingFlow);
              const authWindow = window.cordova.InAppBrowser.open(
                authUrl,
                "_blank",
                WORKOS_MOBILE_IN_APP_BROWSER_FEATURES,
              );

              if (!authWindow) {
                reject("We could not open the secure sign-in window. Please try again.");
                return;
              }

              let authFlowCompleted = false;
              let authExchangeInProgress = false;
              const clearAuthWindowListeners = function () {
                authWindow.removeEventListener("loadstart", onAuthWindowLoadStart);
                authWindow.removeEventListener("loaderror", onAuthWindowLoadError);
                authWindow.removeEventListener("exit", onAuthWindowExit);
              };

              const finalizeWithError = function (error) {
                if (authFlowCompleted) {
                  return;
                }

                authFlowCompleted = true;
                clearAuthWindowListeners();
                try {
                  authWindow.close();
                } catch (closeError) {
                  console.warn("Failed closing hosted auth window after error:", closeError);
                }
                reject(error);
              };

              const finalizeWithSuccess = function (result) {
                if (authFlowCompleted) {
                  return;
                }

                authFlowCompleted = true;
                clearAuthWindowListeners();
                try {
                  authWindow.close();
                } catch (closeError) {
                  console.warn("Failed closing hosted auth window after success:", closeError);
                }
                resolve(result);
              };

              const onAuthWindowLoadStart = function (event) {
                if (!event || !event.url || !this._isStudioHostedAuthCallbackUrl(event.url)) {
                  return;
                }

                const params = this._extractAuthParamsFromUrlValue(event.url);
                if (params.state && params.state !== pendingFlow.state) {
                  finalizeWithError("We could not verify the secure sign-in response. Please try again.");
                  return;
                }

                if (params.error || params.authError) {
                  finalizeWithError(
                    params.error_description ||
                      params.errorDescription ||
                      params.authError ||
                      "We could not complete the hosted sign-in flow.",
                  );
                  return;
                }

                if (!params.code) {
                  finalizeWithError("The secure sign-in flow finished without an authorization code.");
                  return;
                }

                if (authExchangeInProgress) {
                  return;
                }

                authExchangeInProgress = true;
                this._exchangeStudioAuthorizationCode(params.code, pendingFlow)
                  .then(finalizeWithSuccess)
                  .catch(finalizeWithError);
              }.bind(this);

              const onAuthWindowLoadError = function (event) {
                if (event && event.url && this._isStudioHostedAuthCallbackUrl(event.url)) {
                  return;
                }

                if (!authFlowCompleted) {
                  finalizeWithError(
                    event && event.message
                      ? event.message
                      : "The secure sign-in window could not finish loading.",
                  );
                }
              }.bind(this);

              const onAuthWindowExit = function () {
                if (authExchangeInProgress) {
                  return;
                }
                if (!authFlowCompleted) {
                  finalizeWithError(window.getI18n(ti18n, "PLEASE_LOGIN"));
                }
              };

              authWindow.addEventListener("loadstart", onAuthWindowLoadStart);
              authWindow.addEventListener("loaderror", onAuthWindowLoadError);
              authWindow.addEventListener("exit", onAuthWindowExit);
            }.bind(this),
          );
        }.bind(this),
      )
      .finally(
        function () {
          this._pendingMobileHostedAuthPromise = null;
          this._pendingMobileHostedAuthContext = null;
        }.bind(this),
      );

    return this._pendingMobileHostedAuthPromise;
  },

  refreshStoredMobileSessionIfNeeded: function (forceRefresh) {
    const tokenInfo = LocalStorageHelper.getInstance().retrieveAuthentificationToken();
    if (!this._hasRefreshableWorkOSAccessToken(tokenInfo)) {
      return RSVP.Promise.resolve(tokenInfo);
    }

    if (!forceRefresh && !this._isRefreshableAccessTokenExpiredOrExpiringSoon(tokenInfo)) {
      return RSVP.Promise.resolve(tokenInfo);
    }

    if (this._workosRefreshPromise) {
      return this._workosRefreshPromise;
    }

    const apiSelf = this;
    const canUseCurrentAccessToken = !!(
      tokenInfo &&
      tokenInfo.token &&
      tokenInfo.tokenExpirationTimestamp &&
      new Date().getTime() < tokenInfo.tokenExpirationTimestamp
    );
    const params = {
      grant_type: "refresh_token",
      refresh_token: tokenInfo.refreshToken,
      environment: window.getAppEnvironment(),
    };

    this._workosRefreshPromise = new RSVP.Promise(function (resolve, reject) {
      $.ajax(apiSelf._buildServerAjaxOptions("POST", "api/studio/auth/refresh", params, { skipStoredAuthToken: true }))
        .done(function (response) {
          try {
            const refreshedTokenInfo = apiSelf._normalizeStudioTokenInfoResponse(response, tokenInfo);
            apiSelf._handleAuthenticatedTokenInfo(refreshedTokenInfo);
            resolve(refreshedTokenInfo);
          } catch (error) {
            reject(error);
          }
        })
        .fail(function (error) {
          if (apiSelf._shouldClearTokenAfterRefreshFailure(error)) {
            LocalStorageHelper.getInstance().logoutUserAndClearInfo();
            apiSelf._applyAuthenticatedAjaxContext(null);
          }

          if (!forceRefresh && canUseCurrentAccessToken && !apiSelf._shouldClearTokenAfterRefreshFailure(error)) {
            resolve(tokenInfo);
            return;
          }

          reject(error);
        });
    }).finally(
      function () {
        apiSelf._workosRefreshPromise = null;
      }.bind(this),
    );

    return this._workosRefreshPromise;
  },

  _executeServerAjaxRequest: function (method, apiNameOrUrl, params, options) {
    const apiSelf = this;
    const requestOptions = Object.assign({}, options || {});
    const executeRequest = function () {
      return new RSVP.Promise(function (resolve, reject) {
        $.ajax(apiSelf._buildServerAjaxOptions(method, apiNameOrUrl, params, requestOptions))
          .done(resolve)
          .fail(reject);
      });
    };

    // Skip the preflight refresh for endpoints that intentionally omit the
    // stored auth token (login / magic-verify / signup / password-reset /
    // social-login / logout — see _shouldSkipStoredAuthTokenForApiPath).
    // Without this guard, a Cordova session with an expired or revoked
    // WorkOS refresh token would attempt the refresh, fail, and never reach
    // the actual login request — locking the user out instead of letting
    // the new login replace the stale session.
    const shouldRefreshBeforeRequest =
      !requestOptions.skipStoredAuthToken &&
      !requestOptions.skipAuthRefresh &&
      !this._shouldSkipStoredAuthTokenForApiPath(apiNameOrUrl) &&
      this._hasRefreshableWorkOSAccessToken();

    const refreshPromise = shouldRefreshBeforeRequest
      ? this.refreshStoredMobileSessionIfNeeded(false)
      : RSVP.Promise.resolve(LocalStorageHelper.getInstance().retrieveAuthentificationToken());

    return refreshPromise.then(executeRequest).catch(
      function (error) {
        if (
          shouldRefreshBeforeRequest &&
          !requestOptions.hasRetriedAfterRefresh &&
          error &&
          (error.status == 401 || error.status == "401")
        ) {
          const retryRequestOptions = Object.assign({}, requestOptions, {
            hasRetriedAfterRefresh: true,
          });
          return apiSelf.refreshStoredMobileSessionIfNeeded(true).then(function () {
            return apiSelf._executeServerAjaxRequest(method, apiNameOrUrl, params, retryRequestOptions);
          });
        }

        throw error;
      },
    );
  },

  bootstrapWebSession: function (forceRefresh) {
    if (!this._isBrowserHostedAuthEnvironment()) {
      return RSVP.Promise.resolve(LocalStorageHelper.getInstance().retrieveAuthentificationToken());
    }

    const previousTokenInfo = LocalStorageHelper.getInstance().retrieveAuthentificationToken();
    const previousNonCookieTokenInfo =
      previousTokenInfo && !LocalStorageHelper.getInstance().isCookieBackedWebSessionTokenInfo(previousTokenInfo)
        ? previousTokenInfo
        : null;
    const shouldUseStoredBearerSession = (function () {
      try {
        return isLocalhostHostname(window.location.hostname) &&
          window.localStorage &&
          window.localStorage.getItem(FORCE_STORED_BEARER_SESSION_KEY) === "true";
      } catch (error) {
        return false;
      }
    })();

    if (shouldUseStoredBearerSession && this._isImmediatelyUsableAccessToken(previousNonCookieTokenInfo)) {
      this._applyAuthenticatedAjaxContext(previousNonCookieTokenInfo);
      return RSVP.Promise.resolve(previousNonCookieTokenInfo);
    }

    if (this._webSessionBootstrapPromise) {
      if (!forceRefresh) {
        return this._webSessionBootstrapPromise;
      }
      return this._webSessionBootstrapPromise.then(
        function () {
          return this.bootstrapWebSession(true);
        }.bind(this),
        function () {
          return this.bootstrapWebSession(true);
        }.bind(this)
      );
    }

    const apiSelf = this;
    const params = {
      language: window.getAppUsedLanguage(),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      environment: window.getAppEnvironment(),
    };

    // Clear any legacy/global bearer header before bootstrapping the cookie-backed web session.
    // Browser auth should rely on the sealed WorkOS session cookie only.
    this._applyAuthenticatedAjaxContext(null);

    this._webSessionBootstrapPromise = new RSVP.Promise(function (resolve, reject) {
      $.ajax(apiSelf._buildServerAjaxOptions("POST", "auth/session", params, { skipStoredAuthToken: true }))
        .done(function (result) {
          apiSelf._getDefaultResponseHandler(result, resolve, reject, null, "Bootstrap WorkOS Web Session");
        })
        .fail(function (error) {
          // 401 → no active web session, continue with the legacy bearer-token path.
          // 404 → backend doesn't expose the cookie-backed session endpoint at all
          // 503 + "WorkOS auth is not configured" → local/dev backend without WorkOS
          //       (e.g. legacy on-prem deployments, local dev backends predating the
          //       WorkOS integration). Treat the same as 401 — there's no session to
          //       bootstrap, fall back to the stored bearer token. Without this,
          //       /_doLogin rejects, login flows hang, and HomeMenuPanelController
          //       silently clears workspaceContext on `getMyWorkspaces` failure.
          const responseText = error && typeof error.responseText === "string" ? error.responseText : "";
          const isWorkOSUnavailableInCurrentEnvironment =
            (error.status == 503 || error.status == "503") &&
            responseText.indexOf("WorkOS auth is not configured") !== -1;
          if (
            error.status == 401 || error.status == "401" ||
            error.status == 404 || error.status == "404" ||
            isWorkOSUnavailableInCurrentEnvironment
          ) {
            resolve(null);
            return;
          }
          apiSelf._getDefaultFailedResponseHandler(error, reject, null, "Bootstrap WorkOS Web Session");
        });
    })
      .then(function (tokenInfo) {
        if (tokenInfo) {
          tokenInfo.sessionTransport = "cookie";
          return apiSelf._finalizeAuthenticatedTokenInfo(tokenInfo);
        }

        if (LocalStorageHelper.getInstance().isCookieBackedWebSessionTokenInfo(previousTokenInfo)) {
          LocalStorageHelper.getInstance().logoutUserAndClearInfo();
          apiSelf._applyAuthenticatedAjaxContext(null);
          return null;
        }

        if (previousNonCookieTokenInfo && previousNonCookieTokenInfo.userInfo && previousNonCookieTokenInfo.userInfo.temporary) {
          LocalStorageHelper.getInstance().logoutUserAndClearInfo();
          apiSelf._applyAuthenticatedAjaxContext(null);
          return null;
        }

        if (!previousNonCookieTokenInfo || !previousNonCookieTokenInfo.userInfo || previousNonCookieTokenInfo.userInfo.temporary) {
          LocalStorageHelper.getInstance().ensureAnonymousBrowserSession();
        }

        if (apiSelf._isImmediatelyUsableAccessToken(previousNonCookieTokenInfo)) {
          apiSelf._applyAuthenticatedAjaxContext(previousNonCookieTokenInfo);
          // Safari can reject the cookie-backed web session while a freshly
          // returned bearer token is still valid in memory. Return that token
          // so protected-route checks do not immediately bounce the user back
          // to the login page.
          return previousNonCookieTokenInfo;
        }

        apiSelf._applyAuthenticatedAjaxContext(null);
        return null;
      })
      .catch(function (error) {
        apiSelf._applyAuthenticatedAjaxContext(previousNonCookieTokenInfo);
        throw error;
      })
      .finally(function () {
        apiSelf._webSessionBootstrapPromise = null;
      });

    return this._webSessionBootstrapPromise;
  },

  _buildStoredVisitorCredentials: function () {
    let visitorId = LocalStorageHelper.getInstance().getRandomUserIdForUser() || "";
    visitorId = visitorId.toLowerCase().replace(/[^a-z0-9_]/g, "");
    if (!visitorId) {
      visitorId = "anonymous_client_user_id_" + window.ID();
    }

    return {
      username: "visitor_v2_" + visitorId,
      password: "visitor_pw_" + visitorId + "_cocoBongo1",
    };
  },

  _shouldSkipLoginForAnonymousBrowserRead: function () {
    return this._isBrowserHostedAuthEnvironment() && !Utils.getInstance().hasAuthenticatedNonVisitorSession();
  },

  continueWithAnonymousBrowserSession: function () {
    if (!this._isBrowserHostedAuthEnvironment()) {
      return this.doLoginAsGuest();
    }

    const existingTokenInfo = LocalStorageHelper.getInstance().retrieveAuthentificationToken();
    if (existingTokenInfo && existingTokenInfo.userInfo && existingTokenInfo.userInfo.temporary) {
      LocalStorageHelper.getInstance().logoutUserAndClearInfo();
    } else {
      LocalStorageHelper.getInstance().ensureAnonymousBrowserSession();
    }

    this._applyAuthenticatedAjaxContext(null);
    return RSVP.Promise.resolve({
      anonymousSession: true,
      preserveCurrentRoute: true,
    });
  },

  logOutExecute: function (doNotReloadPage) {
    const apiSelf = this;
    const tokenInfo = LocalStorageHelper.getInstance().retrieveAuthentificationToken();
    const shouldUseHostedBrowserLogout = this._shouldUseCookieBackedBrowserSession(tokenInfo);
    const finalizeLocalLogout = function () {
      apiSelf.clearPendingHostedAuthAction();
      LocalStorageHelper.getInstance().logoutUserAndClearInfo();
      apiSelf._applyAuthenticatedAjaxContext(null);
      apiSelf._webSessionBootstrapPromise = null;
      if (navigator.splashscreen) {
        navigator.splashscreen.show();
      }
      window.clearUserIdForTracking();
    };
    const continueWithProviderLogout = function () {
      return window.trebble.helper.requirePromise(["models/helper/FacebookHelper"]).then(
        function (FacebookHelper) {
          return window.trebble.helper.requirePromise(["models/helper/GooglePlusHelper"]).then(
            function (GooglePlusHelper) {
              if (window.waitForCordovaToLoad) {
                FacebookHelper.getInstance().logout();
                GooglePlusHelper.getInstance().logout();
              }
              if (!doNotReloadPage) {
                document.body.style.display = "none";
                if (window.device && window.device.platform == "browser") {
                  const currentUrl = document.location.href;
                  if (currentUrl.indexOf("https://") == 0) {
                    document.location.href = currentUrl.substr(0, currentUrl.indexOf("/", "https://".length));
                  } else {
                    if (currentUrl.indexOf("http://") == 0) {
                      document.location.href = currentUrl.substr(0, currentUrl.indexOf("/", "http://".length));
                    } else {
                      if (window.waitForCordovaToLoad) {
                        window.location = window.location.href.substr(0, window.location.href.indexOf("#")); //remove hash
                      } else {
                        document.location.href = "https://web.trebble.fm";
                      }
                    }
                  }
                } else {
                  document.location.href = "trebbleLibrary140.html";
                  document.location.reload();
                }
              }
            }.bind(apiSelf),
          );
        }.bind(apiSelf),
      );
    };

    if (shouldUseHostedBrowserLogout) {
      return new RSVP.Promise(function (resolve) {
        $.ajax(apiSelf._buildServerAjaxOptions("POST", "auth/logout", {}, { skipStoredAuthToken: true }))
          .always(function () {
            finalizeLocalLogout();
            resolve();
          });
      }).then(function () {
        return continueWithProviderLogout();
      });
    }

    finalizeLocalLogout();
    return continueWithProviderLogout();
  },

  _getDefaultResponseHandler: function (response, resolve, reject, callback, operationName) {
    if (response && response.success) {
      window.log(operationName + " was made successfully to server");
      resolve(response.message);
      if (callback) {
        callback.onSuccess(response.message);
      }
    } else {
      let expectedError = this._buildExpectedErrorFromServerPayload ?
        this._buildExpectedErrorFromServerPayload(
          response,
          response && response.errorMessage ? response.errorMessage : null,
          null,
          operationName === "Login" ? "auth" : null,
        ) :
        null;
      if (!expectedError && this._buildExpectedErrorFromKnownUserFacingFailure) {
        expectedError = this._buildExpectedErrorFromKnownUserFacingFailure(
          response,
          response && response.errorMessage ? response.errorMessage : null,
          null,
          operationName === "Login" ? "auth" : null,
          operationName,
        );
      }
      const rejectionReason = expectedError || (response ? response.errorMessage : null);
      const shouldLogOutForMissingUser = !!(
        (expectedError && expectedError.i18nKey === "USER_NOT_FOUND") ||
        (
          response &&
          typeof(response.errorMessage) === "string" &&
          response.errorMessage.indexOf(window.getI18n(ti18n, "USER_NOT_FOUND")) != -1
        )
      );
      if (shouldLogOutForMissingUser) {
        this.logOutExecute(true);
      }
      if (response && response.errorMessage) {
        if (expectedError) {
          console.warn(expectedError.message);
        } else {
          console.error(response.errorMessage);
        }
      } else if (expectedError) {
        console.warn(expectedError.message);
      } else {
        console.error("Something went wrong when executing the  operation '" + operationName);
      }
      // Preserve the structured error envelope so components can branch on
      // errorCode / seatLimit / seatsUsed. Attach the message for legacy
      // callers that still stringify it. When the backend tagged the
      // response as an ExpectedError, prefer the ExpectedError instance
      // (so sendErrorToRaygun / RSVP global hook recognize it) but still
      // attach the structured envelope fields onto it.
      var rejectionError;
      if (expectedError) {
        rejectionError = expectedError;
        if (response) {
          if (response.errorCode != null && rejectionError.errorCode == null) {
            rejectionError.errorCode = response.errorCode;
          }
          if (response.errorMessage != null && rejectionError.errorMessage == null) {
            rejectionError.errorMessage = response.errorMessage;
          }
          if (response.seatLimit != null && rejectionError.seatLimit == null) {
            rejectionError.seatLimit = response.seatLimit;
          }
          if (response.seatsUsed != null && rejectionError.seatsUsed == null) {
            rejectionError.seatsUsed = response.seatsUsed;
          }
          if (rejectionError.response == null) {
            rejectionError.response = response;
          }
        }
      } else if (response && (response.errorCode || response.errorMessage)) {
        rejectionError = new Error(response.errorMessage || "Request failed");
        rejectionError.errorCode = response.errorCode || null;
        rejectionError.errorMessage = response.errorMessage || null;
        if (response.statusCode) rejectionError.statusCode = response.statusCode;
        if (response.seatLimit != null) rejectionError.seatLimit = response.seatLimit;
        if (response.seatsUsed != null) rejectionError.seatsUsed = response.seatsUsed;
        rejectionError.response = response;
        // Keep `.toString()` returning the message so existing string-key
        // callsites (alertErrorMessage, console.error) still display it.
        rejectionError.toString = function() { return this.errorMessage || this.message; };
      } else {
        rejectionError = response && response.errorMessage ? response.errorMessage : "Request failed";
      }
      reject(rejectionError);
      if (callback) {
        callback.onFailure(rejectionReason);
      }
    }
  },

  _buildExpectedErrorFromServerPayload: function (payload, fallbackMessage, fallbackStatusCode, fallbackClassification) {
    const responsePayload = payload && payload.responseJSON ? payload.responseJSON : payload;
    const responseError = responsePayload && responsePayload.error ? responsePayload.error : null;
    const payloadCandidates = [responseError, responsePayload].filter(Boolean);
    const looksLikeExpectedError = payloadCandidates.some(function (candidate) {
      return candidate &&
        (
          candidate.name === "ExpectedError" ||
          candidate.type === "ExpectedError" ||
          candidate.errorType === "ExpectedError" ||
          candidate.isExpectedError === true ||
          candidate.expectedError === true
        );
    });

    if (!looksLikeExpectedError) {
      return null;
    }

    const resolvedErrorCode = responseError && responseError.errorCode ?
      responseError.errorCode :
      (responsePayload && responsePayload.errorCode ? responsePayload.errorCode : null);
    const resolvedClassification = responseError && responseError.classification ?
      responseError.classification :
      (responsePayload && responsePayload.classification ? responsePayload.classification : null);
    const resolvedI18nKey = responseError && responseError.i18nKey ?
      responseError.i18nKey :
      (responsePayload && responsePayload.i18nKey ? responsePayload.i18nKey : null);
    const resolvedStatusCode = responseError && Object.prototype.hasOwnProperty.call(responseError, "statusCode") ?
      responseError.statusCode :
      (
        responsePayload && Object.prototype.hasOwnProperty.call(responsePayload, "statusCode") ?
          responsePayload.statusCode :
          null
      );
    const message = responseError && responseError.message ?
      responseError.message :
      (
        responsePayload && responsePayload.message ?
          responsePayload.message :
          (responsePayload && responsePayload.errorMessage ? responsePayload.errorMessage : null)
      );
    let classification = resolvedClassification || fallbackClassification || null;

    if (!classification && resolvedErrorCode && /(AUTH|LOGIN|CREDENTIAL|PASSWORD|USER_NOT_FOUND|EMAIL_VERIFICATION)/i.test(resolvedErrorCode)) {
      classification = "auth";
    }

    return new ExpectedError(
      message || fallbackMessage || window.getI18n(ti18n, "SOMETHING_WENT_WRONG"),
      {
        i18nKey: resolvedI18nKey,
        classification: classification,
        statusCode: resolvedStatusCode !== null && typeof resolvedStatusCode !== "undefined" ?
          resolvedStatusCode :
          (
            fallbackStatusCode !== null && typeof fallbackStatusCode !== "undefined" ?
              fallbackStatusCode :
              (
                payload && Object.prototype.hasOwnProperty.call(payload, "status") ?
                  payload.status :
                  null
              )
          ),
        errorCode: resolvedErrorCode,
      },
    );
  },

  _buildExpectedErrorFromKnownUserFacingFailure: function (payload, fallbackMessage, fallbackStatusCode, fallbackClassification, operationName) {
    const responsePayload = payload && payload.responseJSON ? payload.responseJSON : payload;
    const responseError = responsePayload && responsePayload.error ? responsePayload.error : null;
    const errorCode = (
      (responseError && responseError.errorCode) ||
      (responsePayload && responsePayload.errorCode) ||
      null
    );
    const getOwnValue = function(source, fieldName) {
      return source && Object.prototype.hasOwnProperty.call(source, fieldName) ? source[fieldName] : null;
    };
    const responseErrorStatusCode = getOwnValue(responseError, "statusCode");
    const responsePayloadStatusCode = getOwnValue(responsePayload, "statusCode");
    const payloadStatusCode = getOwnValue(payload, "status");
    const statusCode = responseErrorStatusCode !== null && typeof responseErrorStatusCode !== "undefined" ?
      responseErrorStatusCode :
      (
        responsePayloadStatusCode !== null && typeof responsePayloadStatusCode !== "undefined" ?
          responsePayloadStatusCode :
          (
            fallbackStatusCode !== null && typeof fallbackStatusCode !== "undefined" ?
              fallbackStatusCode :
              payloadStatusCode
          )
      );
    const message = (
      (responseError && responseError.message) ||
      (responsePayload && responsePayload.errorMessage) ||
      (responsePayload && responsePayload.message) ||
      fallbackMessage ||
      ""
    );
    const normalizedMessage = String(message || "").toLowerCase();
    const normalizedErrorCode = String(errorCode || "").toLowerCase();
    const normalizedStatusText = String(
      (responseError && responseError.statusText) ||
      (responsePayload && responsePayload.statusText) ||
      (payload && payload.statusText) ||
      ""
    ).toLowerCase();
    const operationNameLower = String(operationName || "").toLowerCase();

    const buildExpectedError = function(category, classification, i18nKey, watchInAnalytics) {
      const fallbackExpectedMessage = i18nKey ?
        window.getI18n(ti18n, i18nKey) :
        window.getI18n(ti18n, "SOMETHING_WENT_WRONG");
      return new ExpectedError(
        message || fallbackExpectedMessage,
        {
          i18nKey: i18nKey || null,
          classification: classification || fallbackClassification || null,
          statusCode: statusCode,
          errorCode: errorCode,
          expectedErrorCategory: category,
          watchInAnalytics: !!watchInAnalytics,
          source: operationName || null,
        },
      );
    };

    if (
      (statusCode === 0 || statusCode === "0") &&
      normalizedStatusText !== "abort" &&
      normalizedStatusText !== "timeout"
    ) {
      return buildExpectedError(EXPECTED_ERROR_CATEGORY.TRANSIENT_NETWORK_NO_RESPONSE, EXPECTED_ERROR_CLASSIFICATION.NETWORK, "NO_INTERNET_CONNECTION_AVAILABLE", true);
    }
    if (normalizedMessage.indexOf("you do not have access to this project") !== -1) {
      return buildExpectedError(EXPECTED_ERROR_CATEGORY.PROJECT_ACCESS_DENIED, EXPECTED_ERROR_CLASSIFICATION.AUTH, "PROJECT_ACCESS_DENIED", false);
    }
    if (
      operationNameLower.indexOf("login") !== -1 &&
      (
        normalizedMessage.indexOf("match any account") !== -1 ||
        normalizedMessage.indexOf("invalid password") !== -1
      )
    ) {
      return buildExpectedError(EXPECTED_ERROR_CATEGORY.LOGIN_ACCOUNT_NOT_FOUND, EXPECTED_ERROR_CLASSIFICATION.AUTH, "LOGIN_ACCOUNT_NOT_FOUND", false);
    }
    if (
      operationNameLower.indexOf("password reset") !== -1 &&
      (
        normalizedErrorCode === "password_reset_token_not_found" ||
        normalizedMessage.indexOf("could not locate user with provided token") !== -1
      )
    ) {
      const passwordResetTokenError = new ExpectedError(
        window.getI18n(ti18n, "PASSWORD_RESET_TOKEN_MISSING"),
        {
          i18nKey: "PASSWORD_RESET_TOKEN_MISSING",
          classification: EXPECTED_ERROR_CLASSIFICATION.AUTH,
          statusCode: statusCode,
          errorCode: errorCode,
          source: operationName || null,
        },
      );
      passwordResetTokenError.errorMessage = passwordResetTokenError.message;
      return passwordResetTokenError;
    }
    if (
      operationNameLower.indexOf("enhance speech in file") !== -1 &&
      normalizedMessage.indexOf("filelocationtoenhance does not match the provided transcriptionjobid") !== -1
    ) {
      return buildExpectedError(null, EXPECTED_ERROR_CLASSIFICATION.VALIDATION, null, false);
    }
    if (
      normalizedMessage.indexOf("transcription quota exceeded") !== -1 ||
      normalizedMessage.indexOf("transcription minutes") !== -1 ||
      normalizedErrorCode.indexOf("transcription_quota") !== -1 ||
      normalizedErrorCode === "workspace_transcription_limit_reached" ||
      (
        normalizedErrorCode.indexOf("quota_exceeded") !== -1 &&
        operationNameLower.indexOf("transcription") !== -1
      )
    ) {
      return buildExpectedError(EXPECTED_ERROR_CATEGORY.TRANSCRIPTION_QUOTA_EXCEEDED, EXPECTED_ERROR_CLASSIFICATION.BUSINESS, "TRANSCRIPTION_QUOTA_EXCEEDED", false);
    }

    return null;
  },

  _getDefaultFailedResponseHandler: function (error, reject, callback, operationName) {
    window.log(
      "Error response from server for operation '" +
        operationName +
        "' .Details :" +
        JSON.stringify(error.responseText),
    );
    const responseText = error && typeof error.responseText === "string" ? error.responseText : "";
    let responseTextJSON = null;
    if(responseText){
      try{
        responseTextJSON = JSON.parse(responseText);
      }catch(parseError){
        responseTextJSON = null;
      }
    }
    const responsePayload = (error && error.responseJSON) || responseTextJSON || null;
    const resolvedErrorCode =
      responsePayload ?
        (responsePayload.errorCode ||
          (responsePayload.error && responsePayload.error.errorCode ? responsePayload.error.errorCode : null)) :
        null;
    const resolvedErrorMessage =
      responsePayload && responsePayload.error && responsePayload.error.message ?
        responsePayload.error.message :
        (
          responsePayload && responsePayload.message ?
            responsePayload.message :
            (
              responsePayload && responsePayload.errorMessage ?
                responsePayload.errorMessage :
                (responseText.indexOf("Support mode is read-only") !== -1 ? responseText : null)
            )
        );

    const isSupportModeReadOnlyError = resolvedErrorCode === "IMPERSONATION_READ_ONLY" ||
      responseText.indexOf("IMPERSONATION_READ_ONLY") !== -1 ||
      responseText.indexOf("Support mode is read-only") !== -1;

    if (isSupportModeReadOnlyError) {
      const supportModeErrorMessage =
        resolvedErrorMessage || "Support mode is read-only. Exit support mode to make changes.";
      const supportModeError = new ExpectedError(
        supportModeErrorMessage,
        {
          i18nKey: "IMPERSONATION_READ_ONLY",
          classification: "business",
          statusCode: error && typeof error.status !== "undefined" ? error.status : null,
          errorCode: resolvedErrorCode || "IMPERSONATION_READ_ONLY",
          expectedErrorCategory: "support_mode_read_only",
          source: operationName || null,
        },
      );
      supportModeError.errorMessage = supportModeErrorMessage;
      supportModeError.response = responsePayload;
      if (window.showSupportModeReadOnlyMessage) {
        window.showSupportModeReadOnlyMessage(supportModeErrorMessage);
      } else if (window.alertWarningMessage) {
        window.alertWarningMessage(supportModeErrorMessage);
      }
      reject(supportModeError);
      if (callback) {
        callback.onFailure(supportModeError);
      }
      return;
    }

    const isProjectAccessDeniedError = resolvedErrorCode === "PROJECT_ACCESS_DENIED" ||
      (
        typeof resolvedErrorMessage === "string" &&
        resolvedErrorMessage.toLowerCase().indexOf("do not have access to this project") !== -1
      ) ||
      responseText.toLowerCase().indexOf("do not have access to this project") !== -1;

    if (isProjectAccessDeniedError) {
      const projectAccessErrorMessage = resolvedErrorMessage || "You do not have access to this project";
      const projectAccessError = new ExpectedError(
        projectAccessErrorMessage,
        {
          i18nKey: "PROJECT_ACCESS_DENIED",
          classification: "auth",
          statusCode: error && typeof error.status !== "undefined" ? error.status : null,
          errorCode: resolvedErrorCode || "PROJECT_ACCESS_DENIED",
          expectedErrorCategory: "project_access_denied",
          source: operationName || null,
        },
      );
      projectAccessError.errorMessage = projectAccessErrorMessage;
      projectAccessError.response = responsePayload;
      reject(projectAccessError);
      if (callback) {
        callback.onFailure(projectAccessError);
      }
      return;
    }

    if (error.status == 401 || error.status == "401") {
      this.logOutExecute(true);
      const unauthorizedError = this._buildExpectedErrorFromServerPayload ?
        this._buildExpectedErrorFromServerPayload(
          error,
          window.getI18n(ti18n, "UNAUTHORIZED_TRANSACTION"),
          401,
          "auth",
        ) :
        null;
      const rejectionReason = unauthorizedError ||
        new ExpectedError(
          window.getI18n(ti18n, "UNAUTHORIZED_TRANSACTION"),
          { i18nKey: "UNAUTHORIZED_TRANSACTION", classification: "auth", statusCode: 401 },
        );
      reject(rejectionReason);
      if (callback) {
        callback.onFailure(rejectionReason);
      }
      return;
    } else {
      // Preserve backend errorCode + structured fields on non-2xx responses
      // so components can branch on workspace/seat_limit_reached etc.
      // When the backend tagged the response as an ExpectedError, prefer
      // the ExpectedError instance (so sendErrorToRaygun / RSVP global hook
      // recognize it) but still attach the structured envelope fields.
      var responseJSON = responsePayload || null;
      if (responseJSON && error) {
        if (!Object.prototype.hasOwnProperty.call(responseJSON, "status") && Object.prototype.hasOwnProperty.call(error, "status")) {
          responseJSON.status = error.status;
        }
        if (!Object.prototype.hasOwnProperty.call(responseJSON, "statusText") && Object.prototype.hasOwnProperty.call(error, "statusText")) {
          responseJSON.statusText = error.statusText;
        }
      }
      var expectedError = this._buildExpectedErrorFromServerPayload ?
        this._buildExpectedErrorFromServerPayload(
          error,
          resolvedErrorMessage,
          error && typeof error.status !== "undefined" ? error.status : null,
          operationName === "Login" ? "auth" : null,
        ) :
        null;
      if (!expectedError && this._buildExpectedErrorFromKnownUserFacingFailure) {
        expectedError = this._buildExpectedErrorFromKnownUserFacingFailure(
          responseJSON || error,
          resolvedErrorMessage,
          error && typeof error.status !== "undefined" ? error.status : null,
          operationName === "Login" ? "auth" : null,
          operationName,
        );
      }
      if (expectedError) {
        if (responseJSON) {
          // Mirror the legacy `errorMessage` copy from the success-handler
          // path (~lines 1351-1353 above). Without this, callers that read
          // `error.errorMessage` directly off the rejected ExpectedError
          // (e.g. ~line 2033 in this file) regress on non-2xx responses
          // — the field would be undefined while the success path sets
          // it. CodeRabbit caught this asymmetry on PR #1739.
          if (responseJSON.errorMessage != null && expectedError.errorMessage == null) {
            expectedError.errorMessage = responseJSON.errorMessage;
          } else if (
            responseJSON.error
            && responseJSON.error.message != null
            && expectedError.errorMessage == null
          ) {
            expectedError.errorMessage = responseJSON.error.message;
          }
          if (responseJSON.errorCode != null && expectedError.errorCode == null) {
            expectedError.errorCode = responseJSON.errorCode;
          } else if (responseJSON.error && responseJSON.error.errorCode != null && expectedError.errorCode == null) {
            expectedError.errorCode = responseJSON.error.errorCode;
          }
          if (responseJSON.seatLimit != null && expectedError.seatLimit == null) {
            expectedError.seatLimit = responseJSON.seatLimit;
          }
          if (responseJSON.seatsUsed != null && expectedError.seatsUsed == null) {
            expectedError.seatsUsed = responseJSON.seatsUsed;
          }
          if (expectedError.response == null) {
            expectedError.response = responseJSON;
          }
        }
        console.warn(expectedError.message);
        reject(expectedError);
        if (callback) {
          callback.onFailure(expectedError);
        }
        return;
      }
      var statusTextForNoResponse = error && typeof error.statusText === "string" ?
        error.statusText.toLowerCase() :
        "";
      if (
        error &&
        (error.status === 0 || error.status === "0") &&
        statusTextForNoResponse !== "abort" &&
        statusTextForNoResponse !== "timeout" &&
        !error.responseJSON &&
        !error.responseText
      ) {
        var noResponseNetworkError = new ExpectedError(
          window.getI18n(ti18n, "NO_INTERNET_CONNECTION_AVAILABLE"),
          {
            i18nKey: "NO_INTERNET_CONNECTION_AVAILABLE",
            classification: EXPECTED_ERROR_CLASSIFICATION.NETWORK,
            statusCode: 0,
            expectedErrorCategory: EXPECTED_ERROR_CATEGORY.TRANSIENT_NETWORK_NO_RESPONSE,
            watchInAnalytics: true,
            source: operationName || null,
          },
        );
        noResponseNetworkError.isNetworkError = true;
        noResponseNetworkError.statusText = error.statusText || null;
        noResponseNetworkError.readyState = Object.prototype.hasOwnProperty.call(error, "readyState") ? error.readyState : null;
        console.warn(noResponseNetworkError.message);
        reject(noResponseNetworkError);
        if (callback) {
          callback.onFailure(noResponseNetworkError);
        }
        return;
      }
      if (responseJSON && (responseJSON.errorCode || responseJSON.errorMessage || (responseJSON.error && responseJSON.error.message))) {
        var nestedMessage = responseJSON.errorMessage
          || (responseJSON.error && responseJSON.error.message)
          || "Request failed";
        var rejectionError = new Error(nestedMessage);
        rejectionError.errorCode = responseJSON.errorCode || (responseJSON.error && responseJSON.error.errorCode) || null;
        rejectionError.errorMessage = nestedMessage;
        rejectionError.statusCode = responseJSON && Object.prototype.hasOwnProperty.call(responseJSON, "statusCode") ?
          responseJSON.statusCode :
          (error && typeof error.status !== "undefined" ? error.status : null);
        if (responseJSON.seatLimit != null) rejectionError.seatLimit = responseJSON.seatLimit;
        if (responseJSON.seatsUsed != null) rejectionError.seatsUsed = responseJSON.seatsUsed;
        rejectionError.response = responseJSON;
        rejectionError.toString = function() { return this.errorMessage || this.message; };
        reject(rejectionError);
      } else if (error.responseText) {
        reject(JSON.stringify(error.responseText));
      } else {
        console.error("Something went wrong when executing the  operation '" + operationName);
        var fallbackFailureMessage = window.getI18n(ti18n, "SOMETHING_WENT_WRONG");
        if (statusTextForNoResponse === "abort" || statusTextForNoResponse === "timeout") {
          reject(fallbackFailureMessage);
          if (callback) {
            callback.onFailure(fallbackFailureMessage);
          }
          return;
        }
        var fallbackError = new Error(fallbackFailureMessage);
        fallbackError.errorMessage = fallbackFailureMessage;
        fallbackError.statusCode = error && typeof error.status !== "undefined" ? error.status : null;
        fallbackError.statusText = error && typeof error.statusText !== "undefined" ? error.statusText : null;
        fallbackError.readyState = error && Object.prototype.hasOwnProperty.call(error, "readyState") ? error.readyState : null;
        fallbackError.source = operationName || null;
        reject(fallbackError);
        if (callback) {
          callback.onFailure(fallbackError);
        }
        return;
      }
    }
    if (callback) {
      callback.onFailure(error.responseText);
    }
  },

  /*_doLoginWithoutToken : function() {
        const username = LocalStorageHelper.getInstance().retrieveUsername() || (device.platform+ device.uuid) ;
        const password = LocalStorageHelper.getInstance().retrieveUserPassword() || (device.uuid);
        const isUsingUIDForLogin =  LocalStorageHelper.getInstance().retrieveUsername() ? false : true;
        return this.doLoginWithoutToken(username, password);
    },*/

  _doLoginInPopup: function (forceLogin, popupLoginOptions) {
    const resolvedPopupLoginOptions = popupLoginOptions || {};
    if (!forceLogin && Utils.getInstance().isTokenValid() && LocalStorageHelper.getInstance().isUsingNewLoginModule()) {
      return this.refreshStoredMobileSessionIfNeeded(false).then(
        function () {
          const tokenInfo = LocalStorageHelper.getInstance().retrieveAuthentificationToken();
          this._applyAuthenticatedAjaxContext(tokenInfo);
        }.bind(this),
      );
    } else {
      return new RSVP.Promise((resolve, reject) => {
        try {
          const uniquePopupLoginPageHash = window.trebble.popupLoginPageHash + "_" + new Date().getTime();
          const completeLoginPopupUrl =
            window.location.protocol == "http:" || window.location.protocol == "https:"
              ? location.origin + window.getAppBaseUrl() + "#" + uniquePopupLoginPageHash
              : window.getBaseUrlWithoutEndSlash() + "#" + uniquePopupLoginPageHash;
          const hostedBrowserAuthPath = resolvedPopupLoginOptions.authPath || "login";
          const hostedBrowserAuthRequestOptions = Object.assign({}, resolvedPopupLoginOptions.options || {});
          if (this._isBrowserHostedAuthEnvironment()) {
            hostedBrowserAuthRequestOptions.returnToUrl = completeLoginPopupUrl;
            // Popup auth preserves the opener's live state, so redirect-only
            // pending actions must stay in-memory and not be replayed on a
            // later startup.
            if (Object.prototype.hasOwnProperty.call(hostedBrowserAuthRequestOptions, "pendingAction")) {
              delete hostedBrowserAuthRequestOptions.pendingAction;
            }
          }
          const w = 500;
          const h = 700;
          const left = window.getLeftPositionForPopupWindow(w);
          const top = window.getTopPositionForPopupWindow(h);
          const popupTargetUrl = this._isBrowserHostedAuthEnvironment()
            ? this._buildHostedBrowserAuthUrl(hostedBrowserAuthPath, hostedBrowserAuthRequestOptions)
            : completeLoginPopupUrl;
          const openedWindow = window.open(
            popupTargetUrl,
            "_blank",
            "toolbar=no, scrollbars=yes, resizable=yes, width=" +
              w +
              ", height=" +
              h +
              " top=" +
              top +
              " left=" +
              left +
              "",
          );

          if (openedWindow && !openedWindow.closed && !window.waitForCordovaToLoad) {
            let popupLoginCompleted = false;
            const expectedPopupOrigin = this._isBrowserHostedAuthEnvironment()
              ? new URL(completeLoginPopupUrl).origin
              : null;
            const onMessageReceivedFunc = (event) => {
              if (event.source != openedWindow) {
                return;
              }

              if (expectedPopupOrigin && event.origin !== expectedPopupOrigin) {
                return;
              }

              let receivedMessageJson = null;
              try {
                receivedMessageJson = this.buildJsonFromBrowserMessageString(event.data);
              } catch (error) {
                window.removeEventListener("message", onMessageReceivedFunc);
                openedWindow.close();
                reject(error);
                return;
              }

              if (receivedMessageJson.action !== "login") {
                return;
              }

              const finalizePopupLoginPromise = receivedMessageJson.success
                ? (this._isBrowserHostedAuthEnvironment()
                    ? this.bootstrapWebSession(true).then(
                        function (tokenInfo) {
                          if (!tokenInfo) {
                            throw new Error("No authenticated WorkOS session was found for popup login completion.");
                          }

                          return true;
                        }.bind(this),
                      )
                    : RSVP.Promise.resolve(receivedMessageJson.message).then(
                        function (tokenInfo) {
                          return this._finalizeAuthenticatedTokenInfo(tokenInfo).then(function () {
                            return true;
                          });
                        }.bind(this),
                      ))
                : RSVP.Promise.reject(receivedMessageJson.errorMessage);

              finalizePopupLoginPromise
                .then(function () {
                  popupLoginCompleted = true;
                  resolve(true);
                })
                .catch(function (error) {
                  popupLoginCompleted = true;
                  reject(error);
                })
                .finally(function () {
                  window.removeEventListener("message", onMessageReceivedFunc);
                  openedWindow.close();
                });
            };

            window.addEventListener("message", onMessageReceivedFunc, false);
            openedWindow.focus();
            if (openedWindow.focus) {
              openedWindow.focus();
            }

            openedWindow.onload = function () {
              openedWindow.onunload = function () {
                if (!popupLoginCompleted) {
                  reject(window.getI18n(ti18n, "PLEASE_LOGIN"));
                }
              };
            };
          } else {
            reject(window.getI18n(ti18n, "PLEASE_ALLOW_POPUPS"));
          }
        } catch (error) {
          reject(error);
        }
      });
    }
  },

  buildBrowserMessageStringToPost: function (action, success, message, errorMessage) {
    const toSend = {};
    toSend.action = action;
    toSend.success = success;
    toSend.message = message;
    toSend.errorMessage = errorMessage;
    return JSON.stringify(toSend);
  },

  buildJsonFromBrowserMessageString: function (messageString) {
    return JSON.parse(messageString);
  },

  _doLogin: function (forceLoginPage, forceLoginOnlyIfGuest, forceSignUpAsCreator) {
    // When the URL indicates an invite/signup/login flow, skip full login
    // entirely and let the router handle auth. This prevents the
    // "Invalid Access Code" popup from blocking the invite acceptance
    // redirect. CRITICAL: when the user is already logged in with a valid
    // token (e.g. the invitee persona in the live workspace E2E flow), we
    // still MUST set the $.ajaxSetup Authorization header. Without it,
    // downstream startup calls like getUserProfileInfoByUsername (main.js
    // line ~858) fire unauthenticated, get a 401, and trigger the generic
    // "Trebble FM was recently updated" alert — which masks the real
    // acceptWorkspaceInvite flow. See workspacePersona.live.spec.js:159.
    var currentRoute = (location.hash || "").replace(/^#/, "").split("/")[0].split("?")[0];
    // Browser/app init can strip the hash during startup (observed when the
    // URL is "#acceptWorkspaceInvite?token=XYZ" and the ?query gets split
    // onto location.search), so the hash-only check above misses the
    // invite route. Fall back to scanning pathname + location.href for the
    // invite route name so the auth-fast-path still fires.
    if (!currentRoute) {
        var pathname = (typeof window !== 'undefined' && window.location) ? window.location.pathname || '' : '';
        var href = (typeof window !== 'undefined' && window.location) ? window.location.href || '' : '';
        if (pathname.indexOf('acceptWorkspaceInvite') !== -1 || href.indexOf('acceptWorkspaceInvite') !== -1) {
            currentRoute = 'acceptWorkspaceInvite';
        } else if (pathname.indexOf('signupForAudioEditor') !== -1) {
            currentRoute = 'signupForAudioEditor';
        } else if (pathname.indexOf('loginForAudioEditor') !== -1) {
            currentRoute = 'loginForAudioEditor';
        } else if (pathname.indexOf('reset-password') !== -1 || href.indexOf('reset-password') !== -1) {
            currentRoute = 'reset-password';
        } else if (pathname.indexOf('resetPassword') !== -1 || href.indexOf('resetPassword') !== -1) {
            currentRoute = 'resetPassword';
        }
    }
    if (!forceLoginPage &&
        (currentRoute === "acceptWorkspaceInvite" ||
         currentRoute === "signupForAudioEditor" ||
         currentRoute === "loginForAudioEditor" ||
         currentRoute === "reset-password" ||
         currentRoute === "resetPassword")) {
      if (Utils.getInstance().isTokenValid() && LocalStorageHelper.getInstance().isUsingNewLoginModule()) {
        var existingTokenInfo = LocalStorageHelper.getInstance().retrieveAuthentificationToken();
        if (existingTokenInfo && existingTokenInfo.token) {
          $.ajaxSetup({
            headers: {
              Authorization: "Bearer " + existingTokenInfo.token,
            },
          });
        }
      }
      return RSVP.Promise.resolve();
    }
    if (this._isBrowserHostedAuthEnvironment()) {
      return this.bootstrapWebSession().then(
        function (tokenInfo) {
          const loginShouldForceBecauseGuestAccount =
            forceLoginOnlyIfGuest && this.isUserpreviouslyLoggedInAsGuest();
          if (
            !forceLoginPage &&
            !loginShouldForceBecauseGuestAccount &&
            tokenInfo &&
            Utils.getInstance().isTokenValid() &&
            LocalStorageHelper.getInstance().isUsingNewLoginModule() &&
            !(this.isUserpreviouslyLoggedInAsGuest() && !window.trebble.allowAutoLoginAsGuest)
          ) {
            this._applyAuthenticatedAjaxContext(tokenInfo);
            return RSVP.Promise.resolve();
          }

          if (isEmbedded || window.trebble.isEmbededLoginInPage) {
            return this._doLoginInPopup(true);
          }

          if (forceSignUpAsCreator) {
            document.location.assign(this._getHostedBrowserAppBaseUrl() + "#onboardingSignupPage");
            return new RSVP.Promise(function () {});
          }

          return this.doLoginWithLoginPage(
            false,
            forceLoginPage || loginShouldForceBecauseGuestAccount,
            null,
            forceSignUpAsCreator,
          );
        }.bind(this),
      );
    }

    const loginShouldForceBecauseGuestAccount = forceLoginOnlyIfGuest && this.isUserpreviouslyLoggedInAsGuest();

    if (
      !forceLoginPage &&
      !loginShouldForceBecauseGuestAccount &&
      Utils.getInstance().isTokenValid() &&
      LocalStorageHelper.getInstance().isUsingNewLoginModule() &&
      !(this.isUserpreviouslyLoggedInAsGuest() && !window.trebble.allowAutoLoginAsGuest)
    ) {
      return this.refreshStoredMobileSessionIfNeeded(false).then(
        function () {
          const tokenInfo = LocalStorageHelper.getInstance().retrieveAuthentificationToken();
          this._applyAuthenticatedAjaxContext(tokenInfo);
          return RSVP.Promise.resolve();
        }.bind(this),
      );
    } else {
      /*
return Utils.getInstance().getUserLoginCredentials().then((function(userCred){
const username = userCred.username;
const password = userCred.password;
return this.doLogin(username, password);
}).bind(this));*/
      if (window.trebble.allowAutoLoginAsGuest && !loginShouldForceBecauseGuestAccount) {
        return this.doLoginAsGuest();
      } else {
        return this.doLoginWithLoginPage(
          false,
          forceLoginPage || loginShouldForceBecauseGuestAccount,
          null,
          forceSignUpAsCreator,
        );
      }
    }
  },

  _doLoginRequiringRegisteredUser: function (forceSignUpAsCreator, loginFlowOptions) {
    const resolvedLoginFlowOptions = Object.assign({}, loginFlowOptions || {}, {
      requiresRegisteredUserSession: true,
    });
    const continueWithRegisteredUserIfAvailable = function (tokenInfo) {
      const resolvedTokenInfo = tokenInfo || LocalStorageHelper.getInstance().retrieveAuthentificationToken();
      const resolvedUserInfo = resolvedTokenInfo && resolvedTokenInfo.userInfo ? resolvedTokenInfo.userInfo : null;
      const hasRegisteredUserSession =
        !!resolvedUserInfo &&
        !resolvedUserInfo.temporary &&
        Utils.getInstance().isTokenValid() &&
        LocalStorageHelper.getInstance().isUsingNewLoginModule();

      if (hasRegisteredUserSession) {
        this._applyAuthenticatedAjaxContext(resolvedTokenInfo);
        return RSVP.Promise.resolve();
      }

      return this.doLoginWithLoginPage(false, true, null, forceSignUpAsCreator, resolvedLoginFlowOptions);
    }.bind(this);

    if (this._isBrowserHostedAuthEnvironment()) {
      return this.bootstrapWebSession().then(continueWithRegisteredUserIfAvailable);
    }

    if (
      Utils.getInstance().isTokenValid() &&
      LocalStorageHelper.getInstance().isUsingNewLoginModule() &&
      LocalStorageHelper.getInstance().getAuthenticatedUserInfo()
    ) {
      return this.refreshStoredMobileSessionIfNeeded(false)
        .then(
          function () {
            return continueWithRegisteredUserIfAvailable(
              LocalStorageHelper.getInstance().retrieveAuthentificationToken(),
            );
          }.bind(this),
        )
        .catch(
          function () {
            return this.doLoginWithLoginPage(false, true, null, forceSignUpAsCreator, resolvedLoginFlowOptions);
          }.bind(this),
        );
    }

    return this.doLoginWithLoginPage(false, true, null, forceSignUpAsCreator, resolvedLoginFlowOptions);
  },

  _createTemporaryAccountWithDeviceUID: function (visitorCredentials) {
    const isBrowserVisitor = window.device && window.device.platform == "browser";
    const resolvedVisitorCredentials = visitorCredentials || (isBrowserVisitor ? this._buildStoredVisitorCredentials() : null);
    let tempUsername = null;
    let tempPassword = null;

    if (resolvedVisitorCredentials) {
      tempUsername = resolvedVisitorCredentials.username;
      tempPassword = resolvedVisitorCredentials.password;
    } else {
      let uid = null;
      if (isBrowserVisitor) {
        uid = new Date().getTime() + window.ID();
      } else {
        uid = window.device.uuid + window.ID();
      }

      if (isBrowserVisitor) {
        tempUsername = "visitor_" + uid;
      } else {
        tempUsername = window.device.platform + uid;
      }
      tempPassword = "cocoBongo1";
    }

    const params = {
      firstName: tempUsername,
      lastName: tempUsername,
      email: tempUsername + "@visitors.trebble.fm",
      birthDate: new Date(),
      username: tempUsername,
      temporary: true,
      accessCode: "QDS5-ZPFK-4F46",
      password: tempPassword,
    };
    if (isBrowserVisitor) {
      params.visitor = true;
      params.referrer = window.trebble.referrer;
    }
    let result = null;
    const apiSelf = this;
    if (!window.trebble.allowAutoLoginAsGuest) {
      Utils.getInstance().showInfoNotification(window.getI18n(ti18n, "WE_ARE_CREATING_YOU_A_TEMPORARY_ACCOUNT"));
    }

    const context = { referrer: window.trebble.referrer };
    return this.signup(params, null, context).then(
      function (signupResult) {
        result = signupResult;
        if (result.userInfo) {
          const username = result.userInfo.username;
          //const password = tempPassword;
          return (this.loginPromise = new RSVP.Promise(function (resolve, reject) {
            $.ajax(
              apiSelf._buildServerAjaxOptions(
                "POST",
                "loginWithToken",
                {
                  username: username,
                  password: tempPassword,
                  language: window.getAppUsedLanguage(),
                  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                  environment: window.getAppEnvironment(),
                },
                { skipStoredAuthToken: true },
              ),
            )
              .done(
                function (result) {
                  apiSelf._loginSuccessfull = result.message;
                  return apiSelf._getDefaultResponseHandler(result, resolve, reject, null, "Login");
                }.bind(this),
              )
              .fail(
                function (error) {
                  apiSelf._loginSuccessfull = false;
                  apiSelf._loginFailureReason = error;
                  return apiSelf._getDefaultFailedResponseHandler(error, reject, null, "Login");
                }.bind(this),
              );
          }).then(function (tokenInfo) {
            return apiSelf._finalizeAuthenticatedTokenInfo(tokenInfo).then(function () {
              return true;
            });
          }));
          //return this.doLogin(username,password, true);
        }
      }.bind(this),
    );
  },

  getUsername: function () {
    return this.username;
  },

  doLoginAsGuest: function (doNotCreateTempUserIfUserNotFound) {
    // Skip guest login during invite/signup flows — no auth needed for these routes
    var currentRoute = (location.hash || "").replace(/^#/, "").split("/")[0].split("?")[0];
    if (currentRoute === "acceptWorkspaceInvite" ||
        currentRoute === "signupForAudioEditor" ||
        currentRoute === "loginForAudioEditor") {
      return RSVP.Promise.resolve(false);
    }
        const visitorCredentials =
      window.device && window.device.platform == "browser" ? this._buildStoredVisitorCredentials() : null;
    const username = visitorCredentials ? visitorCredentials.username : "anonymous";
    const password = visitorCredentials ? visitorCredentials.password : "doudou";
    window.log("doLoginAsGuest ");
    if (Utils.getInstance().isInterntetConnectionIsAvailable()) {
      const apiSelf = this;
      if (
        this._loginDoneWithToken &&
        Utils.getInstance().isTokenValid() &&
        LocalStorageHelper.getInstance().isUsingNewLoginModule()
      ) {
        {
          const tokenInfo = LocalStorageHelper.getInstance().retrieveAuthentificationToken();
          this._applyAuthenticatedAjaxContext(tokenInfo);
          return RSVP.Promise.resolve(true);
        }
      } else {
        if (!this.loginPromiseWithTokenAsGuest) {
          this._loginDoneWithToken = true;
          this.loginPromiseWithTokenAsGuest = new RSVP.Promise(function (resolve, reject) {
            $.ajax(
              apiSelf._buildServerAjaxOptions(
                "POST",
                "loginWithToken",
                {
                  username: username,
                  password: password,
                  language: window.getAppUsedLanguage(),
                  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                  environment: window.getAppEnvironment(),
                },
                { skipStoredAuthToken: true },
              ),
            )
              .done(
                function (result) {
                  return apiSelf._getDefaultResponseHandler(result, resolve, reject, null, "Login As Guest");
                }.bind(this),
              )
              .fail(
                function (error) {
                  apiSelf._loginFailureReasonWithToken = error;
                  return apiSelf._getDefaultFailedResponseHandler(error, reject, null, "Login As Guest");
                }.bind(this),
              );
          })
            .then(function (tokenInfo) {
              return apiSelf._finalizeAuthenticatedTokenInfo(tokenInfo).then(function () {
                return true;
              });
            })
            .catch(
              function (error) {
                const normalizedGuestLoginErrorMessage =
                  Utils.getInstance().getErrorMessageFromObject(error) ||
                  (error && error.errorMessage ? error.errorMessage : null) ||
                  (error && error.responseJSON && error.responseJSON.error && error.responseJSON.error.message
                    ? error.responseJSON.error.message
                    : null) ||
                  (error && error.responseText ? error.responseText : null);
                const shouldCreateTemporaryVisitorAccount =
                  !doNotCreateTempUserIfUserNotFound &&
                  normalizedGuestLoginErrorMessage &&
                  normalizedGuestLoginErrorMessage.indexOf &&
                  (
                    normalizedGuestLoginErrorMessage.indexOf("User not found") != -1 ||
                    normalizedGuestLoginErrorMessage.indexOf("Invalid password!") != -1 ||
                    normalizedGuestLoginErrorMessage.indexOf("doesn’t match any account") != -1 ||
                    normalizedGuestLoginErrorMessage.indexOf("doesn't match any account") != -1
                  );
                if (
                  shouldCreateTemporaryVisitorAccount
                ) {
                  return this._createTemporaryAccountWithDeviceUID(visitorCredentials);
                } else {
                  apiSelf._loginFailureReasonWithToken = error;
                  throw error;
                }
              }.bind(this),
            );
          this.loginPromiseWithTokenAsGuest
            .then(
              function () {
                this.loginPromiseWithTokenAsGuest = null;
                this._loginDoneWithToken = false;
              }.bind(this),
            )
            .catch(
              function (error) {
                this.loginPromiseWithTokenAsGuest = null;
                this._loginDoneWithToken = false;
                console.error("Login Failed: Reason" + error);
                throw window.getI18n(ti18n, "PLEASE_LOGIN");
              }.bind(this),
            );
          return this.loginPromiseWithTokenAsGuest;
        } else {
          return this.loginPromiseWithTokenAsGuest.then(
            function () {
              const tokenInfo = LocalStorageHelper.getInstance().retrieveAuthentificationToken();
              this._applyAuthenticatedAjaxContext(tokenInfo);
            }.bind(this),
          );
        }
      }
    } else {
      return RSVP.Promise.reject(window.getI18n(ti18n, "NO_INTERNET_CONNECTION_AVAILABLE"));
    }
  },

  isUserpreviouslyLoggedInAsGuest: function () {
    const tokenInfo = LocalStorageHelper.getInstance().retrieveAuthentificationToken();
    return tokenInfo && tokenInfo.userInfo && tokenInfo.userInfo.temporary;
  },

  requireLoginController: function () {
    $.mobile.loading("show");
    return new RSVP.Promise(function (resolve, reject) {
      try {
        require(["controllers/login/LoginControllerNew"], function (loadedFiled) {
          $.mobile.loading("hide");
          resolve(loadedFiled.default);
        });
      } catch (error) {
        $.mobile.loading("hide");
        reject(error);
      }
    });
  },

  _openLoginControllerFlow: function (successSignupData, forceSignUpAsCreator, loginFlowOptions) {
    return new RSVP.Promise(
      function (resolve, reject) {
        try {
          const activePage$el = $(".ui-page-active");
          const pendingHostedAuthAction =
            loginFlowOptions && loginFlowOptions.pendingHostedAuthAction
              ? loginFlowOptions.pendingHostedAuthAction
              : null;
          const requiresRegisteredUserSession = !!(
            loginFlowOptions && loginFlowOptions.requiresRegisteredUserSession
          );
          const activePageId = activePage$el.size() != 0 && activePage$el.get(0) ? activePage$el.get(0).id : null;
          const canOpenLoginAsPopupOnActivePage =
            !!activePageId &&
            activePageId != "featurePage" &&
            activePageId != "loginPage" &&
            activePageId != "NewLoginPage" &&
            activePageId != "newSignupPage" &&
            activePageId != "onboardingSignupPage";
          const shouldPreferHostedBrowserPopup =
            this._isBrowserHostedAuthEnvironment() &&
            !!(
              (requiresRegisteredUserSession &&
                typeof activePageId === "string" &&
                activePageId.indexOf("createAShortcastPage_") === 0) ||
              (pendingHostedAuthAction && pendingHostedAuthAction.usePopup === true)
            );
          const showAsPopup =
            canOpenLoginAsPopupOnActivePage &&
            (!this._isBrowserHostedAuthEnvironment() || shouldPreferHostedBrowserPopup);
          const pendingProtectedRedirectHash = (function () {
            try {
              return window.sessionStorage.getItem("trebblePostLoginRedirectHash");
            } catch (error) {
              console.error("Failed reading pending post-login redirect hash. Error:" + error);
              return null;
            }
          })();
          let router = window.trebble ? window.trebble.trebbleRouter : null;
          if (!router && window.trebble) {
            router = {
              _isAuthPlaceholderRouter: true,
              _loginController: null,
              setLoginController: function (loginController) {
                this._loginController = loginController;
              },
              getLoginController: function () {
                return this._loginController;
              },
            };
            window.trebble.trebbleRouter = router;
          }
          const pendingProtectedRouteRequiresRegisteredUser = !!(
            router &&
            router._routeRequiresAuthenticatedNonVisitorSession &&
            pendingProtectedRedirectHash &&
            router._routeRequiresAuthenticatedNonVisitorSession(pendingProtectedRedirectHash)
          );
          const params = {};
          params.loginApi = this.postLogin.bind(this);
          params.startMagicAuthApi = this.startMagicAuth.bind(this);
          params.verifyMagicAuthApi = this.verifyMagicAuth.bind(this);
          params.verifyEmailVerificationApi = this.verifyEmailVerification.bind(this);
          params.startOrganizationLoginApi = (function (loginIdentifier) {
            return this.startOrganizationLogin(loginIdentifier, {
              pendingHostedAuthAction: pendingHostedAuthAction,
              usePopup: showAsPopup,
            });
          }).bind(this);
          params.loginWithFacebookApi = this.postLoginWithFacebook.bind(this);
          params.loginWithAppleApi = (function (appleIdToken) {
            return this.postLoginWithApple(appleIdToken, {
              pendingHostedAuthAction: pendingHostedAuthAction,
              usePopup: showAsPopup,
            });
          }).bind(this);
          params.loginWithGoogleApi = (function (googleAccessToken) {
            return this.postLoginWithGoogle(googleAccessToken, {
              pendingHostedAuthAction: pendingHostedAuthAction,
              usePopup: showAsPopup,
            });
          }).bind(this);
          params.showAsPopup = showAsPopup;
          params.forceSignUpAsCreator = forceSignUpAsCreator;
          params.isUserpreviouslyLoggedInAsGuest = this.isUserpreviouslyLoggedInAsGuest();
          if (window.trebble.isEmbededLoginInPage) {
            params.isUserpreviouslyLoggedInAsGuest = false;
          }
          params.signupApi = this.signup.bind(this);
          params.signupWithFacebookApi = this.signupWithFacebook.bind(this);
          params.signupWithGoogleApi = (function () {
            const signupArguments = Array.prototype.slice.call(arguments);
            signupArguments.push({
              pendingHostedAuthAction: pendingHostedAuthAction,
            });
            return this.signupWithGoogle.apply(this, signupArguments);
          }).bind(this);
          params.signupWithAppleApi = (function () {
            const signupArguments = Array.prototype.slice.call(arguments);
            signupArguments.push({
              pendingHostedAuthAction: pendingHostedAuthAction,
            });
            return this.signupWithApple.apply(this, signupArguments);
          }).bind(this);
          params.doNotAllowGuestLogin = !!(
            window.trebble.isEmbededLoginInPage ||
            window.trebble.entryPointRequiresAuthentication ||
            pendingProtectedRouteRequiresRegisteredUser ||
            requiresRegisteredUserSession
          );
          params.loginAsGuestApi = this._isBrowserHostedAuthEnvironment() ?
            this.continueWithAnonymousBrowserSession.bind(this) :
            this.doLoginAsGuest.bind(this);
          params.successSignupData = successSignupData;
          params.onLoginSuccessfullyCompleted = (function (loginResult) {
            this.loginPromiseWithToken = null;
            this._loginDoneWithToken = false;
            const localStorageHelper = LocalStorageHelper.getInstance();
            const tokenInfo = localStorageHelper.retrieveAuthentificationToken();
            const authenticatedUserInfo = localStorageHelper.getAuthenticatedUserInfo ?
              localStorageHelper.getAuthenticatedUserInfo() :
              (tokenInfo && tokenInfo.userInfo && !tokenInfo.userInfo.temporary ? tokenInfo.userInfo : null);
            const hasCompletedRequiredRegisteredLogin =
              !requiresRegisteredUserSession ||
              !!(
                authenticatedUserInfo &&
                Utils.getInstance().isTokenValid() &&
                localStorageHelper.isUsingNewLoginModule()
              );
            if (loginResult && hasCompletedRequiredRegisteredLogin) {
              this._applyAuthenticatedAjaxContext(tokenInfo);
              resolve();
            } else {
              reject(window.getI18n(ti18n, "LOGIN_FAILED"));
            }
          }).bind(this);
          window.log("Opening LoginControllerNew");

          const requireLoginControllerPromise = this._cachedLoginControllerObj
            ? RSVP.Promise.resolve(this._cachedLoginControllerObj)
            : this.requireLoginController(["controllers/login/LoginControllerNew"]);
          requireLoginControllerPromise
            .then(
              function (LoginControllerNew) {
                this._cachedLoginControllerObj = LoginControllerNew;
                const loginController = new LoginControllerNew(params);
                if (window.trebble) {
                  window.trebble._pendingLoginControllerForRouter = loginController;
                }
                if (window.trebble && window.trebble.trebbleRouter && window.trebble.trebbleRouter.setLoginController) {
                  window.trebble.trebbleRouter.setLoginController(loginController);
                }
                $.mobile.loading("show");
                window.log(" LoginControllerNew built");
                loginController
                  .buildModelAndRenderView()
                  .then(
                    function () {
                      window.log(" waiting for pageContainerReadyPromise");
                      window.log(
                        " waiting for pageContainerReadyPromise" + window.trebble.pageContainerReadyPromise,
                      );
                      return window.trebble.pageContainerReadyPromise;
                    }.bind(this),
                  )
                  .then(
                    function () {
                      window.log(" LoginControllerNew show popup");
                      const loginView = this.loginController.getView ? this.loginController.getView() : null;
                      if (!loginView || !loginView.$el) {
                        $.mobile.loading("hide");
                        window.log(
                          "Skipping legacy login-page navigation because the login controller completed without rendering a view.",
                        );
                        return RSVP.Promise.resolve();
                      }
                      if (!showAsPopup) {
                        const appRouter = window.trebble ? window.trebble.trebbleRouter : null;
                        if (appRouter && appRouter.navigateToPageWithId) {
                          return appRouter.navigateToPageWithId(
                            "NewLoginPage",
                            "Login page",
                            false,
                            false,
                            loginView.$el,
                            null,
                            false,
                          );
                        } else if (loginView) {
                          $("body").append(loginView.$el);
                          $.mobile.changePage("#NewLoginPage", {
                            changeHash: false,
                          });
                          // A logged-out direct link shows the login page before the app router exists,
                          // so the router never hides the start-up loader; covered by this page, its
                          // animation would keep the visitor's browser busy.
                          $("#loadingBoxWidget").css("display", "none");
                          if (appRouter && appRouter.setCanPlayerFooterBeShowOnActivePage) {
                            appRouter.setCanPlayerFooterBeShowOnActivePage(false);
                          }
                          $.mobile.resetActivePageHeight();
                        }
                        $.mobile.loading("hide");
                      } else {
                        $.mobile.loading("hide");
                      }
                    }.bind({
                      loginController: loginController,
                    }),
                  )
                  .catch(function (error) {
                    $.mobile.loading("hide");
                    console.error("An error occured while showing Login Page.Error:" + error);
                    reject(error);
                  });
              }.bind(this),
            )
            .catch(
              function (error) {
                console.error("Error loading Login controller.Error" + error);
                window.alertErrorMessage(window.getI18n(ti18n, "SOMETHING_WENT_WRONG_WHILE_DISPLAYING_LOGIN"));
              }.bind(this),
            );
        } catch (error) {
          reject(error);
        }
      }.bind(this),
    );
  },

  doLoginWithLoginPage: function (
    doNotCreateTempUserIfUserNotFound,
    forceLogin,
    successSignupData,
    forceSignUpAsCreator,
    loginFlowOptions,
  ) {
    window.log("doLoginWithLoginPage  ");
    if (!Utils.getInstance().isInterntetConnectionIsAvailable()) {
      return RSVP.Promise.reject(window.getI18n(ti18n, "NO_INTERNET_CONNECTION_AVAILABLE"));
    }

    if (this._isBrowserHostedAuthEnvironment()) {
      return this.bootstrapWebSession().then(
        function (tokenInfo) {
          if (
            !forceLogin &&
            tokenInfo &&
            Utils.getInstance().isTokenValid() &&
            LocalStorageHelper.getInstance().isUsingNewLoginModule()
          ) {
            this._applyAuthenticatedAjaxContext(tokenInfo);
            return RSVP.Promise.resolve(true);
          }

          if (forceSignUpAsCreator) {
            document.location.assign(this._getHostedBrowserAppBaseUrl() + "#onboardingSignupPage");
            return new RSVP.Promise(function () {});
          }

          return this._openLoginControllerFlow(successSignupData, forceSignUpAsCreator, loginFlowOptions);
        }.bind(this),
      );
    }

    if (
      !forceLogin &&
      this._loginDoneWithToken &&
      Utils.getInstance().isTokenValid() &&
      LocalStorageHelper.getInstance().isUsingNewLoginModule()
    ) {
      return this.refreshStoredMobileSessionIfNeeded(false).then(
        function () {
          const tokenInfo = LocalStorageHelper.getInstance().retrieveAuthentificationToken();
          this._applyAuthenticatedAjaxContext(tokenInfo);
          return RSVP.Promise.resolve(true);
        }.bind(this),
      );
    }

    if (this.loginPromiseWithToken) {
      return this.loginPromiseWithToken.then(
        function () {
          const tokenInfo = LocalStorageHelper.getInstance().retrieveAuthentificationToken();
          this._applyAuthenticatedAjaxContext(tokenInfo);
        }.bind(this),
      );
    }

    this._loginDoneWithToken = true;
    let p = null;
    window.log("window.trebble.isEmbededLoginInPage is " + window.trebble.isEmbededLoginInPage);
    if (
      (!isEmbedded &&
        !Utils.getInstance().isJQMPopupOpen() &&
        !window.trebble.entryPointUrlHashLoadedPlayerQueue) ||
      window.trebble.isEmbededLoginInPage
    ) {
      p = this._openLoginControllerFlow(successSignupData, forceSignUpAsCreator, loginFlowOptions);
    } else {
      p = this._doLoginInPopup(true);
    }

    p.then(
      function () {
        this.loginPromiseWithToken = null;
        this._loginDoneWithToken = false;
      }.bind(this),
    ).catch(
      function (error) {
        this.loginPromiseWithToken = null;
        this._loginDoneWithToken = false;
        console.error("Login Failed: Reason" + error);
        throw window.getI18n(ti18n, "PLEASE_LOGIN");
      }.bind(this),
    );
    this.loginPromiseWithToken = p;
    return this.loginPromiseWithToken;
  },

  postLogin: function (username, password) {
    const apiSelf = this;
    this._loginDoneWithToken = true;
    const params = {
      username: username,
      password: password,
      language: window.getAppUsedLanguage(),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      environment: window.getAppEnvironment(),
    };
    return this._makeApiServerCall("auth/password/login", params, "Do login with token", true)
      .then(function (tokenInfo) {
        if (tokenInfo && tokenInfo.requiresEmailVerification) {
          return tokenInfo;
        }
        return apiSelf._finalizeAuthenticatedTokenInfo(tokenInfo).then(function () {
          return true;
        });
      })
      .catch(function (error) {
        throw error;
      });
  },

  startMagicAuth: function (email) {
    const params = {
      email: email,
      language: window.getAppUsedLanguage(),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      environment: window.getAppEnvironment(),
    };

    return this._makeApiServerCall("auth/magic/start", params, "Send WorkOS Magic Login Code", true);
  },

  verifyMagicAuth: function (email, code) {
    const apiSelf = this;
    this._loginDoneWithToken = true;
    const params = {
      email: email,
      code: code,
      language: window.getAppUsedLanguage(),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      environment: window.getAppEnvironment(),
    };

    return this._makeApiServerCall("auth/magic/verify", params, "Verify WorkOS Magic Login Code", true)
      .then(function (tokenInfo) {
        return apiSelf._finalizeAuthenticatedTokenInfo(tokenInfo).then(function () {
          return true;
        });
      })
      .catch(function (error) {
        throw error;
      });
  },

  verifyEmailVerification: function (pendingAuthenticationToken, code) {
    const apiSelf = this;
    this._loginDoneWithToken = true;
    const params = {
      pendingAuthenticationToken: pendingAuthenticationToken,
      code: code,
      language: window.getAppUsedLanguage(),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      environment: window.getAppEnvironment(),
    };

    return this._makeApiServerCall("auth/verification/verify", params, "Verify WorkOS Email Verification", true)
      .then(function (tokenInfo) {
        return apiSelf._finalizeAuthenticatedTokenInfo(tokenInfo).then(function () {
          return true;
        });
      })
      .catch(function (error) {
        throw error;
      });
  },

  _buildOrganizationLoginOptions: function (loginIdentifier) {
    const resolvedLoginIdentifier =
      typeof loginIdentifier === "string" ? loginIdentifier.trim().toLowerCase() : "";
    const options = {};
    const emailValidationRegex = Utils.getInstance().getEmailRegexValidation();

    if (resolvedLoginIdentifier && emailValidationRegex.test(resolvedLoginIdentifier)) {
      options.loginHint = resolvedLoginIdentifier;
      options.domainHint = resolvedLoginIdentifier.split("@")[1];
    }

    return options;
  },

  startOrganizationLogin: function (loginIdentifier, hostedAuthOptions) {
    const organizationLoginOptions = this._buildOrganizationLoginOptions(loginIdentifier);

    if (this._isBrowserHostedAuthEnvironment()) {
      if (this._shouldUseHostedBrowserAuthPopup(hostedAuthOptions)) {
        return this._doLoginInPopup(true, {
          options: Object.assign({}, organizationLoginOptions),
        });
      }

      return this._startHostedBrowserAuthRedirect(
        "login",
        this._getHostedBrowserLoginReturnUrl(),
        Object.assign({}, organizationLoginOptions, {
          pendingAction:
            hostedAuthOptions && hostedAuthOptions.pendingHostedAuthAction
              ? hostedAuthOptions.pendingHostedAuthAction
              : null,
        }),
      );
    }

    if (this._isCordovaHostedAuthEnvironment()) {
      return this._beginMobileHostedAuthFlow("login", organizationLoginOptions).then(function (result) {
        return result && result.tokenInfo && result.tokenInfo.userInfo ? result.tokenInfo.userInfo : {};
      });
    }

    return RSVP.Promise.reject("Organization sign-in is not available in this environment yet.");
  },

  postLoginWithFacebook: function (facebookAccessToken) {
    if (this._usesHostedWorkOSSocialAuth()) {
      return this._rejectUnsupportedHostedBrowserProvider("Facebook");
    }

    this._loginDoneWithToken = true;
    const apiSelf = this;
    const params = {
      facebookAccessToken: facebookAccessToken,
      language: window.getAppUsedLanguage(),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      environment: window.getAppEnvironment(),
    };
    return this._makeApiServerCall("loginWithFacebookToken", params, "Do login with facebook token", true)
      .then(function (tokenInfo) {
        return apiSelf._finalizeAuthenticatedTokenInfo(tokenInfo).then(function (resolvedTokenInfo) {
          const userInfo = resolvedTokenInfo && resolvedTokenInfo.userInfo ? resolvedTokenInfo.userInfo : {};
          return userInfo;
        });
      })
      .catch(function (error) {
        throw error;
      });
  },

  postLoginWithApple: function (appleIdToken, hostedAuthOptions) {
    if (!Utils.getInstance().shouldShowAppleAuthButtons()) {
      return RSVP.Promise.reject(window.getI18n(ti18n, "APPLE_SIGN_IN_TEMPORARILY_UNAVAILABLE"));
    }

    if (this._isBrowserHostedAuthEnvironment()) {
      if (this._shouldUseHostedBrowserAuthPopup(hostedAuthOptions)) {
        return this._doLoginInPopup(true, {
          options: {
            provider: WORKOS_AUTH_PROVIDER_MAP.APPLE,
          },
        });
      }

      return this._startHostedBrowserAuthRedirect("login", this._getHostedBrowserLoginReturnUrl(), {
        provider: WORKOS_AUTH_PROVIDER_MAP.APPLE,
        pendingAction:
          hostedAuthOptions && hostedAuthOptions.pendingHostedAuthAction
            ? hostedAuthOptions.pendingHostedAuthAction
            : null,
      });
    }

    if (this._isCordovaHostedAuthEnvironment()) {
      return this._beginMobileHostedAuthFlow("login", {
        provider: WORKOS_AUTH_PROVIDER_MAP.APPLE,
      }).then(function (result) {
        return result && result.tokenInfo && result.tokenInfo.userInfo ? result.tokenInfo.userInfo : {};
      });
    }

    this._loginDoneWithToken = true;
    const apiSelf = this;
    const params = {
      appleIdToken: appleIdToken,
      language: window.getAppUsedLanguage(),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      environment: window.getAppEnvironment(),
    };
    return this._makeApiServerCall("loginWithAppleToken", params, "Do login with Apple token", true)
      .then(function (tokenInfo) {
        return apiSelf._finalizeAuthenticatedTokenInfo(tokenInfo).then(function (resolvedTokenInfo) {
          const userInfo = resolvedTokenInfo && resolvedTokenInfo.userInfo ? resolvedTokenInfo.userInfo : {};
          return userInfo;
        });
      })
      .catch(function (error) {
        throw error;
      });
  },

  postLoginWithGoogle: function (googleAccessToken, hostedAuthOptions) {
    if (this._isBrowserHostedAuthEnvironment()) {
      if (this._shouldUseHostedBrowserAuthPopup(hostedAuthOptions)) {
        return this._doLoginInPopup(true, {
          options: {
            provider: WORKOS_AUTH_PROVIDER_MAP.GOOGLE,
          },
        });
      }

      return this._startHostedBrowserAuthRedirect("login", this._getHostedBrowserLoginReturnUrl(), {
        provider: WORKOS_AUTH_PROVIDER_MAP.GOOGLE,
        pendingAction:
          hostedAuthOptions && hostedAuthOptions.pendingHostedAuthAction
            ? hostedAuthOptions.pendingHostedAuthAction
            : null,
      });
    }

    if (this._isCordovaHostedAuthEnvironment()) {
      return this._beginMobileHostedAuthFlow("login", {
        provider: WORKOS_AUTH_PROVIDER_MAP.GOOGLE,
      }).then(function (result) {
        return result && result.tokenInfo && result.tokenInfo.userInfo ? result.tokenInfo.userInfo : {};
      });
    }

    this._loginDoneWithToken = true;
    const apiSelf = this;
    const params = {
      googleAccessToken: googleAccessToken,
      language: window.getAppUsedLanguage(),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      environment: window.getAppEnvironment(),
    };
    return this._makeApiServerCall("loginWithGoogleToken", params, "Do login with Google token", true)
      .then(function (tokenInfo) {
        return apiSelf._finalizeAuthenticatedTokenInfo(tokenInfo).then(function (resolvedTokenInfo) {
          const userInfo = resolvedTokenInfo && resolvedTokenInfo.userInfo ? resolvedTokenInfo.userInfo : {};
          return userInfo;
        });
      })
      .catch(function (error) {
        throw error;
      });
  },

  getAllMyFavoritedSongs: function () {
    return this._makeApiServerCall("retrieveFavoritedSongs", {}, "Get my list of favorited Songs");
  },

  getMyFollowers: function () {
    return this._makeApiServerCall("getMyFollowers", {}, "Get my list of followers");
  },

  getMyFollowings: function () {
    return this._makeApiServerCall("getMyFollowings", {}, "Get my list of followings");
  },

  isTrebblePaidSubscriptionValid: function () {
    return this._makeApiServerCall(
      "isTrebblePaidSubscriptionValid",
      {},
      "Is Trebble paid subscription valid for logged in user",
    );
  },

  isStripeAccountFullySetupToReceivePayments: function () {
    return this._makeApiServerCall(
      "isStripeAccountFullySetupToReceivePayments",
      {},
      "Is Stripe Account Fully Setup To Receive Payments",
    );
  },

  hasPurchasedJourney: function (journeyRadioId) {
    return this._makeApiServerCall(
      "hasPurchasedJourney",
      { journeyRadioId: journeyRadioId },
      "Has User Purchased Journey",
    );
  },

  onMobileJourneyPurchaseApproved: function (foveaProduct, journeyRadioId) {
    return this._makeApiServerCall(
      "onMobileJourneyPurchaseApproved",
      { journeyRadioId: journeyRadioId, foveaProduct: foveaProduct },
      "On Mobile Journey Journey Purchased Approved",
    );
  },

  onMobileJourneyPurchaseVerified: function (foveaProduct, journeyRadioId) {
    return this._makeApiServerCall(
      "onMobileJourneyPurchaseVerified",
      { journeyRadioId: journeyRadioId, foveaProduct: foveaProduct },
      "On Mobile Journey Journey Purchased Approved",
    );
  },

  getCouponInfo: function (couponId) {
    return this._makeApiServerCall(
      "getCouponInfo",
      { couponId},
      "Get coupon info",
    );
  },

  getUrlToSetupStripe: function (forwardUrlOnOnboardingCompleted, forwardUrlOnOnboardingInterupted) {
    return this._makeApiServerCall(
      "getUrlToSetupStripe",
      {
        forwardUrlOnOnboardingCompleted: forwardUrlOnOnboardingCompleted,
        forwardUrlOnOnboardingInterupted: forwardUrlOnOnboardingInterupted,
        locale: window.getAppUsedLanguage(),
      },
      "Get Url to setup stripe",
    );
  },

  getStripeUrlForPurchasingJourney: function (
    journeyRadioId,
    forwardUrlOnPurchaseSuccessfull,
    forwardUrlOnPurchaseCancelled,
  ) {
    return this._makeApiServerCall(
      "getStripeUrlForPurchasingJourney",
      {
        journeyRadioId: journeyRadioId,
        forwardUrlOnPurchaseSuccessfull: forwardUrlOnPurchaseSuccessfull,
        forwardUrlOnPurchaseCancelled: forwardUrlOnPurchaseCancelled,
        locale: window.getAppUsedLanguage(),
      },
      "Get Url to setup stripe",
    );
  },

  getUrlToStripeDashboard: function () {
    return this._makeApiServerCall("getUrlToStripeDashboard", {}, "Get Url to Stripe Dashboard");
  },
  disconnectFromStripe: function () {
    return this._makeApiServerCall("disconnectFromStripe", {}, "Disconnect From Stripe", false, false, true);
  },

  deleteStripeAccount: function () {
    return this._makeApiServerCall("deleteStripeAccount", {}, "Delete stripe account", false, false, true);
  },

  createSubscriptionForCreatorPro: function (couponId) {
    return this._makeApiServerCall("createSubscriptionForCreatorPro", {couponId}, "Create subcription for creator pro ", false, false, true);
  },

  changeSubscriptionToCreatorPro: function (couponId) {
    return this._makeApiServerCall("changeSubscriptionToCreatorPro", {couponId}, "Change to subcription for creator pro ", false, false, true);
  },

  createSubscriptionForCreatorProPlus: function (couponId) {
    return this._makeApiServerCall(
      "createSubscriptionForCreatorProPlus",
      {couponId},
      "Create subcription for creator pro plus",
      false, false, true,
    );
  },

  changeSubscriptionToCreatorProPlus: function (couponId) {
    return this._makeApiServerCall(
      "changeSubscriptionToCreatorProPlus",
      {couponId},
      "Change to subcription for creator pro plus",
      false, false, true,
    );
  },

  createSubscriptionForCreatorProYearly: function (couponId) {
    return this._makeApiServerCall(
      "createSubscriptionForCreatorProYearly",
      {couponId},
      "Create subcription for creator pro yearly ",
      false, false, true,
    );
  },

  reactivateCreatorSubscription: function (couponId) {
    return this._makeApiServerCall("reactivateCreatorSubscription", {couponId}, "Reactivate creator subcription", false, false, true);
  },

  changeSubscriptionToCreatorProYearly: function (couponId) {
    return this._makeApiServerCall(
      "changeSubscriptionToCreatorProYearly",
      {couponId},
      "Change to subcription for creator pro yearly ",
      false, false, true,
    );
  },

  createSubscriptionForCreatorProPlusYearly: function (couponId) {
    return this._makeApiServerCall(
      "createSubscriptionForCreatorProPlusYearly",
      {couponId},
      "Create subcription for creator pro plus yearly",
      false, false, true,
    );
  },

  changeSubscriptionToCreatorProPlusYearly: function (couponId) {
    return this._makeApiServerCall(
      "changeSubscriptionToCreatorProPlusYearly",
      {couponId},
      "Change to subcription for creator pro plus yearly",
      false, false, true,
    );
  },

  cancelCreatorSubscription: function () {
    return this._makeApiServerCall("cancelCreatorSubscription", {}, "Cancel creator subscription", false, false, true);
  },

  getStripeCreatorCustomerPortalUrl: function (returnUrl, showPaymentMethodUpdate, showInvoiceHistory) {
    return this._makeApiServerCall(
      "getStripeCreatorCustomerPortalUrl",
      {
        returnUrl: returnUrl,
        showPaymentMethodUpdate: showPaymentMethodUpdate,
        showInvoiceHistory: showInvoiceHistory,
      },
      "get Stripe Creator Customer Portal Url",
      false, false, true,
    );
  },

  retriveUpcomingInvoiceForCreatorSubscriptionUpgradeToProPlan: function (yearlyBilling, couponId) {
    return this._makeApiServerCall(
      "retriveUpcomingInvoiceForCreatorSubscriptionUpgradeToProPlan",
      { yearlyBilling: yearlyBilling ,couponId},
      "Retrieve upcoming invoice for creator upgrading to pro plan",
      false, false, true,
    );
  },

  retriveUpcomingInvoiceForCreatorSubscriptionUpgradeToProPlusPlan: function (yearlyBilling, couponId) {
    return this._makeApiServerCall(
      "retriveUpcomingInvoiceForCreatorSubscriptionUpgradeToProPlusPlan",
      { yearlyBilling: yearlyBilling, couponId },
      "Retrieve upcoming invoice for creator upgrading to pro plus plan",
      false, false, true,
    );
  },

  retrievePaymentMethodUsedForCreatorSubscription: function () {
    return this._makeApiServerCall(
      "retrievePaymentMethodUsedForCreatorSubscription",
      {},
      "Retrieve default payment method used for creator subscription",
    );
  },

  getValidTrebblePaidSubscription: function () {
    return this._makeApiServerCall(
      "getValidTrebblePaidSubscription",
      {},
      "Get valid Trebble paid subscription valid for logged in user",
    );
  },

  getUserActiveCreatorPaidSubscription: function (includeDisplayablePaymentMethod) {
    return this._makeApiServerCall(
      "getUserActiveCreatorPaidSubscription",
      { includeDisplayablePaymentMethod: includeDisplayablePaymentMethod },
      "Get active Trebble creator paid subscription valid for logged in user",
    );
  },

  getSecretToSetupPaymentIntent: function () {
    return this._makeApiServerCall("getSecretToSetupPaymentIntent", {}, "Get secret to setup payment intent", false, false, true);
  },

  getNumberOfMinutesOfTranscriptionLeft: function () {
    return this._makeApiServerCall("getNumberOfMinutesOfTranscriptionLeft", {}, "Get minutes of transcription left");
  },

  enhanceSpeechInFile : function(fileLocationToEnhance, transcriptionJobId, workspaceId){
    const effectiveWorkspaceId = this._resolveWorkspaceIdForScopedMutation(workspaceId);
    return this._makeApiServerCall(
      "enhanceSpeechInFile",
      this._appendWorkspaceIdParam({ fileLocationToEnhance, transcriptionJobId }, effectiveWorkspaceId),
      "Enhance speech in file",
    );
  },

  startVideoRenderingInCloud : function(capsuleId, projectId, audioFileUrl, srtFileUrl, useTemporaryLocation, ffmpegCommandJsonUrl, workspaceId){
    const effectiveWorkspaceId = this._resolveWorkspaceIdForScopedMutation(workspaceId);
    return this._makeApiServerCall(
      "startVideoRenderingProcess",
      this._appendWorkspaceIdParam({ capsuleId, projectId, audioFileUrl, srtFileUrl, useTemporaryLocation, ffmpegCommandJsonUrl }, effectiveWorkspaceId),
      "start video rendering in the cloud",
    );
  },

  startClipVideoRenderingInCloud : function(projectId, audioFileUrl, srtFileUrl, useTemporaryLocation, remotionRenderingInputData, remotionRenderingInputDataJsonUrl, relatedProjectId, workspaceId){
    const effectiveWorkspaceId = this._resolveWorkspaceIdForScopedMutation(workspaceId);
    return this._makeApiServerCall(
      "startClipVideoRenderingRequest",
      this._appendWorkspaceIdParam({
        projectId,
        audioFileUrl,
        srtFileUrl,
        useTemporaryLocation,
        remotionRenderingInputDataString: JSON.stringify(remotionRenderingInputData),
        remotionRenderingInputDataJsonUrl,
        relatedProjectId,
      }, effectiveWorkspaceId),
      "start video clip rendering in the cloud",
    );
  },

  createCapsuleFromProjectIdAndAudioUrl: function(projectName, projectId, audioUrl){
    return this._makeApiServerCall("createCapsuleFromProjectIdAndAudioUrl", {  projectName, projectId, audioUrl}, "create capsule from project id and audio url");
  },

  getPresignedUrlForUploadingFFMPEGCommands : function(){
    return this._makeApiServerCall("getPresignedUrlForUploadingFFMPEGCommands", {}, "get presigned url for uploading ffmpeg commands");
  },

  getPresignedUrlForUploadingRemotionClipRenderingInputData : function(){
    return this._makeApiServerCall("getPresignedUrlForUploadingRemotionClipRenderingInputData", {}, "get presigned url for uploading remotion video clip creation input");
  },

  // Timeloom (Remotion) rendering methods
  startTimeloomVideoRenderingInCloud : function(projectId, capsuleId, audioFileUrl, srtFileUrl, useTemporaryLocation, remotionRenderingInputData, remotionRenderingInputDataJsonUrl, workspaceId){
    const effectiveWorkspaceId = this._resolveWorkspaceIdForScopedMutation(workspaceId);
    return this._makeApiServerCall(
      "startTimeloomVideoRenderingRequest",
      this._appendWorkspaceIdParam({
        projectId,
        capsuleId,
        audioFileUrl,
        srtFileUrl,
        useTemporaryLocation,
        remotionRenderingInputDataString: JSON.stringify(remotionRenderingInputData),
        remotionRenderingInputDataJsonUrl,
      }, effectiveWorkspaceId),
      "start timeloom video rendering in the cloud",
    );
  },

  getPresignedUrlForUploadingTimeloomRenderingInputData : function(){
    return this._makeApiServerCall("getPresignedUrlForUploadingTimeloomRenderingInputData", {}, "get presigned url for uploading timeloom rendering input data");
  },

  getPresignedUrlForUploadingSrtFile : function(){
    return this._makeApiServerCall("getPresignedUrlForUploadingSrtFile", {}, "get presigned url for uploading srt file");
  },

  getPresignedUrlForUploadingTemporaryAudioOrVideoFile: function(mimeType){
    return this._makeApiServerCall("getPresignedUrlForUploadingTemporaryAudioOrVideoFile", {mimeType}, "get presigned url for uploading temporaru audio or video file");
  },

  /**
   * Request a presigned S3 upload URL for a generated project video thumbnail.
   * The thumbnail route returns its payload at the top level, so this method
   * uses _makeApiServerCall's raw-response option to preserve that payload.
   *
   * @param {string} capsuleId - Capsule/project identifier used by the thumbnail API
   * @returns {Promise<{presignedUrl: string, key: string}>}
   */
  getVideoThumbnailPresignedUrl: function (capsuleId) {
    return this._makeApiServerCall(
      "api/v1/video/thumbnail/presign",
      { capsuleId },
      "Video Thumbnail: Get presigned upload URL",
      false,
      false,
      false,
      false,
      { unwrapMessage: false }
    );
  },

  /**
   * Persist the S3 URL for a generated project video thumbnail.
   *
   * @param {string} capsuleId - Capsule/project identifier used by the thumbnail API
   * @param {string} thumbnailS3Url - S3 URL returned after thumbnail upload
   * @returns {Promise<*>}
   */
  recordVideoThumbnailUrl: function (capsuleId, thumbnailS3Url) {
    return this._makeApiServerCall(
      "api/v1/video/thumbnail/record",
      { capsuleId, thumbnailS3Url },
      "Video Thumbnail: Record thumbnail URL"
    );
  },

  getPresignedUrlForUploadingSearchOnMediaTranscriptionInputData: function(transcriptionId, projectId){
    return this._makeApiServerCall("getPresignedUrlForUploadingSearchOnMediaTranscriptionInputData", {projectId, transcriptionId }, "get presigned url for uploading search on media transcription input data");
  },

  startAISearchOnMediaTranscription: function(transcriptionId, projectId, fileLocationOfMediaTranscriptionWithIds, searchQueryPresetsArray, numberOfTokens, isVideo, languageCode , llmProvider, preprocessedDeepCutAnalysisResults, force, isEditLikeMeMode, referenceProjectId){
    return this._makeApiServerCall("startAISearchOnMediaTranscription", { transcriptionId, projectId, fileLocationOfMediaTranscriptionWithIds, searchQueryPresetsArray, numberOfTokens, isVideo, languageCode,llmProvider, preprocessedDeepCutAnalysisResults, force, isEditLikeMeMode, referenceProjectId},"Start AI Search On Media Transcription");
  },

  getEditedProjectsForUser: function(numberOfResults, pageOffset, searchKeyword, workspaceId) {
    return this._makeApiServerCall(
      "getEditedProjectsForUser",
      this._appendWorkspaceIdParam({ numberOfResults, pageOffset, searchKeyword }, workspaceId),
      "Get edited projects for user",
      false,
      false,
      false
    );
  },

  getReferenceProjectData: function(projectId) {
    return this._makeApiServerCall("getReferenceProjectData", { projectId }, "Get reference project data");
  },

  getSuggestionResultUrlForRequestId : function(requestId){
    return this._makeApiServerCall("getSuggestionResultUrlForRequestId", { requestId}, "Get suggestion result url for request id ");
  },

  /**
   * Record DeepCut/Edit-Like-Me suggestion feedback labels through the backend API.
   * @param {Array<Object>} events Batched feedback events to write idempotently.
   * @returns {Promise} Backend API response.
   */
  recordSuggestionFeedback : function(events){
    return this._makeApiServerCall("recordSuggestionFeedback", { events }, "Record suggestion feedback");
  },

  classifyAudio : function(audioUrl, filename){
    return this._makeApiServerCall("classifyAudio", { audioUrl, filename }, "Classify audio file");
  },

  batchClassifyAudio : function(audioFiles){
    return this._makeApiServerCall("batchClassifyAudio", { audioFiles }, "Batch classify audio files");
  },

  saveAudioClassificationUserSelection : function(audioUrl, selectedType, selectedLabel, locale){
    return this._makeApiServerCall("saveAudioClassificationUserSelection", { audioUrl, selectedType, selectedLabel, locale }, "Save Audio Classification User Selection");
  },

  getAIEditsForMediaTranscription: function(transcriptionId, projectId, searchQueryPresetsArray, strictMatch){
    return this._makeApiServerCall("getAIEditsForMediaTranscription", { transcriptionId, projectId, searchQueryPresetsArray , strictMatch},"Get ai edits for media transcription");
  },

  getEnhancedFileUrlForMediaFile : function(fileLocationToEnhance){
    return this._makeApiServerCall("getEnhancedFileUrlForMediaFile", {fileLocationToEnhance}, "Get enhanced file url for media file");
  },

  getZendeskToken: function () {
    return this._makeApiServerCall("getZendeskToken", {}, "Get Zendesk Token");
  },

  getTawkToToken: function () {
    return this._makeApiServerCall("getTawkToToken", {}, "Get TawkTo Token");
  },

  getTranscriptionInfo: function (transcriptionId) {
    return this._makeApiServerCall(
      "getTranscriptionInfo",
      { transcriptionId: transcriptionId },
      "Get transcription info",
    );
  },

  findTranscriptionInfoForAudio: function (audioUrl, language) {
    return this._makeApiServerCall(
      "findTranscriptionInfoForAudio",
      { audioUrl, language },
      "Find transcription info for audio",
    );
  },

  preprocessTransriptionForDeepcut: function (transcript, selectedIntent, userDirectives, platformType, contentType, customDirectives, probingQuestionAnswers, userFlow, referenceRequestUID, transcriptionId, projectId, referenceProjectId, isEditLikeMeMode, locale) {
    // Transform to match lambda function expectations
    const requestData = {
      action: 'analyze',
      transcript: transcript,
      selectedIntent: selectedIntent,
      userDirectives: userDirectives,
      platformType: platformType,
      contentType: contentType,
      customDirectives: customDirectives,
      probingQuestionAnswers: probingQuestionAnswers,
      userFlow: userFlow || {}
    };

    // Add referenceRequestUID if provided
    if (referenceRequestUID) {
      requestData.referenceRequestUID = referenceRequestUID;
    }

    // Add transcriptionId and projectId if provided
    if (transcriptionId) {
      requestData.transcriptionId = transcriptionId;
    }
    if (projectId) {
      requestData.projectId = projectId;
    }

    // Edit Like Me fields
    if (referenceProjectId) {
      requestData.referenceProjectId = referenceProjectId;
    }
    if (isEditLikeMeMode) {
      requestData.isEditLikeMeMode = isEditLikeMeMode;
    }

    // Locale for language-aware processing
    if (locale) {
      requestData.locale = locale;
    }

    return this._makeApiServerCall(
      "preprocessTransriptionForDeepcut",
      requestData,
      "Preprocess transcription for deepcut analysis",
    );
  },

  updateEditingPlan: function (originalPlan, userAnswer, referenceRequestUID) {
    const requestData = {
      action: 'update-plan',
      originalPlan: originalPlan,
      userAnswer: userAnswer
    };
    
    // Add referenceRequestUID if provided
    if (referenceRequestUID) {
      requestData.referenceRequestUID = referenceRequestUID;
    }
    
    return this._makeApiServerCall(
      "preprocessTransriptionForDeepcut",
      requestData,
      "Update editing plan based on user feedback",
    );
  },

  executeEditingPlan: function (executePlanData, referenceRequestUID) {
    const requestData = {
      action: 'execute-plan',
      executePlanData: executePlanData
    };
    
    // Add referenceRequestUID if provided
    if (referenceRequestUID) {
      requestData.referenceRequestUID = referenceRequestUID;
    }
    
    return this._makeApiServerCall(
      "preprocessTransriptionForDeepcut",
      requestData,
      "Execute editing plan",
    );
  },

  startEditing: function (referenceRequestUID) {
    const requestData = {
      action: 'start-editing'
    };

    // Add referenceRequestUID if provided
    if (referenceRequestUID) {
      requestData.referenceRequestUID = referenceRequestUID;
    }

    return this._makeApiServerCall(
      "preprocessTransriptionForDeepcut",
      requestData,
      "Start editing process",
    );
  },

  getDeepCutRequestStatus: function (requestId) {
    return this._makeApiServerCall(
      "getDeepCutRequestStatus",
      { requestId: requestId },
      "Get DeepCut request status",
    );
  },

  getTranscribedFiles: function (searchKeyword, pageOffset, numberOfResults, workspaceId) {
    const effectiveWorkspaceId = workspaceId === undefined ? this._resolveActiveWorkspaceId() : workspaceId;
    return this._makeApiServerCall(
      "getTranscribedFiles",
      this._appendWorkspaceIdParam({
        searchKeyword: searchKeyword,
        numberOfResults: numberOfResults,
        pageOffset: pageOffset,
      }, effectiveWorkspaceId),
      "Get transcribed  files",
      false,
      false,
      false,
    );
  },

  getSequencerProjects: function (searchKeyword, pageOffset, numberOfResults, referenceProjectOnly, workspaceId) {
    return this._makeApiServerCall(
      "getSequencerProjects",
      this._appendWorkspaceIdParam({
        searchKeyword: searchKeyword,
        numberOfResults: numberOfResults,
        pageOffset: pageOffset,
        referenceProjectOnly: referenceProjectOnly,
      }, workspaceId),
      "Get sequencer projects  files",
      false,
      false,
      false,
    );
  },

  /**
   * Grouped edit-history listing. Unlike getSequencerProjects, which returns
   * raw version docs and forces the client to fetch every page to group them,
   * this endpoint groups by referenceProjectUID server-side and paginates
   * over GROUPS. Use this for the /edithistory page — one call per scroll
   * page instead of an unbounded while-loop.
   */
  listEditHistoryGrouped: function (params) {
    var requestParams = Object.assign({}, params || {});
    if (requestParams.searchKeyword === null || requestParams.searchKeyword === undefined) {
      delete requestParams.searchKeyword;
    }
    if (requestParams.workspaceId === undefined) {
      delete requestParams.workspaceId;
    }
    return this._makeApiServerCall(
      "api/v1/editHistory/listGrouped",
      requestParams,
      "List Edit History (Grouped)",
      false,
      false,
      false,
    );
  },

  getUserProcessedCreatorPaidSubscription: function () {
    return this._makeApiServerCall(
      "getUserProcessedCreatorPaidSubscription",
      {},
      "Get processed Trebble creator paid subscription valid for logged in user",
    );
  },

  getMyCompleteUserInfo: function () {
    return this._makeApiServerCall("getCompleteUserInfo", {}, "Get my complete user info");
  },

  getAllMyCapsules: function () {
    return this._makeApiServerCall("getAllMyCapsules", {}, "Get All My Capsules");
  },

  getEpidemicSoundToken: function () {
    return this._makeApiServerCall("getEpidemicSoundToken", {}, "Get Epidemic Sound Token");
  },

  searchForAllUsers: function (keyword, numberOfResults, startPage) {
    return this._makeApiServerCall(
      "searchForAllUsers",
      {
        keyword: keyword,
        numberOfResults: numberOfResults,
        startPage: startPage,
      },
      "Search for Users",
    );
  },

  searchForCities: function (keyword, language) {
    return this._makeApiServerCall(
      "searchForCities",
      {
        keyword: keyword,
        language: language,
      },
      "Search for Cities",
      true,
    );
  },

  getCityInfo: function (placeId, language) {
    return this._makeApiServerCall(
      "getCityInfo",
      {
        placeId: placeId,
        language: language,
      },
      "Get City Info",
      true,
    );
  },

  followUserByUsername: function (usernameOfUserToFollow) {
    return this._makeApiServerCall(
      "followUserByUsername",
      {
        usernameOfUserToFollow: usernameOfUserToFollow,
      },
      "Follow User By Username",
      false,
      false,
      true,
    );
  },

  unfollowUserByUsername: function (usernameOfUserToUnfollow) {
    return this._makeApiServerCall(
      "unfollowUserByUsername",
      {
        usernameOfUserToUnfollow: usernameOfUserToUnfollow,
      },
      "UnFollow User By Username",
      false,
      false,
      true,
    );
  },

  followTrebble: function (trebbleId) {
    return this._makeApiServerCall(
      "followRadioByRadioId",
      {
        radioIdToFollow: trebbleId,
      },
      "Follow Trebble",
      false,
      false,
      true,
    );
  },

  followJourney: function (journeyRadioId) {
    return this._makeApiServerCall(
      "followJourneyByJourneyRadioId",
      {
        journeyRadioIdToFollow: journeyRadioId,
      },
      "Follow Trebble",
      false,
      false,
      true,
    );
  },

  getJourneyStats: function (radioId) {
    return this._makeApiServerCall(
      "getStatsForJourney",
      {
        radioId: radioId,
      },
      "Get Stats for Journey",
      false,
      false,
      true,
    );
  },

  getJourneyOwner: function (journeyRadioId) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "getJourneyOwner",
      {
        journeyRadioId: journeyRadioId,
      },
      "Get Journey Owner",
      shouldSkipLogin,
      false,
      false,
    );
  },

  unfollowTrebble: function (trebbleId) {
    return this._makeApiServerCall(
      "unfollowRadioByRadioId",
      {
        radioIdToUnfollow: trebbleId,
      },
      "Unfollow Trebble",
      false,
      false,
      true,
    );
  },

  unfollowJourney: function (journeyRadioId) {
    return this._makeApiServerCall(
      "unfollowJourneyByJourneyRadioId",
      {
        journeyRadioIdToUnfollow: journeyRadioId,
      },
      "Unfollow Journey",
      false,
      false,
      true,
    );
  },

  getIdifiedSongInfoBySongTitle: function (songTitle, artistName, albumName) {
    return this._makeApiServerCall(
      "identifySongBySongInfo",
      {
        songTitle: songTitle,
        artistName: artistName,
        albumName: albumName,
      },
      "get gracenote song info by song title and artist name",
      false,
    );
  },

  getTokenInfo: function (token) {
    return this._makeApiServerCall(
      "getTokenInfo",
      {
        token: token,
      },
      "retrieve token info using token",
      true,
    );
  },

  getMyTrebbleInfoByTrebbleId: function (trebbleId) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "getRadioInfoByRadioId",
      {
        radioId: trebbleId,
      },
      "Get a trebble info via trebble id",
      shouldSkipLogin,
    );
  },

  getJourneyInfoByJourneyRadioId: function (journeyRadioId) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "getJourneyRadioInfoByJourneyRadioId",
      {
        journeyRadioId: journeyRadioId,
      },
      "Get a journey radio info via journey radio id",
      shouldSkipLogin,
    );
  },

  createAJourneyDraft: function (journeyRadioId) {
    return this._makeApiServerCall(
      "createAJourneyDraft",
      {
        radioId: journeyRadioId,
      },
      "create journey draft",
    );
  },

  deletAJourney: function (journeyRadioId) {
    return this._makeApiServerCall(
      "deletAJourney",
      {
        radioId: journeyRadioId,
      },
      "delete a journey",
    );
  },

  
getTheme: function (themeId) {
  return this._makeApiServerCall(
      `getTheme/${themeId}`,
      {
          id: themeId
      },
      "Get a theme by ID"
  );
},

getThemes: function (filters = {}, workspaceId) {
  return this._makeApiServerCall(
      "getThemes",
      this._appendWorkspaceIdParam({filters}, workspaceId),
      "Get all themes with optional filters"
  );
},

createTheme: function (themeData, workspaceId) {
  const effectiveWorkspaceId = this._resolveWorkspaceIdForScopedMutation(workspaceId);
  return this._makeApiServerCall(
      "createTheme",
      this._appendWorkspaceIdParam({themeDataString: JSON.stringify(themeData)}, effectiveWorkspaceId),
      "Create a new theme"
  );
},

updateTheme: function (themeId, themeData, workspaceId) {
  const effectiveWorkspaceId = this._resolveWorkspaceIdForScopedMutation(workspaceId);
  return this._makeApiServerCall(
      `updateTheme/${themeId}`,
      this._appendWorkspaceIdParam({
          id: themeId,
          themeDataString: JSON.stringify(themeData),
      }, effectiveWorkspaceId),
      "Update an existing theme"
  );
},

deleteTheme: function (themeId, workspaceId) {
  return this._makeApiServerCall(
      `deleteTheme/${themeId}`,
      this._appendWorkspaceIdParam({
          id: themeId
      }, workspaceId),
      "Delete a theme"
  );
},

// Add these methods to the TrebbleClientAPI object
getTemplate: function (templateId) {
  return this._makeApiServerCall(
      "getTemplate",
      {
          id: templateId
      },
      "Get a template by ID"
  );
},

getTemplates: function (filters = {}, workspaceId) {
  return this._makeApiServerCall(
      "getTemplates",
      this._appendWorkspaceIdParam(filters, workspaceId),
      "Get all templates with optional filters"
  );
},

createTemplate: function (templateData, workspaceId) {
  const effectiveWorkspaceId = this._resolveWorkspaceIdForScopedMutation(workspaceId);
  return this._makeApiServerCall(
      "createTemplate",
      this._appendWorkspaceIdParam({templateDataString: JSON.stringify(templateData)}, effectiveWorkspaceId),
      "Create a new template"
  );
},

updateTemplate: function (templateId, templateData, workspaceId) {
  return this._makeApiServerCall(
      `updateTemplate/${templateId}`,
      this._appendWorkspaceIdParam({
          id: templateId,
          templateDataString: JSON.stringify(templateData),
      }, workspaceId),
      "Update an existing template"
  );
},

deleteTemplate: function (templateId, workspaceId) {
  return this._makeApiServerCall(
      `deleteTemplate/${templateId}`,
      this._appendWorkspaceIdParam({
          id: templateId
      }, workspaceId),
      "Delete a template"
  );
},

  getRadioInfoAndCapsuleInfoByShortcastId: function (shortcastId) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "getRadioInfoAndCapsuleInfoByShortcastId",
      {
        episodeUID: shortcastId,
      },
      "Get capsules and radio info via shortcast id",
      shouldSkipLogin,
    );
  },

  getCapsulesInDraftJourney: function (journeyRadioId) {
    return this._makeApiServerCall(
      "getCapsulesInDraftJourney",
      {
        journeyRadioId: journeyRadioId,
      },
      "Get Capsules In Draft Journey",
    );
  },

  getCapsulesInAvailableJourney: function (journeyRadioId) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "getCapsulesInAvailableJourney",
      {
        journeyRadioId: journeyRadioId,
      },
      "Get Capsules In Available Journey",
      shouldSkipLogin,
    );
  },

  getTrailerForDraftJourney: function (journeyRadioId) {
    return this._makeApiServerCall(
      "getCapsuleUsedAsTrailerInDraftJourney",
      {
        journeyRadioId: journeyRadioId,
      },
      "Get Trailer For Draft Journey",
    );
  },

  getTrailerForAvailableJourney: function (journeyRadioId) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "getCapsuleUsedAsTrailerInPublishedJourney",
      {
        journeyRadioId: journeyRadioId,
      },
      "Get Trailer For Available Journey",
      shouldSkipLogin,
    );
  },

  addCapsuleAsTrailerToDraftJourney: function (capsuleId, journeyRadioId) {
    return this._makeApiServerCall(
      "addCapsuleAsTrailerToDraftJourney",
      {
        radioId: journeyRadioId,
        capsuleId: capsuleId,
      },
      "Clear Journey Trailer",
    );
  },

  clearJourneyTrailer: function (journeyRadioId) {
    return this._makeApiServerCall(
      "clearJourneyTrailer",
      {
        radioId: journeyRadioId,
      },
      "Clear Journey Trailer",
    );
  },

  getCapsulesInAvailableJourneyWithProgress: function (journeyRadioId) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "getCapsulesInAvailableJourneyWithProgress",
      {
        journeyRadioId: journeyRadioId,
      },
      "Get Capsules In Available Journey with progress",
      shouldSkipLogin,
    );
  },

  getCapsulesInDraftJourneyWithProgress: function (journeyRadioId) {
    return this._makeApiServerCall(
      "getCapsulesInDraftJourneyWithProgress",
      {
        journeyRadioId: journeyRadioId,
      },
      "Get Capsules In Draft Journey with progress",
    );
  },

  addCapsulesToDraftJourney: function (capsuleId, journeyRadioId) {
    return this._makeApiServerCall(
      "addCapsulesToDraftJourney",
      {
        radioId: journeyRadioId,
        capsuleId: capsuleId,
      },
      "Add Capsules To Draft Journey",
    );
  },

  archivePublishedJourney: function (journeyRadioId) {
    return this._makeApiServerCall(
      "archivePublishedJourney",
      {
        radioId: journeyRadioId,
      },
      "Archive Published Journey",
    );
  },

  logRadioPageVisited: function (radioId) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "logRadioPageVisited",
      {
        radioId: radioId,
      },
      "Log Radio Page was visited",
      shouldSkipLogin,
    );
  },

  logRadioTrailerPlayed: function (radioId) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "logRadioTrailerPlayed",
      {
        radioId: radioId,
      },
      "Log Journey Trailer Played",
      shouldSkipLogin,
    );
  },

  removeCapsulesToDraftJourney: function (capsuleId, journeyRadioId) {
    return this._makeApiServerCall(
      "removeCapsulesToDraftJourney",
      {
        radioId: journeyRadioId,
        capsuleId: capsuleId,
      },
      "Remove Capsules From Draft Journey",
    );
  },

  publishJourney: function (journeyRadioId, availabilityDate, timezone, context) {
    return this._makeApiServerCall(
      "publishJourney",
      {
        radioId: journeyRadioId,
        availabilityDate: availabilityDate,
        timezone: timezone,
        context: context,
      },
      "Publish Journey",
    );
  },

  revertToDraft: function (journeyRadioId, context) {
    return this._makeApiServerCall(
      "cancelScheduledJourney",
      {
        radioId: journeyRadioId,
        context: context,
      },
      "revert journey to draft",
    );
  },

  trackCapsuleDownload: function (capsuleId, downloadedUrl, downloadType, projectId) {
    return this._makeApiServerCall(
      "trackCapsuleDownload",
      {
        capsuleId: capsuleId,
        downloadedUrl: downloadedUrl,
        downloadType: downloadType,
        projectId
      },
      "track Capsule Download",
    );
  },

  removeFromArchive: function (journeyRadioId, context) {
    return this._makeApiServerCall(
      "removeJourneyFromArchive",
      {
        radioId: journeyRadioId,
        context: context,
      },
      "remove journey from archive",
    );
  },

  changeJourneyPublishedDate: function (journeyRadioId, availabilityDate, timezone, context) {
    return this._makeApiServerCall(
      "changeJourneyPublishedDate",
      {
        radioId: journeyRadioId,
        availabilityDate: availabilityDate,
        timezone: timezone,
        context: context,
      },
      "Change Journey Scheduled Date",
    );
  },

  getMyCompleteTrebbleInfoByTrebbleId: function (trebbleId) {
    return this._makeApiServerCall(
      "getRadioCompleteInfoByRadioId",
      {
        radioId: trebbleId,
      },
      "Get my complete trebble info via trebble id",
    );
  },

  getMyCompleteJourneyInfoByTrebbleId: function (trebbleId) {
    return this._makeApiServerCall(
      "getJourneyCompleteInfoByRadioId",
      {
        radioId: trebbleId,
      },
      "Get my complete journey info via trebble id",
    );
  },

  getHostUserIdByTrebbleId: function (trebbleId) {
    return this._makeApiServerCall(
      "getHostUserIdByRadioId",
      {
        radioId: trebbleId,
      },
      "Get host user id by trebble id",
    );
  },

  getMyTrebbleInfoByTrebbleCustomURL: function (customURL) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "getRadioInfoByRadioCustomURL",
      {
        customURL: customURL,
      },
      "Get a trebble info via custom url",
      shouldSkipLogin,
    );
  },

  getCapsuleInfoByCapsuleId: function (capsuleId) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "getCapsuleInfoByCapsuleId",
      {
        capsuleId: capsuleId,
      },
      "Get a capsule info",
      shouldSkipLogin,
    );
  },

  getCategoryIdsForRadioWithContent: function (language) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "getCategoryIdsForRadioWithContent",
      {
        language: language,
      },
      "Get category ids for available Trebble with audio preview",
      shouldSkipLogin,
    );
  },

  getCategoryIdsAvailableForShortcastRadio: function (language) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "getCategoryIdsAvailableForShortcastRadio",
      {
        language: language,
      },
      "Get category ids  available for shortcast radio",
      shouldSkipLogin,
    );
  },

  getCityInfoForRadioWithContentForSpecificLanguage: function (language, i18nLanguage) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "getCityInfoForRadioWithContentForSpecificLanguage",
      {
        language: language,
        i18nLanguage: i18nLanguage,
      },
      "Get city info for available Trebble with audio preview for specific language",
      shouldSkipLogin,
    );
  },

  getLanguagesForRadioWithContent: function (categoryId) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "getLanguageForRadioWithContent",
      {
        categoryId: categoryId,
      },
      "Get languages for available Trebble with audio preview",
      shouldSkipLogin,
    );
  },

  getLanguagesForRadioWithContentForSpecificCity: function (cityId) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "getLanguageForRadioWithContentForSpecificCity",
      {
        cityId: cityId,
      },
      "Get languages for available Trebble with audio preview for specific city",
      shouldSkipLogin,
    );
  },

  getCapsuleForSongCreatedFromCapsuleInfo: function (songJson) {
    return this._makeApiServerCall(
      "getCapsuleForSongCreatedFromCapsuleInfo",
      { song: songJson },
      "Get capsule client json for song created from capsule info",
    );
  },

  getNumberOfUnreadNotification: function () {
    return this._makeApiServerCall(
      "getNumberOfUnreadNotificationForLoggedInUser",
      {},
      "Get number of unread notifications",
      true,
    );
  },

  markUnreadNotificationAsRead: function () {
    return this._makeApiServerCall(
      "markUnreadNotificationForLoggedInUserAsRead",
      {},
      "mark unread notifications as read",
    );
  },

  getSongInfoBySongId: function (songId) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "getSongInfoBySongId",
      {
        songId: songId,
      },
      "Get a song info",
      shouldSkipLogin,
    );
  },

  getFollowersForUserWithUsername: function (username) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "getFollowersForUserByUsername",
      {
        username: username,
      },
      "Get Followers for User with username",
      shouldSkipLogin,
    );
  },

  getFollowedTrebblesForUserWithUsername: function (username) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "getFollowedTrebblesForUserWithUsername",
      {
        username: username,
      },
      "Get Followed Trebbles for User with username",
      shouldSkipLogin,
    );
  },

  getMyJourneys: function () {
    return this._makeApiServerCall("getMyJourneys", {}, "Get my journeys");
  },

  saveMyTrebbleSubscriptionOrder: function (orderedTrebbleIds) {
    return this._makeApiServerCall(
      "saveMyTrebbleSubscriptionOrder",
      {
        orderedTrebbleIds: orderedTrebbleIds,
      },
      "Save My Trebble Subscription Order",
    );
  },

  saveShortcastOrderInJourney: function (radioId, orderedShortcastIds) {
    return this._makeApiServerCall(
      "saveShortcastOrderInJourney",
      {
        radioId: radioId,
        orderedShortcastIds: orderedShortcastIds,
      },
      "Save Shortcast Order In Journey",
    );
  },

  getFollowingsForUserWithUsername: function (username) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "getFollowingsForUserByUsername",
      {
        username: username,
      },
      "Get Followings for User with username",
      shouldSkipLogin,
    );
  },

  getCommentInfoByCommentId: function (commentId) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "getCommentInfoByCommentId",
      {
        commentId: commentId,
      },
      "Get a comment info",
      shouldSkipLogin,
    );
  },

  getNotificationCustomPayloadByNotificationId: function (notificationId) {
    return this._makeApiServerCall(
      "getNotificationCustomPayloadByNotificationId",
      {
        notificationId: notificationId,
      },
      "Get custom payload by notification Id",
    );
  },

  getCapsulesInfoForSong: function (songJson, songRefSummary) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "getCapsulesInfoForSong",
      {
        songJson: songJson,
        songRefSummary: songRefSummary,
      },
      "Get all capsules info for song",
      shouldSkipLogin,
    );
  },

  getAllCapsulesForShortcastId: function (shortcastId) {
    return this._makeApiServerCall(
      "getAllCapsulesForShortcastId",
      {
        episodeUID: shortcastId,
      },
      "Get all capsules for shortcast",
    );
  },

  getCapsuleCoverArtUrl: function (capsuleId) {
    return this._makeApiServerCall(
      "getCapsuleCoverArtUrl",
      {
        capsuleId: capsuleId,
      },
      "Get Capsule Cover Art Url By Capsule Id",
    );
  },

  getCapsuleCoverArtImages: function (capsuleId) {
    return this._makeApiServerCall(
      "getCapsuleCoverArtImages",
      {
        capsuleId: capsuleId,
      },
      "Get Capsule Cover Art images info By Capsule Id",
    );
  },

  getCommentsInfoForSong: function (songJson, songRefSummary) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "getCommentsInfoForSong",
      {
        songJson: songJson,
        songRefSummary: songRefSummary,
      },
      "Get all comments for song",
      shouldSkipLogin,
    );
  },

  getCommentsInfoForCapsule: function (capsuleId, songRefSummary) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "getCommentsInfoForCapsule",
      {
        capsuleId: capsuleId,
        songRefSummary: songRefSummary,
      },
      "Get all comments for Capsule",
      shouldSkipLogin,
    );
  },

  getRepliesForComment: function (commentId) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "getRepliesForComment",
      {
        commentId: commentId,
      },
      "Get replies for comment",
      shouldSkipLogin,
    );
  },

  isRadioWithSameCustomURL: function (customURL, radioId) {
    return this._makeApiServerCall(
      "isRadioWithSameCustomURL",
      {
        radioId: radioId,
        customURL: customURL,
      },
      "Check radio exist with the same custom URL",
      true,
    );
  },

  isUrlASupportedFeed: function (rssFeedUrl) {
    return this._makeApiServerCall(
      "isUrlASupportedFeed",
      {
        feedUrl: rssFeedUrl,
      },
      "Check is RSS Feed URL is valid",
      true,
    );
  },

  getGeneratedCustomURLFromTrebbleName: function (trebbleName) {
    return this._makeApiServerCall(
      "getGeneratedCustomURLFromTrebbleName",
      {
        trebbleName: trebbleName,
      },
      "get generated custom URL from Trebble Name",
      true,
    );
  },

  isRadioWithSameName: function (name, radioId) {
    return this._makeApiServerCall(
      "isRadioWithSameName",
      {
        name: name,
        radioId: radioId,
      },
      "Check radio exist with the same name",
      true,
    );
  },

  isUserWithSameUsername: function (username, userId) {
    return this._makeApiServerCall(
      "isUsernameAlreadyInUse",
      {
        username: username,
        userId: userId,
      },
      "Check if user with the same username exist",
      true,
    );
  },

  isUserWithSameEmail: function (email, userId) {
    return this._makeApiServerCall(
      "isEmailAlreadyInUse",
      {
        email: email,
        userId: userId,
      },
      "Check if user with the same email exist",
      true,
    );
  },

  verifyBetaAccessCode: function (accessCode) {
    return this._makeApiServerCall(
      "verifyBetaAccessCode",
      {
        accessCode: accessCode,
      },
      "Check access code",
      true,
    );
  },

  updateCapsuleTitleAndNotes: function (capsuleId, title, notes) {
    return this._makeApiServerCall(
      "updateCapsuleTitleAndNotes",
      {
        capsuleId: capsuleId,
        title: title,
        notes: notes,
      },
      "Update shortcast info",
    );
  },

  updateTrebbleInfoByTrebbleId: function (
    trebbleId,
    name,
    description,
    customURL,
    categoryId,
    cityId,
    timezone,
    language,
    syncWithRssFeed,
    rssFeedUrlContentSource,
  ) {
    return this._makeApiServerCall(
      "UpdateRadioInfoByRadioId",
      {
        radioId: trebbleId,
        name: name,
        description: description,
        customURL: customURL,
        categoryId: categoryId,
        cityId: cityId,
        timezone: timezone,
        language: language,
        syncWithRssFeed: syncWithRssFeed,
        rssFeedUrlContentSource: rssFeedUrlContentSource,
      },
      "Update a trebble info",
    );
  },

  updateJourneyInfo: function (
    trebbleId,
    name,
    goal,
    description,
    categoryId,
    cityId,
    timezone,
    language,
    isPaid,
    costInUSD,
    visibility,
  ) {
    return this._makeApiServerCall(
      "updateJourneyInfo",
      {
        radioId: trebbleId,
        name: name,
        goal: goal,
        description: description,
        categoryId: categoryId,
        cityId: cityId,
        timezone: timezone,
        language: language,
        isPaid: isPaid,
        costInUSD: costInUSD,
        visibility: visibility,
      },
      "Update a journey info",
    );
  },

  changePassword: function (currentPassword, newPassword, reenterNewPassword) {
    return this._makeApiServerCall(
      "changePassword",
      {
        currentPassword: currentPassword,
        newPassword: newPassword,
        reenterNewPassword: reenterNewPassword,
      },
      "Change password",
    );
  },

  redeemCodeForCreatorSubscription: function (code) {
    return this._makeApiServerCall(
      "redeemCodeForCreatorSubscription",
      {
        codeToRedeem: code,
      },
      "Redeem code for creator subscription",
      false, // noLogin
      false, // doNotSendAnalytics
      true,  // forceLoginIfGuest - ensure guest/anonymous users are prompted to log in before redeeming
    );
  },



  getSignatureForCapsuleUpload: function (filename, songUri, requireCreatorSignup) {
    return this._makeApiServerCall(
      "getSignatureForCapsuleUpload",
      {
        songURI: songUri,
        fileName: filename,
      },
      "Get signature for capsule upload",
      false,
      false,
      true,
      requireCreatorSignup,
    );
  },


  getSignatureForCapsuleMP3Upload: function (filename, songUri, requireCreatorSignup) {
    return this._makeApiServerCall(
      "getSignatureForCapsuleMP3Upload",
      {
        songURI: songUri,
        fileName: filename,
      },
      "Get signature for capsule MP3 upload",
      false,
      false,
      true,
      requireCreatorSignup,
    );
  },

  getSignatureForCapsuleVideoUpload: function (filename, songUri, requireCreatorSignup) {
    return this._makeApiServerCall(
      "getSignatureForCapsuleVideoUpload",
      {
        songURI: songUri,
        fileName: filename,
      },
      "Get signature for capsule video upload",
      false,
      false,
      true,
      requireCreatorSignup,
    );
  },

  getSignatureForCapsuleVideoWebMUpload: function (filename, songUri, requireCreatorSignup) {
    return this._makeApiServerCall(
      "getSignatureForCapsuleVideoWebMUpload",
      {
        songURI: songUri,
        fileName: filename,
      },
      "Get signature for capsule video WebM upload",
      false,
      false,
      true,
      requireCreatorSignup,
    );
  },

  getSignatureForTrebbleUserBackgroundImageFileUpload: function (fileName, mimeType) {
    return this._makeApiServerCall(
      "getSignatureForTrebbleUserBackgroundImageFileUpload",
      {
        fileName, mimeType
      },
      "Get signature for trebble user background image upload",
      false,
      false,
      true,
      true,
    );
  },

  getSignatureForTrebbleUserLogoImageFileUpload: function (fileName, mimeType) {
    return this._makeApiServerCall(
      "getSignatureForTrebbleUserLogoImageFileUpload",
      {
        fileName, mimeType
      },
      "Get signature for trebble user logo upload",
      false,
      false,
      true,
      true,
    );
  },

  getSignatureForCapsuleWithNoSongUpload: function (filename, noParams, requireCreatorSignup) {
    return this._makeApiServerCall(
      "getSignatureForCapsuleWithNoSongUpload",
      {
        fileName: filename,
      },
      "Get signature for capsule upload with no song",
      false,
      false,
      true,
      requireCreatorSignup,
    );
  },

  

  getSignatureForDataUploadForEditQualityClassifier: async function (projectIdOrTranscriptionId, fileName, unsecure, mimeType, requireCreatorSignup) {
    return this._makeApiServerCall(
      "getSignatureForDataUploadForEditQualityClassifier",
      {
        projectIdOrTranscriptionId, fileName, unsecure, mimeType
      },
      "get signature for data input upload for edit quality classifier",
      false,
      false,
      true,
      requireCreatorSignup,
    );
  },

  getPresignedUrlForDataUploadForEditQualityClassifier: async function (projectIdOrTranscriptionId, fileName, unsecure, mimeType, requireCreatorSignup) {
    return this._makeApiServerCall(
      "getPresignedUrlForDataUploadForEditQualityClassifier",
      {
        projectIdOrTranscriptionId, fileName, unsecure, mimeType
      },
      "get presigned url for data input upload for edit quality classifier",
      false,
      false,
      true,
      requireCreatorSignup,
    );
  },


  saveUserFeedback: function (feedback, feedbackType) {
    return this._makeApiServerCall(
      "saveUserFeedback",
      {
        feedback: feedback,
        feedbackType: feedbackType,
      },
      "Send feedback",
      false,
      false,
      true,
    );
  },

  saveApps: function (names) {
    return this._makeApiServerCall(
      "saveApps",
      {
        names: names,
      },
      "Save names",
      false,
      false,
      true,
    );
  },

  saveAppleUserInfo: function (id_token, email, firstName, lastName) {
    return this._makeApiServerCall(
      "saveAppleUserInfo",
      {
        id_token: id_token,
        email: email,
        firstName: firstName,
        lastName: lastName,
      },
      "Save Apple User Info",
      true,
    );
  },

  retrieveAppleAuthorizationTokenInfo: function (code, client_secret) {
    return this._makeApiServerCall(
      "retrieveAppleAuthorizationTokenInfo",
      {
        code: code,
        client_secret: client_secret,
      },
      "Retrieve Apple Authorization Token Info",
      true,
    );
  },
  getSignatureForCapsuleReplyUpload: function (filename, capsuleRefId, requireCreatorSignup) {
    return this._makeApiServerCall(
      "getSignatureForCapsuleReplyUpload",
      {
        capsuleId: capsuleRefId,
        fileName: filename,
      },
      "Get signature for capsule reply upload",
      false,
      false,
      false,
      true,
    );
  },

  getUserProfileInfoByUsername: function (username) {
    return this._makeApiServerCall(
      "getUserProfileInfoByUsername",
      {
        username: username,
      },
      "Get user profile info by username",
      true,
    );
  },

  getUserProfileInfoByUserUniqueId: function (userUID) {
    return this._makeApiServerCall(
      "getUserProfileInfoByUserUniqueId",
      {
        userUID: userUID,
      },
      "Get user profile info by user unique id",
      true,
    );
  },

  sendRecoveryPasswordEmail: function (email) {
    return this._makeApiServerCall(
      "auth/password-reset/request",
      {
        email: email,
      },
      "Send a link to reset a user password via email",
      true,
    );
  },

  completePasswordReset: function (token, newPassword) {
    return this._makeApiServerCall(
      "auth/password-reset/complete",
      {
        token: token,
        newPassword: newPassword,
      },
      "Complete password reset",
      true,
    );
  },

  getAvailableDefaultBackgroundMusic: function () {
    return this._makeApiServerCall(
      "getAvailableDefaultBackgroundMusic",
      null,
      "Get Available Default Background Music",
      true,
    );
  },

  getUserUploadedBackgroundMusic: function (workspaceId) {
    return this._makeApiServerCall(
      "getUserUploadedBackgroundMusic",
      this._appendWorkspaceIdParam(null, workspaceId),
      "Get User Uploaded Background Music",
      false,
      false,
      true,
    );
  },

  getAllBackgroundImagesForEditor: function (workspaceId) {
    return this._makeApiServerCall(
      "getAllBackgroundImagesForEditor",
      this._appendWorkspaceIdParam(null, workspaceId),
      "Get All Backgroud Images For Editor",
      false,
      false,
      true,
    );
  },

  getAllLogoImagesForEditor: function (workspaceId) {
    return this._makeApiServerCall(
      "getAllLogoImagesForEditor",
      this._appendWorkspaceIdParam(null, workspaceId),
      "Get All Logo Images For Editor",
      false,
      false,
      true,
    );
  },

  getUserUploadedMedia: function () {
    return this._makeApiServerCall(
      "getUserUploadedMedia",
      null,
      "Get User Uploaded Media",
      false,
      false,
      true,
    );
  },

  getUserUploadedVideo: function (workspaceId) {
    return this._makeApiServerCall(
      "getUserUploadedMedia",
      this._appendWorkspaceIdParam({
        videoOnly: true,
      }, workspaceId),
      "Get User Uploaded Media",
      false,
      false,
      true,
    );
  },


  getUserUploadedAudio: function () {
    return this._makeApiServerCall(
      "getUserUploadedMedia",
      {
        audioOnly: true,
      },
      "Get User Uploaded Media",
      false,
      false,
      true,
    );
  },
  

  addBackgroundMusicToUserLibrary: function (name, audioUrl, uploadAudioInfo, isVideo, metadata, workspaceId) {
    const effectiveWorkspaceId = workspaceId === undefined ? this._resolveActiveWorkspaceIdForUpload() : workspaceId;
    return this._makeApiServerCall(
      "addBackgroundMusicToUserLibrary",
      this._appendWorkspaceIdParam({ name: name, audioUrl: audioUrl, uploadAudioInfo: uploadAudioInfo, isVideo: isVideo, metadata }, effectiveWorkspaceId),
      "Add Background Music To User Library",
      false,
      false,
      true,
    );
  },

  addUploadedBackgroundImageToEditorMediaAssetLibrary: function (name, uri, uploadAudioInfo, type, workspaceId) {
    return this._makeApiServerCall(
      "addUploadedBackgroundImageToEditorMediaAssetLibrary",
      this._appendWorkspaceIdParam({ name, uri, uploadAudioInfo, type }, workspaceId),
      "Add Uploaded Background Image To Editor Media Asset Library",
      false,
      false,
      true,
    );
  },


  addUploadedLogoToEditorMediaAssetLibrary: function (name, uri, uploadAudioInfo, type, workspaceId) {
    return this._makeApiServerCall(
      "addUploadedLogoToEditorMediaAssetLibrary",
      this._appendWorkspaceIdParam({ name, uri, uploadAudioInfo, type }, workspaceId),
      "Add Uploaded Logo To Editor Media Asset Library",
      false,
      false,
      true,
    );
  },


  addUploadedMediaToUserLibrary: function (name, audioUrl, uploadAudioInfo, isVideo, metadata, workspaceId) {
    const effectiveWorkspaceId = workspaceId === undefined ? this._resolveActiveWorkspaceIdForUpload() : workspaceId;
    return this._makeApiServerCall(
      "addUploadedMediaToUserLibrary",
      this._appendWorkspaceIdParam({ name: name, audioUrl: audioUrl, uploadAudioInfo: uploadAudioInfo, isVideo: isVideo, metadata }, effectiveWorkspaceId),
      "Add Uploaded Media To User Library",
      false,
      false,
      true,
    );
  },


  removeBackgroundMusicToUserLibrary: function (audioUID) {
    return this._makeApiServerCall(
      "removeBackgroundMusicToUserLibrary",
      { audioUID: audioUID },
      "Remove Background Music From User Library",
      false,
      false,
      true,
    );
  },

  removeUserUploadedMediaToUserLibrary: function (audioUID) {
    return this._makeApiServerCall(
      "removeUserUploadedMediaToUserLibrary",
      { audioUID: audioUID },
      "Remove User Uploaded Media From User Library",
      false,
      false,
      true,
    );
  },

  startTranscriptionForAudioRecording: function (audioRecordingId, language, audioType, transcribeVerbatim) {
    const effectiveWorkspaceId = this._resolveWorkspaceIdForScopedMutation(undefined);
    return this._makeApiServerCall(
      "startTranscriptionForAudioRecording",
      this._appendWorkspaceIdParam({ audioRecordingId: audioRecordingId, language: language, audioType , transcribeVerbatim }, effectiveWorkspaceId),
      "start Transcription For Audio Recording",
      false,
      false,
      true,
    );
  },

  checkForDuplicateTranscription: function (filename) {
    return this._makeApiServerCall(
      "checkForDuplicateTranscription",
      { filename: filename },
      "Check For Duplicate Transcription",
      false,
      false,
      true,
    );
  },

  saveSequencerProject: function (projectId, dateTimestamp, serializedData, willBeSaveByClient, workspaceId) {
    const effectiveWorkspaceId = this._resolveWorkspaceIdForScopedMutation(workspaceId);
    return this._makeApiServerCall(
      "saveSequencerProject",
      this._appendWorkspaceIdParam({
        projectId: projectId,
        dateTimestamp: dateTimestamp,
        willBeSaveByClient: willBeSaveByClient,
        serializedDataStringified: JSON.stringify(serializedData),
      }, effectiveWorkspaceId),
      "Save sequencer project",
      false,
      false,
      true,
    );
  },

  getSerializedDataFileLocation: function (projectId, confirmed) {
    return this._makeApiServerCall(
      "getSerializedDataFileLocation",
      { projectId: projectId, confirmed: confirmed },
      "Get serialized data file location",
      false,
      false,
      true,
    );
  },

  getSequencerProjectTexTranscription: function (projectId, confirmed) {
    return this._makeApiServerCall(
      "getSequencerProjectTexTranscription",
      { projectId: projectId, confirmed: confirmed },
      "Get sequencer project text transcription",
      false,
      false,
      true,
    );
  },

  confirmProjectWasSuccessfullySaved: function (serializedDataFileLocation) {
    return this._makeApiServerCall(
      "confirmProjectWasSuccessfullySaved",
      { serializedDataFileLocation: serializedDataFileLocation },
      "Confirm sequencer project was successfully saved",
      false,
      false,
      true,
    );
  },

  getNumberOfFreeMinutesOfTranscriptionLeft: function () {
    return this._makeApiServerCall(
      "getNumberOfFreeMinutesOfTranscriptionLeft",
      null,
      "Get Number Of Free Minutes Of Transcription Left",
      false,
      false,
      true,
    );
  },

  addUploadedAudioRecordingToUserLibrary: function (name, audioUrl, uploadAudioInfo, originalFilename, workspaceId) {
    const effectiveWorkspaceId = workspaceId === undefined ? this._resolveActiveWorkspaceIdForUpload() : workspaceId;
    return this._makeApiServerCall(
      "addUploadedAudioRecordingToUserLibrary",
      this._appendWorkspaceIdParam({ name: name, audioUrl: audioUrl, uploadAudioInfo: uploadAudioInfo, originalFilename: originalFilename }, effectiveWorkspaceId),
      "Add User Audio Recording To User Library",
      false,
      false,
      true,
    );
  },

  addUploadedAudioRecordingArrayToUserLibrary: function (audioPartsArray, workspaceId) {
    const effectiveWorkspaceId = workspaceId === undefined ? this._resolveActiveWorkspaceIdForUpload() : workspaceId;
    return this._makeApiServerCall(
      "addUploadedAudioRecordingArrayToUserLibrary",
      this._appendWorkspaceIdParam({ audioPartsArray: audioPartsArray }, effectiveWorkspaceId),
      "Add User Audio Recording Array To User Library",
      false,
      false,
      true,
    );
  },

  removeBackgroundAudioRecordingFromUserLibrary: function (audioUID) {
    return this._makeApiServerCall(
      "removeBackgroundAudioRecordingFromUserLibrary",
      { audioUID: audioUID },
      "Remove Background Music From User Library",
      false,
      false,
      true,
    );
  },

  getSignatureForTrebbleCoverArtUpload: function (fileName, trebbleId, requireCreatorSignup, mimeType) {
    return this._makeApiServerCall(
      "getSignatureForTrebbleCovertArtUpload",
      {
        trebbleId: trebbleId,
        fileName: fileName,
        mimeType
      },
      "Get signature for cover art trebble upload",
      false,
      false,
      true,
      requireCreatorSignup,
    );
  },

  getSignatureForTrebbleSweeperUpload: function (fileName, trebbleId, requireCreatorSignup, mimeType) {
    return this._makeApiServerCall(
      "getSignatureForTrebbleSweeperUpload",
      {
        trebbleId: trebbleId,
        fileName: fileName,
        mimeType
      },
      "Get signature for trebble sweeper upload",
      false,
      false,
      true,
      requireCreatorSignup,
    );
  },

  getSignatureForTrebbleUserBackgroundMusicUpload: function (fileName, userId, requireCreatorSignup, mimeType) {
    return this._makeApiServerCall(
      "getSignatureForTrebbleUserBackgroundMusicUpload",
      {
        userId: userId,
        fileName: fileName,
        mimeType
      },
      "Get signature for trebble user background music upload",
      false,
      false,
      true,
      requireCreatorSignup,
    );
  },

  getSignatureForTrebbleUserAudioUpload: function (fileName, userId, requireCreatorSignup, mimeType) {
    return this._makeApiServerCall(
      "getSignatureForTrebbleUserAudioUpload",
      {
        userId: userId,
        fileName: fileName,
        mimeType
      },
      "Get signature for trebble user audio upload",
      false,
      false,
      true,
      requireCreatorSignup,
    );
  },

  getSignatureForTrebbleUserBackgroundMusicVideoUpload: function (fileName, userId, requireCreatorSignup, mimeType) {
    return this._makeApiServerCall(
      "getSignatureForTrebbleUserBackgroundMusicVideoUpload",
      {
        userId: userId,
        fileName: fileName,
        mimeType
      },
      "Get signature for trebble user background music video upload",
      false,
      false,
      true,
      requireCreatorSignup,
    );
  },

  getSignatureForTrebbleUserVideoUpload: function (fileName, userId, requireCreatorSignup, mimeType) {
    return this._makeApiServerCall(
      "getSignatureForTrebbleUserVideoUpload",
      {
        userId: userId,
        fileName: fileName,
        mimeType
      },
      "Get signature for trebble user video upload",
      false,
      false,
      true,
      requireCreatorSignup,
    );
  },

  getSignatureForTrebbleUserClipUpload: function (fileName, userId, requireCreatorSignup, mimeType) {
    return this._makeApiServerCall(
      "getSignatureForTrebbleUserClipUpload",
      {
        userId: userId,
        fileName: fileName,
        mimeType
      },
      "Get signature for trebble user clip upload",
      false,
      false,
      true,
      requireCreatorSignup,
    );
  },

  getSignatureForTrebbleUserAudioRecordingUpload: function (fileName, userId, requireCreatorSignup, mimeType) {
    return this._makeApiServerCall(
      "getSignatureForTrebbleUserAudioRecordingUpload",
      {
        userId: userId,
        fileName: fileName,
        mimeType
      },
      "Get signature for trebble user audio recording upload",
      false,
      false,
      true,
      requireCreatorSignup,
    );
  },

  getSignatureForTrebbleGreaterUpload: function (fileName, trebbleId, requireCreatorSignup, mimeType) {
    return this._makeApiServerCall(
      "getSignatureForTrebbleGreaterUpload",
      {
        trebbleId: trebbleId,
        fileName: fileName,
        mimeType
      },
      "Get signature for trebble greater upload",
      false,
      false,
      true,
      requireCreatorSignup,
    );
  },

  getSignatureForTrebbleIntroUpload: function (fileName, trebbleId, requireCreatorSignup, mimeType) {
    return this._makeApiServerCall(
      "getSignatureForTrebbleIntroUpload",
      {
        trebbleId: trebbleId,
        fileName: fileName,
        mimeType
      },
      "Get signature for trebble intro upload",
      false,
      false,
      true,
      requireCreatorSignup,
    );
  },

  getSignatureForTrebbleOutroUpload: function (fileName, trebbleId, requireCreatorSignup, mimeType) {
    return this._makeApiServerCall(
      "getSignatureForTrebbleOutroUpload",
      {
        trebbleId: trebbleId,
        fileName: fileName,
        mimeType
      },
      "Get signature for trebble outro upload",
      false,
      false,
      true,
      requireCreatorSignup,
    );
  },

  getSignatureForSequencerProjectTextTranscriptionUpload: function (fileName, userId, requireCreatorSignup, mimeType) {
    return this._makeApiServerCall(
      "getSignatureForSequencerProjectTextTranscriptionUpload",
      {
        userId: userId,
        fileName: fileName,
        mimeType
      },
      "Get signature for sequencer project txt transcription upload",
      false,
      false,
      true,
      requireCreatorSignup,
    );
  },

  updateRadioCoverArtByRadioId: function (completeImageFileUrl, trebbleId) {
    return this._makeApiServerCall(
      "updateRadioCoverArtByRadioId",
      {
        radioId: trebbleId,
        coverArtUrl: completeImageFileUrl,
      },
      "Update cover art for trebble",
    );
  },

  updateJourneyCoverArtByRadioId: function (completeImageFileUrl, journeyId) {
    return this._makeApiServerCall(
      "updateJourneyCoverArtByRadioId",
      {
        journeyId: journeyId,
        coverArtUrl: completeImageFileUrl,
      },
      "Update cover art for journey",
    );
  },

  hasUserLeftReviewOnJourney: function (radioId) {
    return this._makeApiServerCall(
      "hasUserLeftReviewOnJourney",
      {
        radioId: radioId,
      },
      "Has user left review on journey",
    );
  },

  canUserSubmitAJourneyReview: function (radioId) {
    return this._makeApiServerCall(
      "canUserSubmitAJourneyReview",
      {
        radioId: radioId,
      },
      "Can User Submit A Journey Review",
    );
  },

  getUserReviewOnJourney: function (radioId) {
    return this._makeApiServerCall(
      "getUserReviewOnJourney",
      {
        radioId: radioId,
      },
      "Get user left review on journey",
    );
  },

  createUserJourneyReview: function (radioId, journeyId, textReview, numberOfStars) {
    return this._makeApiServerCall(
      "createUserJourneyReview",
      {
        radioId: radioId,
        journeyId: journeyId,
        textReview: textReview,
        numberOfStars: numberOfStars,
      },
      "create user journey review",
    );
  },

  updateUserJourneyReview: function (reviewId, textReview, numberOfStars) {
    return this._makeApiServerCall(
      "updateUserJourneyReview",
      {
        reviewId: reviewId,
        textReview: textReview,
        numberOfStars: numberOfStars,
      },
      "update user journey review",
    );
  },

  setJingleToMyDefaultPersonalRadio: function (jingleUrl, trebbleId, duration) {
    return this._makeApiServerCall(
      "setJingleToMyDefaultPersonalRadio",
      {
        radioUID: trebbleId,
        jingleUri: jingleUrl,
        duration: duration,
      },
      "Update Jingle On Default Trebble",
    );
  },

  setGreaterToMyDefaultPersonalRadio: function (greaterUrl, trebbleId, duration) {
    return this._makeApiServerCall(
      "setGreaterToMyDefaultPersonalRadio",
      {
        radioUID: trebbleId,
        greaterUri: greaterUrl,
        duration: duration,
      },
      "Update Greater On Default Trebble",
    );
  },

  setIntroToMyDefaultPersonalRadio: function (introUrl, trebbleId, duration) {
    return this._makeApiServerCall(
      "setIntroToMyDefaultPersonalRadio",
      {
        radioUID: trebbleId,
        introUri: introUrl,
        duration: duration,
      },
      "Update Intro On Default Trebble",
    );
  },

  setOutroToMyDefaultPersonalRadio: function (outroUrl, trebbleId, duration) {
    return this._makeApiServerCall(
      "setOutroToMyDefaultPersonalRadio",
      {
        radioUID: trebbleId,
        outroUri: outroUrl,
        duration: duration,
      },
      "Update Outro On Default Trebble",
    );
  },

  getJingleForMyDefaultPersonalRadio: function (trebbleId) {
    return this._makeApiServerCall(
      "getJingleForMyDefaultPersonalRadio",
      {
        radioUID: trebbleId,
      },
      "Retrieve Jingle On Default Trebble",
    );
  },

  getGreaterForMyDefaultPersonalRadio: function (trebbleId) {
    return this._makeApiServerCall(
      "getGreaterForMyDefaultPersonalRadio",
      {
        radioUID: trebbleId,
      },
      "Retrieve Greater On Default Trebble",
    );
  },

  getIntroForMyDefaultPersonalRadio: function (trebbleId) {
    return this._makeApiServerCall(
      "getIntroForMyDefaultPersonalRadio",
      {
        radioUID: trebbleId,
      },
      "Retrieve Intro On Default Trebble",
    );
  },

  getOutroForMyDefaultPersonalRadio: function (trebbleId) {
    return this._makeApiServerCall(
      "getOutroForMyDefaultPersonalRadio",
      {
        radioUID: trebbleId,
      },
      "Retrieve Outro On Default Trebble",
    );
  },

  unsetCurrentJingleFromMyDefaultPersonalRadio: function (trebbleId) {
    return this._makeApiServerCall(
      "disableJingleOnMyDefaultPersonalRadio",
      {
        radioUID: trebbleId,
      },
      "Unset Jingle On Default Trebble",
    );
  },

  unsetCurrentGreaterFromMyDefaultPersonalRadio: function (trebbleId) {
    return this._makeApiServerCall(
      "disableGreaterOnMyDefaultPersonalRadio",
      {
        radioUID: trebbleId,
      },
      "Unset Greater On Default Trebble",
    );
  },

  unsetCurrentIntroFromMyDefaultPersonalRadio: function (trebbleId) {
    return this._makeApiServerCall(
      "disableIntroOnMyDefaultPersonalRadio",
      {
        radioUID: trebbleId,
      },
      "Unset Intro On Default Trebble",
    );
  },

  unsetCurrentOutroFromMyDefaultPersonalRadio: function (trebbleId) {
    return this._makeApiServerCall(
      "disableOutroOnMyDefaultPersonalRadio",
      {
        radioUID: trebbleId,
      },
      "Unset Outro On Default Trebble",
    );
  },

  deleteCurrentJingleFromMyDefaultPersonalRadio: function (trebbleId) {
    return this._makeApiServerCall(
      "deleteCurrentJingleOnMyDefaultPersonalRadio",
      {
        radioUID: trebbleId,
      },
      "Delete Current Jingle On Default Trebble",
    );
  },

  deleteCurrentGreaterFromMyDefaultPersonalRadio: function (trebbleId) {
    return this._makeApiServerCall(
      "deleteCurrentGreaterOnMyDefaultPersonalRadio",
      {
        radioUID: trebbleId,
      },
      "Delete Current Greater On Default Trebble",
    );
  },

  deleteCurrentIntroFromMyDefaultPersonalRadio: function (trebbleId) {
    return this._makeApiServerCall(
      "deleteCurrentIntroOnMyDefaultPersonalRadio",
      {
        radioUID: trebbleId,
      },
      "Delete Current Intro On Default Trebble",
    );
  },

  deleteCurrentOutroFromMyDefaultPersonalRadio: function (trebbleId) {
    return this._makeApiServerCall(
      "deleteCurrentOutroOnMyDefaultPersonalRadio",
      {
        radioUID: trebbleId,
      },
      "Delete Current Outro On Default Trebble",
    );
  },

  getSignatureForUserProfileImageUpload: function (fileName) {
    return this._makeApiServerCall(
      "getSignatureForUserProfileImageUpload",
      {
        fileName: fileName,
      },
      "Get signature for user profile image upload",
    );
  },

  updateUserProfileImage: function (completeImageFileUrl) {
    return this._makeApiServerCall(
      "updateUserProfileImage",
      {
        profileImageUrl: completeImageFileUrl,
      },
      "Update user profile image",
    );
  },

  updateUserSetTimeForNotification: function (timeHour, timezone) {
    return this._makeApiServerCall(
      "updateUserSetTimeForNotification",
      {
        timeHour: timeHour,
        timezone: timezone,
      },
      "Update user set time for daily digest",
    );
  },

  markSongCommentsAsNotified: function (songJson, context, songRefSummary) {
    return this._makeApiServerCall(
      "markSongCommentsAsNotifiedByLoggedInUser",
      {
        songJson: songJson,
        songRefSummary: songRefSummary,
        context: context,
      },
      "Mark comments for song as notified",
    );
  },

  markSongCommentsAsConsumed: function (songJson, context, songRefSummary) {
    return this._makeApiServerCall(
      "markSongCommentsAsConsumedByLoggedInUser",
      {
        songJson: songJson,
        songRefSummary: songRefSummary,
        context: context,
      },
      "Mark comments for song as consumed",
    );
  },

  markCapsuleCommentsAsConsumed: function (capsuleId, context, songRefSummary) {
    return this._makeApiServerCall(
      "markCapsuleCommentsAsConsumedByLoggedInUser",
      {
        capsuleId: capsuleId,
        songRefSummary: songRefSummary,
        context: context,
      },
      "Mark comments for song as consumed",
    );
  },

  markCommentRepliesAsConsumed: function (commentId, context, songRefSummary) {
    return this._makeApiServerCall(
      "markCommentRepliesAsConsumedByLoggedInUser",
      {
        commentId: commentId,
        context: context,
      },
      "Mark comment replies as consumed",
    );
  },

  searchForUsers: function (keyword, numberOfResults, pageOffset) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "searchForUsers",
      {
        keyword: keyword,
        numberOfResults: numberOfResults,
        pageOffset: pageOffset,
      },
      "Search for Users matching keyword",
      shouldSkipLogin,
    );
  },

  searchForMyDraftJourneys: function (searchKeyword, numberOfResults, pageOffset) {
    return this._makeApiServerCall(
      "searchForMyDraftJourneys",
      {
        searchKeyword: searchKeyword,
        numberOfResults: numberOfResults,
        pageOffset: pageOffset,
      },
      "Search for my draft journeys matching keyword",
    );
  },

  searchForBigBankSounds: function (searchKeyword, numberOfResults, pageOffset) {
    return this._makeApiServerCall(
      "searchForBigBankSounds",
      {
        searchKeyword: searchKeyword,
        numberOfResults: numberOfResults,
        pageOffset: pageOffset,
      },
      "Search for big bank sounds matching keyword",
    );
  },

  searchForTrebbles: function (keyword, numberOfResults, pageOffset) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "searchForTrebbles",
      {
        keyword: keyword,
        numberOfResults: numberOfResults,
        pageOffset: pageOffset,
      },
      "Search for Trebbles matching keyword",
      shouldSkipLogin,
    );
  },

  searchForJourneys: function (keyword, numberOfResults, pageOffset) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "searchForJourneys",
      {
        keyword: keyword,
        numberOfResults: numberOfResults,
        pageOffset: pageOffset,
      },
      "Search for Journeys matching keyword",
      shouldSkipLogin,
    );
  },

  getAllAvailableJourneysCreatedByUserWithId: function (userId) {
    return this._makeApiServerCall(
      "getAllAvailableJourneysCreatedByUserWithId",
      {
        userId: userId,
      },
      "Get all journeys created by user with id",
      true,
    );
  },

  retrieveAllTrebbleGenres: function (searchOnTrebbleWithNoPreview) {
    return this._makeApiServerCall(
      "retrieveAllGenres",
      {
        searchOnTrebbleWithNoPreview: searchOnTrebbleWithNoPreview,
      },
      "Retrieve All Trebble ' Genres",
      true,
    );
  },

  retrieveTrebbleByGenres: function (genre, maxNumberOfResults, pageOffset) {
    return this._makeApiServerCall(
      "retrieveTrebblesByGenre",
      {
        genre: genre,
        numberOfResults: maxNumberOfResults,
        pageOffset: pageOffset,
      },
      "Retrieve Trebble By Genres",
      true,
    );
  },

  retrieveTrebbleByCategory: function (category, maxNumberOfResults) {
    return this._makeApiServerCall(
      "retrieveTrebbleByCategory",
      {
        category: category,
        numberOfResults: maxNumberOfResults,
      },
      "Retrieve Trebble By Category",
      true,
    );
  },

  retrieveTrebbleByCity: function (cityId) {
    return this._makeApiServerCall(
      "retrieveTrebbleByCity",
      {
        cityId: cityId,
      },
      "Retrieve Trebble By City",
      true,
    );
  },

  retrieveTrebbleByCategoryAndLanguage: function (category, language, maxNumberOfResults, pageOffset) {
    return this._makeApiServerCall(
      "retrieveTrebbleByCategoryAndLanguage",
      {
        category: category,
        language: language,
        numberOfResults: maxNumberOfResults,
        pageOffset: pageOffset,
      },
      "Retrieve Trebble By Category And Language",
      true,
    );
  },

  retrieveTrebbleByCityAndLanguage: function (cityId, language, numberOfResults, pageOffset) {
    return this._makeApiServerCall(
      "retrieveTrebbleByCityAndLanguage",
      {
        cityId: cityId,
        language: language,
        numberOfResults: numberOfResults,
        pageOffset: pageOffset,
      },
      "Retrieve Trebble By City And Language",
      true,
    );
  },

  postComment: function (songJson, songRefSummary, commentToPost, context) {
    const params = {};
    params.songJson = songJson;
    params.comment = commentToPost;
    params.songRefSummary = songRefSummary;
    params.context = context;
    return this._makeApiServerCall("commentOnSong", params, "Comment on song");
  },

  commentOnCapsule: function (capsuleId, songRefSummary, commentToPost, context) {
    const params = {};
    params.capsuleRefId = capsuleId;
    params.comment = commentToPost;
    params.songRefSummary = songRefSummary;
    params.context = context;
    return this._makeApiServerCall("commentOnSong", params, "Comment on song");
  },

  postReply: function (commentId, commentToPost, context) {
    const params = {};
    params.commentRefId = commentId;
    params.comment = commentToPost;
    params.context = context;
    return this._makeApiServerCall("commentOnSong", params, "Post a comment reply");
  },

  likeComment: function (commentId) {
    const params = {};
    params.commentId = commentId;
    return this._makeApiServerCall("likeComment", params, "Like comment");
  },

  unlikeComment: function (commentId) {
    const params = {};
    params.commentId = commentId;
    return this._makeApiServerCall("unlikeComment", params, "Unlike comment");
  },

  updateCapsule: function (
    capsuleId,
    audioPartsInfo,
    title,
    comment,
    imageArtUrl,
    context,
    capsuleReceiverId,
    wasTranscribedAndEditedInTrebble,
    hqAudioInfo,
    projectId,
    videoInfo,
    audioInfo
  ) {
    const params = {};
    params.capsuleId = capsuleId;
    params.audioPartsInfo = audioPartsInfo;
    params.title = title;
    params.comment = comment;
    params.imageArtUrl = imageArtUrl;
    params.context = context;
    params.capsuleReceiverId = capsuleReceiverId;
    params.wasTranscribedAndEditedInTrebble = wasTranscribedAndEditedInTrebble;
    params.hqAudioInfo = hqAudioInfo;
    params.projectId = projectId;
    params.videoInfo = videoInfo;
    params.audioInfo = audioInfo;
    return this._makeApiServerCall("updateSongCapsule", params, "Update Capsule", false, false, true);
  },

  createSongCapsule: function (
    songJson,
    capsuleId,
    audioPartsInfo,
    lifeSpanInDays,
    title,
    comment,
    imageArtUrl,
    backgroundMusicUri,
    doNotTriggerAudioProcessing,
    categoryId,
    isPrivate,
    context,
    capsuleReceiverId,
    addToRadioWitIds,
    doNotAddOnAir,
    isScheduled,
    scheduledStartDate,
    timezone,
    language,
    textToConvertToAudio,
    voiceToUseForTTS,
    ttsLanguage,
    narrationParams,
    wasTranscribedAndEditedInTrebble,
    hqAudioInfo,
    projectId,
    videoInfo,
  ) {
    const params = {};
    params.songJson = songJson;
    params.capsuleRefId = capsuleId;
    params.audioPartsInfo = audioPartsInfo;
    params.lifeSpanInDays = lifeSpanInDays;
    params.title = title;
    params.comment = comment;
    params.imageArtUrl = imageArtUrl;
    params.backgroundMusicUri = backgroundMusicUri;
    params.categoryId = categoryId;
    params.capsuleReceiverId = capsuleReceiverId;
    params.doNotTriggerAudioProcessing = doNotTriggerAudioProcessing;
    params.private = isPrivate;
    params.context = context;
    params.addToRadioWitIds = addToRadioWitIds;
    params.doNotAddOnAir = doNotAddOnAir;
    params.isScheduled = isScheduled;
    params.scheduledStartDate = scheduledStartDate;
    params.timezone = timezone;
    params.language = language;
    params.textToConvertToAudio = textToConvertToAudio;
    params.voiceToUseForTTS = voiceToUseForTTS;
    params.ttsLanguage = ttsLanguage;
    params.narrationParams = narrationParams;
    params.wasTranscribedAndEditedInTrebble = wasTranscribedAndEditedInTrebble;
    params.hqAudioInfo = hqAudioInfo;
    params.projectId = projectId;
    params.videoInfo = videoInfo;
    return this._makeApiServerCall("createSongCapsule", params, "Create Capsule", false, false, true);
  },

  deleteSongCapsule: function (capsuleId) {
    const params = {};
    params.capsuleUID = capsuleId;
    return this._makeApiServerCall("deleteCapsule", params, "Delete song capsule");
  },

  updateSongCapsule: function (
    capsuleId,
    title,
    notes,
    updateLifeSpan,
    numberOfDaysToLive,
    makeActive,
    updateCategoryId,
    newCategoryId,
    isPrivate,
  ) {
    const params = {};
    params.capsuleId = capsuleId;
    params.title = title;
    params.comment = notes;
    params.updateExpirationDate = updateLifeSpan;
    params.numberOfDaysToLive = numberOfDaysToLive;
    params.setAsActiveCapsule = makeActive;
    params.updateCategoryId = updateCategoryId;
    params.private = isPrivate;
    params.categoryId = newCategoryId;
    return this._makeApiServerCall("updateCapsuleInfo", params, "Update song capsule info", false, false, true);
  },

  _makeApiServerCall: function (
    apiName,
    params,
    actionLogName,
    noLogin,
    doNotSendAnalytics,
    forceLoginIfGuest,
    forceSignUpAsCreator,
    responseOptions,
  ) {
    const apiSelf = this;
    const startTime = new Date().getTime();
    const resolverFunc = function (resolve, reject) {
      apiSelf
        ._executeServerAjaxRequest("POST", apiName, params)
        .then(function (result) {
          if (
            responseOptions &&
            responseOptions.unwrapMessage === false &&
            result &&
            result.success
          ) {
            window.log(actionLogName + " was made successfully to server");
            const hasMessage = Object.prototype.hasOwnProperty.call(result, "message");
            resolve(hasMessage ? result.message : result);
          } else {
            apiSelf._getDefaultResponseHandler(result, resolve, reject, undefined, actionLogName);
          }
          const endTime = new Date().getTime();
          if (!doNotSendAnalytics && window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
            window.trebbleAnalyticsHelper.trackEvent("backendCall", apiName, actionLogName);
            window.trebbleAnalyticsHelper.trackTiming("Server API Call", endTime - startTime, "Success", actionLogName);
          }
        })
        .catch(function (errorObj) {
          apiSelf._getDefaultFailedResponseHandler(errorObj, reject, undefined, actionLogName);
          const endTime = new Date().getTime();
          if (!doNotSendAnalytics && window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
            window.trebbleAnalyticsHelper.trackEvent("backendCall", apiName, actionLogName, -1);
            window.trebbleAnalyticsHelper.trackTiming(
              "Server API Call",
              endTime - startTime,
              "Error" + errorObj,
              actionLogName,
            );
          }
        });
    }.bind(this);
    if (noLogin) {
      return new RSVP.Promise(resolverFunc);
    } else {
      window.log("Login for " + actionLogName);
      return this._doLogin(false, forceLoginIfGuest, forceSignUpAsCreator).then(function () {
        return new RSVP.Promise(resolverFunc);
      });
    }
  },

  _makeApiGetServerCall: function (
    apiName,
    params,
    actionLogName,
    noLogin,
    doNotSendAnalytics,
    forceLoginIfGuest,
    forceSignUpAsCreator,
  ) {
    const apiSelf = this;
    const startTime = new Date().getTime();
    const resolverFunc = function (resolve, reject) {
      apiSelf
        ._executeServerAjaxRequest("GET", apiName, params)
        .then(function (result) {
          apiSelf._getDefaultResponseHandler(result, resolve, reject, undefined, actionLogName);
          const endTime = new Date().getTime();
          if (!doNotSendAnalytics && window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
            window.trebbleAnalyticsHelper.trackEvent("backendCall", apiName, actionLogName);
            window.trebbleAnalyticsHelper.trackTiming("Server API Call", endTime - startTime, "Success", actionLogName);
          }
        })
        .catch(function (errorObj) {
          apiSelf._getDefaultFailedResponseHandler(errorObj, reject, undefined, actionLogName);
          const endTime = new Date().getTime();
          if (!doNotSendAnalytics && window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
            window.trebbleAnalyticsHelper.trackEvent("backendCall", apiName, actionLogName, -1);
            window.trebbleAnalyticsHelper.trackTiming(
              "Server API Call",
              endTime - startTime,
              "Error" + errorObj,
              actionLogName,
            );
          }
        });
    }.bind(this);
    if (noLogin) {
      return new RSVP.Promise(resolverFunc);
    } else {
      window.log("Login for " + actionLogName);
      return this._doLogin(false, forceLoginIfGuest, forceSignUpAsCreator).then(function () {
        return new RSVP.Promise(resolverFunc);
      });
    }
  },

  _makeApiPlayTrebbleCall: function (apiName, params, actionLogName, noLogin, doNotSendAnalytics) {
    const apiSelf = this;
    const startTime = new Date().getTime();
    const resolverFunc = function (resolve, reject) {
      $.ajax({
        url: httpOrHttpsPrefix + playTrebbleServerUrl + "/" + apiName,
        type: "POST",
        data: JSON.stringify(params),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
      })
        .done(function (result) {
          apiSelf._getDefaultResponseHandler(result, resolve, reject, undefined, actionLogName);
          const endTime = new Date().getTime();
          if (!doNotSendAnalytics && window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
            window.trebbleAnalyticsHelper.trackEvent("backendCall", apiName, actionLogName);
            window.trebbleAnalyticsHelper.trackTiming("Server API Call", endTime - startTime, "Success", actionLogName);
          }
        })
        .fail(function (errorObj) {
          apiSelf._getDefaultFailedResponseHandler(errorObj, reject, undefined, actionLogName);
          const endTime = new Date().getTime();
          if (!doNotSendAnalytics && window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
            window.trebbleAnalyticsHelper.trackEvent("backendCall", apiName, actionLogName, -1);
            window.trebbleAnalyticsHelper.trackTiming(
              "Server API Call",
              endTime - startTime,
              "Error" + errorObj,
              actionLogName,
            );
          }
        });
    }.bind(this);
    if (noLogin) {
      return new RSVP.Promise(resolverFunc);
    } else {
      return this._doLogin().then(function () {
        return new RSVP.Promise(resolverFunc);
      });
    }
  },

  generatePlaylistFromSongBasedOnAllUsersData: function (song) {
    const apiSelf = this;
    let endTime = null;
    const resolverFunc = function (resolve, reject) {
      const startTime = new Date().getTime();
      $.post(_getApiBaseUrl() + "/generatePlaylistFromSongBasedOnAllUsers", {
        songURI: song.uri,
      })
        .done(function (response) {
          try {
            const arrayOfSongs = response.message;
            const result = {};
            result.songs = arrayOfSongs;
            result.albums = apiSelf._getAlbumsArrayFromSongsJson(arrayOfSongs);
            result.artists = apiSelf._getArtistArrayFromAlbumsJson(result.albums);
            response.message = arrayOfSongs;
            apiSelf._getDefaultResponseHandler(
              response,
              resolve,
              reject,
              undefined,
              "Get list of  similar songs from othes users catalog",
            );
            endTime = new Date().getTime();
            if (window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
              window.trebbleAnalyticsHelper.trackEvent(
                "backendCall",
                "generatePlaylistFromSongBasedOnAllUsers",
                "Get list of  similar songs from othes users catalog",
              );
              window.trebbleAnalyticsHelper.trackTiming(
                "Server API Call",
                endTime - startTime,
                "Success",
                "Get list of  similar songs from othes users catalog",
              );
            }
          } catch (error) {
            apiSelf._getDefaultFailedResponseHandler(
              error,
              reject,
              undefined,
              "Get list of  similar songs from othes users catalog",
            );
            endTime = new Date().getTime();
            if (window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
              window.trebbleAnalyticsHelper.trackEvent(
                "backendCall",
                "generatePlaylistFromSongBasedOnAllUsers",
                "Get list of  similar songs from othes users catalog",
                -1,
              );
              window.trebbleAnalyticsHelper.trackTiming(
                "Server API Call",
                endTime - startTime,
                "Error" + error,
                "Get list of  similar songs from othes users catalog",
              );
            }
          }
        })
        .fail(function (error) {
          apiSelf._getDefaultFailedResponseHandler(
            error,
            reject,
            undefined,
            "Get list of  similar songs from othes users catalog",
          );
        });
    }.bind(this);

    return this._doLogin().then(function () {
      return new RSVP.Promise(resolverFunc);
    });
  },

  generatePlaylistOfSimilarSongs: function (song, allowSongOutsideLibrary) {
    const apiSelf = this;
    let endTime = null;
    const startTime = new Date().getTime();
    const resolverFunc = function (resolve, reject) {
      $.post(_getApiBaseUrl() + "/generatePlaylistOfSimilarSongs", {
        songURI: song.uri,
        allowSongsOutsideCatalog: allowSongOutsideLibrary,
      })
        .done(function (response) {
          try {
            const arrayOfSongs = response.message;
            const result = {};
            result.songs = arrayOfSongs;
            result.albums = apiSelf._getAlbumsArrayFromSongsJson(arrayOfSongs);
            result.artists = apiSelf._getArtistArrayFromAlbumsJson(result.albums);
            response.message = arrayOfSongs;
            apiSelf._getDefaultResponseHandler(response, resolve, reject, undefined, "Get list of similar songs");
            endTime = new Date().getTime();
            if (window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
              window.trebbleAnalyticsHelper.trackEvent(
                "backendCall",
                "generatePlaylistOfSimilarSongs",
                "Get list of similar songs",
              );
              window.trebbleAnalyticsHelper.trackTiming(
                "Server API Call",
                endTime - startTime,
                "Success",
                "Get list of similar songs",
              );
            }
          } catch (error) {
            apiSelf._getDefaultFailedResponseHandler(error, reject, undefined, "Get list of similar songs");
            endTime = new Date().getTime();
            if (window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
              window.trebbleAnalyticsHelper.trackEvent(
                "backendCall",
                "generatePlaylistOfSimilarSongs",
                "Get list of similar songs",
                -1,
              );
              window.trebbleAnalyticsHelper.trackTiming(
                "Server API Call",
                endTime - startTime,
                "Error" + error,
                "Get list of similar songs",
              );
            }
          }
        })
        .fail(function (error) {
          apiSelf._getDefaultFailedResponseHandler(error, reject, undefined, "Get list of similar songs");
        });
    }.bind(this);

    return this._doLogin().then(function () {
      return new RSVP.Promise(resolverFunc);
    });
  },

  searchForSongsAlbumsArtists: function (keyword, numberOfResults, songWithAudioPreviewOnly) {
    const apiSelf = this;
    const startTime = new Date().getTime();
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    let endTime = null;
    const resolverFunc = function (resolve, reject) {
      $.post(_getApiBaseUrl() + "/searchForTracksAlbumsArtists", {
        searchQuery: keyword,
        numberOfResults: numberOfResults,
        songWithAudioPreviewOnly: songWithAudioPreviewOnly,
      })
        .done(function (response) {
          try {
            const results = response.message;
            const arrayOfSongs = results.songs;
            const albumsFromSongs = apiSelf._getAlbumsArrayFromSongsJson(arrayOfSongs);
            const artistsFromSongs = apiSelf._getArtistArrayFromAlbumsJson(albumsFromSongs);
            results.songs = arrayOfSongs;
            apiSelf._getDefaultResponseHandler(
              response,
              resolve,
              reject,
              undefined,
              "Searching for songs , albums and artists",
            );
            endTime = new Date().getTime();
            if (window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
              window.trebbleAnalyticsHelper.trackEvent(
                "backendCall",
                "searchForTracksAlbumsArtists",
                "Searching for songs , albums and artists",
              );
              window.trebbleAnalyticsHelper.trackTiming(
                "Server API Call",
                endTime - startTime,
                "Success",
                "Searching for songs , albums and artists",
              );
            }
          } catch (error) {
            apiSelf._getDefaultFailedResponseHandler(
              error,
              reject,
              undefined,
              "Searching for songs , albums and artists",
            );
            endTime = new Date().getTime();
            if (window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
              window.trebbleAnalyticsHelper.trackEvent(
                "backendCall",
                "searchForTracksAlbumsArtists",
                "Searching for songs , albums and artists",
                -1,
              );
              window.trebbleAnalyticsHelper.trackTiming(
                "Server API Call",
                endTime - startTime,
                "Error" + error,
                "Searching for songs , albums and artists",
              );
            }
          }
        })
        .fail(function (error) {
          apiSelf._getDefaultFailedResponseHandler(
            error,
            reject,
            undefined,
            "Searching for songs , albums and artists",
          );
        });
    }.bind(this);

    if (shouldSkipLogin) {
      return new RSVP.Promise(resolverFunc);
    }

    return this._doLogin().then(function () {
      return new RSVP.Promise(resolverFunc);
    });
  },

  searchForAllSongs: function (keyword, numberOfResults, startPage, advancedQuery, songWithAudioPreviewOnly) {
    const apiSelf = this;
    const startTime = new Date().getTime();
    let endTime = null;
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    const resolverFunc = function (resolve, reject) {
      $.post(_getApiBaseUrl() + "/searchForTracks", {
        searchQuery: keyword,
        numberOfResults: numberOfResults,
        startPage: startPage,
        advancedQuery: advancedQuery,
        songWithAudioPreviewOnly: songWithAudioPreviewOnly,
      })
        .done(function (response) {
          try {
            const results = response.message;
            const arrayOfSongs = results.songs;
            const albumsFromSongs = apiSelf._getAlbumsArrayFromSongsJson(arrayOfSongs);
            const artistsFromSongs = apiSelf._getArtistArrayFromAlbumsJson(albumsFromSongs);
            results.songs = arrayOfSongs;
            apiSelf._getDefaultResponseHandler(
              response,
              resolve,
              reject,
              undefined,
              "Searching for all songs for keyword ",
            );
            endTime = new Date().getTime();
            if (window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
              window.trebbleAnalyticsHelper.trackEvent(
                "backendCall",
                "searchForTracks",
                "Searching for all songs for keyword ",
              );
              window.trebbleAnalyticsHelper.trackTiming(
                "Server API Call",
                endTime - startTime,
                "Success",
                "Searching for all songs for keyword ",
              );
            }
          } catch (error) {
            apiSelf._getDefaultFailedResponseHandler(error, reject, undefined, "Searching for all songs for keyword ");
            endTime = new Date().getTime();
            if (window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
              window.trebbleAnalyticsHelper.trackEvent(
                "backendCall",
                "searchForTracks",
                "Searching for all songs for keyword ",
                -1,
              );
              window.trebbleAnalyticsHelper.trackTiming(
                "Server API Call",
                endTime - startTime,
                "Error" + error,
                "Searching for all songs for keyword ",
              );
            }
          }
        })
        .fail(function (error) {
          apiSelf._getDefaultFailedResponseHandler(error, reject, undefined, "Searching for all songs for keyword ");
        });
    }.bind(this);

    if (shouldSkipLogin) {
      return new RSVP.Promise(resolverFunc);
    }

    return this._doLogin().then(function () {
      return new RSVP.Promise(resolverFunc);
    });
  },

  getTopTracksByArtistIdOrName: function (artistId, artistName) {
    const apiSelf = this;
    const startTime = new Date().getTime();
    let endTime = null;
    const resolverFunc = function (resolve, reject) {
      $.post(_getApiBaseUrl() + "/getTopTracksByArtistIdOrName", {
        artistId: artistId,
        artistName: artistName,
      })
        .done(function (response) {
          try {
            const results = response.message;
            const arrayOfSongs = results;
            const albumsFromSongs = apiSelf._getAlbumsArrayFromSongsJson(arrayOfSongs);
            const artistsFromSongs = apiSelf._getArtistArrayFromAlbumsJson(albumsFromSongs);
            response.message = arrayOfSongs;
            apiSelf._getDefaultResponseHandler(response, resolve, reject, undefined, "Get Top Tracks For Artist ");
            endTime = new Date().getTime();
            if (window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
              window.trebbleAnalyticsHelper.trackEvent(
                "backendCall",
                "getTopTracksByArtistIdOrName",
                "Get Top Tracks For Artist ",
              );
              window.trebbleAnalyticsHelper.trackTiming(
                "Server API Call",
                endTime - startTime,
                "Success",
                "Get Top Tracks For Artist ",
              );
            }
          } catch (error) {
            apiSelf._getDefaultFailedResponseHandler(error, reject, undefined, "Get Top Tracks For Artist ");
            endTime = new Date().getTime();
            if (window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
              window.trebbleAnalyticsHelper.trackEvent(
                "backendCall",
                "getTopTracksByArtistIdOrName",
                "Get Top Tracks For Artist ",
                -1,
              );
              window.trebbleAnalyticsHelper.trackTiming(
                "Server API Call",
                endTime - startTime,
                "Error" + error,
                "Get Top Tracks For Artist ",
              );
            }
          }
        })
        .fail(function (error) {
          apiSelf._getDefaultFailedResponseHandler(error, reject, undefined, "Searching for all songs for keyword ");
        });
    }.bind(this);

    return this._doLogin().then(function () {
      return new RSVP.Promise(resolverFunc);
    });
  },

  getArtistInfoByArtistIdOrName: function (artistId, artistName) {
    const params = {};
    params.artistId = artistId;
    params.artistName = artistName;
    return this._makeApiServerCall(
      "getArtistInfoByArtistIdOrName",
      params,
      "Get Artist Info By artist id or Arist name",
    );
  },

  getArtistBiographyInfoByArtistIdOrName: function (artistId, artistName) {
    const params = {};
    params.artistId = artistId;
    params.artistName = artistName;
    return this._makeApiServerCall(
      "getArtistBiographyInfoByArtistIdOrName",
      params,
      "Get Artist Biography By artist id or Arist name",
    );
  },

  getMyRecentNotificationCustomPayload: function (maxNumberOfResults) {
    const params = {};
    params.maxNumberOfResults = maxNumberOfResults;
    return this._makeApiServerCall(
      "getMyRecentCustomPayloadNotifiactions",
      params,
      "Get My Recent Notification Custom Payload",
    );
  },
  getAlbumByAlbumId: function (albumId) {
    const params = {};
    params.albumId = albumId;
    return this._makeApiServerCall("getAlbumByAlbumId", params, "Get Album By Album Id");
  },

  searchForAllAlbums: function (keyword, numberOfResults, startPage) {
    const apiSelf = this;
    const startTime = new Date().getTime();
    let endTime = null;
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    const resolverFunc = function (resolve, reject) {
      $.post(_getApiBaseUrl() + "/searchForAlbums", {
        searchQuery: keyword,
        numberOfResults: numberOfResults,
        startPage: startPage,
      })
        .done(function (response) {
          try {
            const results = response.message;
            const arrayOfAlbums = results.albums;
            const artistsFromAlbums = apiSelf._getArtistArrayFromAlbumsJson(arrayOfAlbums);
            results.albums = arrayOfAlbums;
            apiSelf._getDefaultResponseHandler(
              response,
              resolve,
              reject,
              undefined,
              "Searching for all albums for keyword ",
            );
            endTime = new Date().getTime();
            if (window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
              window.trebbleAnalyticsHelper.trackEvent(
                "backendCall",
                "searchForAlbums",
                "Searching for all albums for keyword ",
              );
              window.trebbleAnalyticsHelper.trackTiming(
                "Server API Call",
                endTime - startTime,
                "Success",
                "Searching for all albums for keyword ",
              );
            }
          } catch (error) {
            apiSelf._getDefaultFailedResponseHandler(error, reject, undefined, "Searching for all albums for keyword ");
            endTime = new Date().getTime();
            if (window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
              window.trebbleAnalyticsHelper.trackEvent(
                "backendCall",
                "searchForAlbums",
                "Searching for all albums for keyword ",
                -1,
              );
              window.trebbleAnalyticsHelper.trackTiming(
                "Server API Call",
                endTime - startTime,
                "Error" + error,
                "Searching for all albums for keyword ",
              );
            }
          }
        })
        .fail(function (error) {
          apiSelf._getDefaultFailedResponseHandler(error, reject, undefined, "Searching for all albums for keyword ");
        });
    }.bind(this);

    if (shouldSkipLogin) {
      return new RSVP.Promise(resolverFunc);
    }

    return this._doLogin().then(function () {
      return new RSVP.Promise(resolverFunc);
    });
  },

  getAlbumsForArtist: function (artistId, artistName, albumType, numberOfResults, offset) {
    const apiSelf = this;
    const startTime = new Date().getTime();
    let endTime = null;
    const resolverFunc = function (resolve, reject) {
      $.post(_getApiBaseUrl() + "/getAlbumsForArtistByAlbumType", {
        artistId: artistId,
        artistName: artistName,
        numberOfResults: numberOfResults,
        albumType: albumType,
        offset: offset,
      })
        .done(function (response) {
          try {
            let results = response.message;
            const arrayOfAlbums = results;
            const artistsFromAlbums = apiSelf._getArtistArrayFromAlbumsJson(arrayOfAlbums);
            results = arrayOfAlbums;
            response.message = results;
            apiSelf._getDefaultResponseHandler(response, resolve, reject, undefined, "Get Albums for Artist ");
            endTime = new Date().getTime();
            if (window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
              window.trebbleAnalyticsHelper.trackEvent(
                "backendCall",
                "getAlbumsForArtistByAlbumType",
                "Get Albums for Artist ",
              );
              window.trebbleAnalyticsHelper.trackTiming(
                "Server API Call",
                endTime - startTime,
                "Success",
                "Get Albums for Artist ",
              );
            }
          } catch (error) {
            apiSelf._getDefaultFailedResponseHandler(error, reject, undefined, "Get Albums for Artist ");
            endTime = new Date().getTime();
            if (window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
              window.trebbleAnalyticsHelper.trackEvent(
                "backendCall",
                "getAlbumsForArtistByAlbumType",
                "Get Albums for Artist ",
                -1,
              );
              window.trebbleAnalyticsHelper.trackTiming(
                "Server API Call",
                endTime - startTime,
                "Error" + error,
                "Get Albums for Artist ",
              );
            }
          }
        })
        .fail(function (error) {
          apiSelf._getDefaultFailedResponseHandler(error, reject, undefined, "Get Albums for Artist ");
        });
    }.bind(this);

    return this._doLogin().then(function () {
      return new RSVP.Promise(resolverFunc);
    });
  },

  searchForAllArtists: function (keyword, numberOfResults, startPage) {
    const apiSelf = this;
    const startTime = new Date().getTime();
    let endTime = null;
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    const resolverFunc = function (resolve, reject) {
      $.post(_getApiBaseUrl() + "/searchForArtists", {
        searchQuery: keyword,
        numberOfResults: numberOfResults,
        startPage: startPage,
      })
        .done(function (response) {
          try {
            const results = response.message;
            const arrayOfArtists = results.artists;
            results.artists = arrayOfArtists;
            apiSelf._getDefaultResponseHandler(
              response,
              resolve,
              reject,
              undefined,
              "Searching for all artists for keyword ",
            );
            endTime = new Date().getTime();
            if (window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
              window.trebbleAnalyticsHelper.trackEvent(
                "backendCall",
                "searchForArtists",
                "Searching for all artists for keyword ",
              );
              window.trebbleAnalyticsHelper.trackTiming(
                "Server API Call",
                endTime - startTime,
                "Success",
                "Searching for all artists for keyword ",
              );
            }
          } catch (error) {
            apiSelf._getDefaultFailedResponseHandler(
              error,
              reject,
              undefined,
              "Searching for all artists for keyword ",
            );
            endTime = new Date().getTime();
            if (window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
              window.trebbleAnalyticsHelper.trackEvent(
                "backendCall",
                "searchForArtists",
                "Searching for all artists for keyword ",
                -1,
              );
              window.trebbleAnalyticsHelper.trackTiming(
                "Server API Call",
                endTime - startTime,
                "Error" + error,
                "Searching for all artists for keyword ",
              );
            }
          }
        })
        .fail(function (error) {
          apiSelf._getDefaultFailedResponseHandler(error, reject, undefined, "Searching for all artists for keyword ");
        });
    }.bind(this);

    if (shouldSkipLogin) {
      return new RSVP.Promise(resolverFunc);
    }

    return this._doLogin().then(function () {
      return new RSVP.Promise(resolverFunc);
    });
  },

  getRelatedArtistsByArtistIdOrName: function (artistId, artistName) {
    const apiSelf = this;
    const startTime = new Date().getTime();
    let endTime = null;
    const resolverFunc = function (resolve, reject) {
      $.post(_getApiBaseUrl() + "/getRelatedArtistsByArtistIdOrName", {
        artistId: artistId,
        artistName: artistName,
      })
        .done(function (response) {
          try {
            let results = response.message;
            const arrayOfArtists = results;
            results = arrayOfArtists;
            response.message = results;
            apiSelf._getDefaultResponseHandler(response, resolve, reject, undefined, "Get related artists for artist ");
            endTime = new Date().getTime();
            if (window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
              window.trebbleAnalyticsHelper.trackEvent(
                "backendCall",
                "getRelatedArtistsByArtistIdOrName",
                "Get related artists for artist ",
              );
              window.trebbleAnalyticsHelper.trackTiming(
                "Server API Call",
                endTime - startTime,
                "Success",
                "Get related artists for artist ",
              );
            }
          } catch (error) {
            apiSelf._getDefaultFailedResponseHandler(error, reject, undefined, "Get related artists for artist ");
            endTime = new Date().getTime();
            if (window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
              window.trebbleAnalyticsHelper.trackEvent(
                "backendCall",
                "getRelatedArtistsByArtistIdOrName",
                "Get related artists for artist ",
                -1,
              );
              window.trebbleAnalyticsHelper.trackTiming(
                "Server API Call",
                endTime - startTime,
                "Error" + error,
                "Get related artists for artist ",
              );
            }
          }
        })
        .fail(function (error) {
          apiSelf._getDefaultFailedResponseHandler(error, reject, undefined, "Get related artists for artist ");
        });
    }.bind(this);

    return this._doLogin().then(function () {
      return new RSVP.Promise(resolverFunc);
    });
  },

  sendPushNotificationRegistrationId: function (
    registrationId,
    devicePlatform,
    registrationType,
    uniqueDeviceId,
    language,
    timezone,
  ) {
    return this._makeApiServerCall(
      "setMyRegistrationId",
      {
        registrationId: registrationId,
        devicePlatform: devicePlatform,
        registrationType: registrationType,
        uniqueDeviceId: uniqueDeviceId,
        language: language,
        timezone: timezone,
      },
      "Send Push notification registration Id",
    );
  },

  deletePushNotificationRegistrationId: function (
    userUID,
    registrationId,
    devicePlatform,
    registrationType,
    uniqueDeviceId,
  ) {
    return this._makeApiServerCall(
      "deleteMyPushRegistrationInfo",
      {
        userUID: userUID,
        registrationId: registrationId,
        devicePlatform: devicePlatform,
        uniqueDeviceId: uniqueDeviceId,
        registrationType: registrationType,
      },
      "delete Push notification registration Id",
      true,
    );
  },

  markSongsAsDeleted: function (deletedSongUriArray) {
    return this._makeApiServerCall(
      "markSongsAsDeleted",
      {
        songUrisToMarkDeleted: deletedSongUriArray,
      },
      "Mark songs as deleted",
      false,
      false,
      true,
    );
  },

  getAllMyPersonalRadioInfos: function () {
    return this._makeApiServerCall("getAllMyPersonalRadioInfos", {}, "Get All My Personal Trebbles Infos");
  },

  createAPersonalRadio: function (name, description, type, coverArtBase64) {
    return this._makeApiServerCall(
      "createAPersonalRadio",
      {
        name: name,
        description: description,
        type: type,
        coverArtBase64: coverArtBase64,
      },
      "Create a personal Trebble",
    );
  },

  createAJourney: function (
    name,
    goal,
    description,
    categoryId,
    cityId,
    language,
    timezone,
    isPaid,
    costInUSD,
    coverArtUrl,
    coverArtBase64,
    context,
  ) {
    return this._makeApiServerCall(
      "createAJourney",
      {
        name: name,
        goal: goal,
        description: description,
        categoryId: categoryId,
        cityId: cityId,
        language: language,
        timezone: timezone,
        isPaid: isPaid,
        costInUSD: costInUSD,
        coverArtUrl: coverArtUrl,
        coverArtBase64: coverArtBase64,
        context: context,
      },
      "Create a journey",
      null,
      null,
      null,
      null,
      true,
    );
  },

  addSongsToMyPersonalRadio: function (songUrisArray, radioUIDs, context) {
    return this._makeApiServerCall(
      "addSongsToMyPersonalRadio",
      {
        songURIs: songUrisArray,
        radioIUDs: radioUIDs,
        context: context,
      },
      "Add Songs To My personal Trebble",
      false,
      false,
      true,
    );
  },

  removeSongsToMyPersonalRadio: function (songUrisArray, radioUIDs, context) {
    return this._makeApiServerCall(
      "removeSongsToMyPersonalRadio",
      {
        songURIs: songUrisArray,
        radioIUDs: radioUIDs,
        context: context,
      },
      "Remove Songs From My personal Trebble",
      false,
      false,
      true,
    );
  },

  addSongsToMyDefaultPersonalRadio: function (songUrisArray, context) {
    return this._makeApiServerCall(
      "addSongsToMyDefaultPersonalRadio",
      {
        songURIs: songUrisArray,
        context: context,
      },
      "Add Songs To My default personal Trebble",
      false,
      false,
      true,
    );
  },

  removeSongsFromMyDefaultPersonalRadio: function (songUrisArray, context) {
    return this._makeApiServerCall(
      "removeSongsToMyDefaultPersonalRadio",
      {
        songURIs: songUrisArray,
        context: context,
      },
      "Remove Songs From My default personal Trebble",
      false,
      false,
      true,
    );
  },

  addCapsuleToRadios: function (
    capsuleId,
    radioIds,
    lifeSpanInDays,
    isScheduled,
    scheduledStartDate,
    timezone,
    context,
  ) {
    return this._makeApiServerCall(
      "addCapsuleToRadio",
      {
        capsuleId: capsuleId,
        radioIds: radioIds,
        lifeSpanInDays: lifeSpanInDays,
        isScheduled: isScheduled,
        scheduledStartDate: scheduledStartDate,
        timezone: timezone,
        context: context,
      },
      "Add Capsule To Trebbles",
      false,
      false,
      true,
    );
  },

  removeCapsuleFromRadios: function (capsuleId, radioIds, context) {
    return this._makeApiServerCall(
      "removeCapsuleFromRadio",
      {
        capsuleId: capsuleId,
        radioIds: radioIds,
        context: context,
      },
      "Remove Capsule From Trebbles",
      false,
      false,
      true,
    );
  },

  logUserClickedOnUrlPreviewInCapsule: function (capsuleId, url, context) {
    return this._makeApiServerCall(
      "logClickedOnUrlPreviewInCapsuleDetails",
      {
        url: url,
        capsuleId: capsuleId,
        context: context,
      },
      "Log user clicked on url preview in capsule",
    );
  },

  logUserClickedOnUrlPreviewInComment: function (commentId, url, context) {
    return this._makeApiServerCall(
      "logClickedOnUrlPreviewInComment",
      {
        url: url,
        commentId: commentId,
        context: context,
      },
      "Log user clicked on url preview in comment",
    );
  },

  getListOfSongRecentlyPlayedByAllOthers: function (options) {
    const apiSelf = this;
    return this._getSongsSetFromParams(
      options,
      "generatePlaylistOfRecentlyPlayedSongsByOther",
      "Get list of songs recently played by all other users",
      false,
    );
  },

  getListOfSongRecentlyAddedOrFavoritedByAllOthers: function (options) {
    const apiSelf = this;
    const params = {};
    if (options) {
      params.selectedTagIds = options.selectedTagIds;
    }
    return this._getSongsSetFromParams(
      params,
      "generatePlaylistOfRecentlyAddedOrFavoritedSongsByOther",
      "Get list of songs recently played by all other users",
      false,
    );
  },

  getListOfSongFromPersonalUserId: function (personalUserRadioId, options) {
    const apiSelf = this;
    const params = {};
    //TODO:Need to correct Typo here and in the server
    params.personalUserId = personalUserRadioId;
    if (options) {
      params.selectedTagIds = options.selectedTagIds;
    }
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._getSongsSetFromParams(
      params,
      "generatePlaylistForPersonalUserId",
      "Get list of songs For personal user radio",
      false,
      shouldSkipLogin,
    );
  },

  getCapsuleFeedForUserId: function (userId, options) {
    const apiSelf = this;
    const params = {};
    params.userId = userId;
    if (options && options.doNotUseTextToSpeech) {
      params.doNotUseTextToSpeech = options.doNotUseTextToSpeech;
    }
    return this._getSongsSetFromParams(
      params,
      "generatePlaylistCapsuleFeedForUserId",
      "Get capsule feed for user id",
      false,
    );
  },

  getCapsulePlaylistForCategories: function (categoryIds, language, options) {
    const apiSelf = this;
    const params = {};
    params.categoryIds = categoryIds;
    params.language = language;
    if (options && options.doNotUseTextToSpeech) {
      params.doNotUseTextToSpeech = options.doNotUseTextToSpeech;
    }
    return this._getSongsSetFromParams(
      params,
      "generatePlaylistCapsuleForCategories",
      "Get capsule playlist for categories",
      false,
    );
  },

  getPlaylistOfNextShortcastToPlayForJourney: function (capsuleId, journeyRadioId) {
    const apiSelf = this;
    const params = {};
    params.journeyRadioId = journeyRadioId;
    params.capsuleId = capsuleId;
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._getSongsSetFromParams(
      params,
      "generatePlaylistOfNextShortcastToPlayForJourneyRadioId",
      "get Playlist Of Next Shortcast To Play For Journey",
      false,
      shouldSkipLogin,
    );
  },

  getAllSongInPersonalUserRadio: function (personalUserRadioId) {
    const apiSelf = this;
    const params = {};
    params.personalUserRadioId = personalUserRadioId;
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._getSongsSetFromParamsViaGet(
      params,
      "getAllSongsInPersonalUserId",
      "Get all songs in personal user Trebble",
      true,
      shouldSkipLogin,
    );
  },

  getMostRecentSongsInPersonalUserRadio: function (personalUserRadioId, numberOfSongs) {
    const apiSelf = this;
    const params = {};
    params.personalUserRadioId = personalUserRadioId;
    params.numberOfSongs = numberOfSongs;
    return this._getSongsSetFromParams(
      params,
      "getMostRecentSongsInPersonalUserId",
      "Get most recent songs in personal user Trebble",
      true,
    );
  },

  getTrebbleTracksInfoForSpotifyIds: function (spotifyTrackIds) {
    const apiSelf = this;
    const params = {};
    params.spotifyTrackIds = spotifyTrackIds;
    return this._getSongsSetFromParams(
      params,
      "getTrebbeSongInfoForSpotifyTrackIds",
      "Get track infos songs for spotify ids",
      true,
    );
  },

  getMostPlayedSongsForUserByUserIdOrUsername: function (userId, username, numberOfResults, pageOffset) {
    const params = {};
    params.userId = userId;
    params.username = username;
    params.numberOfResults = numberOfResults;
    params.pageOffset = pageOffset;
    return this._getSongsSetFromParams(
      params,
      "getMostPlayedSongsForUserByUserIdOrUsername",
      "Get most played songs for a user",
      true,
      true,
    );
  },

  getRecentlyAddedSongsForUserByUserIdOrUsername: function (userId, username, numberOfResults, pageOffset) {
    const params = {};
    params.userId = userId;
    params.username = username;
    params.numberOfResults = numberOfResults;
    params.pageOffset = pageOffset;
    return this._getSongsSetFromParams(
      params,
      "getRecentlyAddedSongsForUserByUserIdOrUsername",
      "Get recently addded songs for a user",
      true,
      true,
    );
  },

  getUserTrebblesForUserByUserIdOrUsername: function (userId, username, numberOfResults, pageOffset) {
    return this._makeApiServerCall(
      "getUserTrebblesForUserByUserIdOrUsername",
      {
        userId: userId,
        username: username,
        numberOfResults: numberOfResults,
        pageOffset: pageOffset,
      },
      "Get trebbles  owned by user",
      true,
      false,
      false,
    );
  },

  getExpiredCapsulesForUserByUserIdOrUsername: function (userId, username, numberOfResults, pageOffset) {
    return this._makeApiServerCall(
      "getExpiredCapsulesForUserByUserIdOrUsername",
      {
        userId: userId,
        username: username,
        numberOfResults: numberOfResults,
        pageOffset: pageOffset,
      },
      "Get expired user capsules",
      true,
      false,
      false,
    );
  },

  getReceivedCapsules: function () {
    return this._makeApiServerCall("getReceivedCapsules", {}, "Get received  capsules", false, false, false);
  },

  getReceivedCapsulesWithPaging: function (searchKeyword, pageOffset, numberOfResults) {
    return this._makeApiServerCall(
      "getReceivedCapsulesWithPaging",
      {
        searchKeyword: searchKeyword,
        numberOfResults: numberOfResults,
        pageOffset: pageOffset,
      },
      "Get received  capsules",
      false,
      false,
      false,
    );
  },

  getOffAirCapsules: function () {
    return this._makeApiServerCall("getOffAirCapsules", {}, "Get Off-Air  capsules", false, false, false);
  },

  getOffAirCapsulesWithPaging: function (searchKeyword, pageOffset, numberOfResults) {
    return this._makeApiServerCall(
      "getOffAirCapsulesWithPaging",
      {
        searchKeyword: searchKeyword,
        numberOfResults: numberOfResults,
        pageOffset: pageOffset,
      },
      "Get Off-Air  capsules with paging",
      false,
      false,
      false,
    );
  },

  getDraftCapsules: function () {
    return this._makeApiServerCall("getDraftCapsules", {}, "Get Draft  capsules", false, false, false);
  },

  getDraftCapsulesWithPaging: function (searchKeyword, pageOffset, numberOfResults) {
    return this._makeApiServerCall(
      "getDraftCapsulesWithPaging",
      {
        searchKeyword: searchKeyword,
        numberOfResults: numberOfResults,
        pageOffset: pageOffset,
      },
      "Get Draft  capsules with paging",
      false,
      false,
      false,
    );
  },

  getOnAirCapsules: function () {
    return this._makeApiServerCall("getOnAirCapsules", {}, "Get On-Air  capsules", false, false, false);
  },

  getOnAirCapsulesWithPaging: function (searchKeyword, pageOffset, numberOfResults) {
    return this._makeApiServerCall(
      "getOnAirCapsulesWithPaging",
      {
        searchKeyword: searchKeyword,
        numberOfResults: numberOfResults,
        pageOffset: pageOffset,
      },
      "Get On-Air  capsules with paging",
      false,
      false,
      false,
    );
  },

  getAllMyCapsulesWithPaging: function (searchKeyword, pageOffset, numberOfResults, filterType, sortBy, folderId, unfiledOnly, workspaceId) {
    return this._makeApiServerCall(
      "getAllMyCapsulesWithPaging",
      this._appendWorkspaceIdParam({
        searchKeyword: searchKeyword,
        numberOfResults: numberOfResults,
        pageOffset: pageOffset,
        filterType: filterType || undefined,
        sortBy: sortBy || undefined,
        folderId: folderId || undefined,
        unfiledOnly: unfiledOnly ? "true" : undefined,
      }, workspaceId),
      "Get On-Air  capsules with paging",
      false,
      false,
      false,
    );
  },

  getScheduledCapsules: function () {
    return this._makeApiServerCall("getScheduleCapsules", {}, "Get Scheduled  capsules", false, false, false);
  },

  getScheduledCapsulesWithPaging: function (searchKeyword, pageOffset, numberOfResults) {
    return this._makeApiServerCall(
      "getScheduleCapsulesWithPaging",
      {
        searchKeyword: searchKeyword,
        numberOfResults: numberOfResults,
        pageOffset: pageOffset,
      },
      "Get Scheduled  capsules with paging",
      false,
      false,
      false,
    );
  },

  getMyCapsuleFeed: function () {
    return this._makeApiServerCall("getMyCapsuleFeed", {}, "Get my  capsules feed", false, false, false);
  },

  getAllCapsulesByType: function (maxNumberOfResults) {
    return this._makeApiServerCall(
      "getAllCapsulesByType",
      { maxNumberOfResults: maxNumberOfResults },
      "Get All  capsules by type",
      false,
      false,
      false,
    );
  },

  getCapsulesMatchingSearchFromRecentlyListenOnSmartSpeakers: function (audioPlayerToken, searchCriteria) {
    return this._makeApiServerCall(
      "getCapsulesMatchingSearchFromRecentlyListenOnSmartSpeakers",
      {
        audioPlayerToken: audioPlayerToken,
        searchCriteria: searchCriteria,
      },
      "Get Capsules Matching Search From Recently Listened On Smart Speakers",
      false,
      false,
      false,
    );
  },

  getOnAirCapsulesForRadioId: function (radioId, numberOfResults, pageOffset) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "getOnAirCapsulesForRadioId",
      {
        radioId: radioId,
        numberOfResults: numberOfResults,
        pageOffset: pageOffset,
      },
      "Get On-Air  capsules for radio id",
      shouldSkipLogin,
      false,
      false,
    );
  },

  getScheduledCapsulesForRadioId: function (radioId) {
    return this._makeApiServerCall(
      "getScheduleCapsulesForRadioId",
      {
        radioId: radioId,
      },
      "Get Schedule  capsules for radio id",
      false,
      false,
      false,
    );
  },

  getArchivedCapsulesForRadioId: function (radioId, numberOfResults, pageOffset) {
    const shouldSkipLogin = this._shouldSkipLoginForAnonymousBrowserRead();
    return this._makeApiServerCall(
      "getArchivedCapsulesForRadioId",
      {
        radioId: radioId,
        numberOfResults: numberOfResults,
        pageOffset: pageOffset,
      },
      "Get archived  capsules for radio id",
      shouldSkipLogin,
      false,
      false,
    );
  },

  getSimpleSetForCapsuleId: function (capsuleId) {
    const apiSelf = this;
    const params = {};
    params.capsuleId = capsuleId;
    return this._getSongsSetFromParams(
      params,
      "generateCapsuleSimpleSetForCapsuleId",
      "Get simple set for capsule id",
      false,
    );
  },

  getSimpleSetForSongId: function (songId) {
    const apiSelf = this;
    const params = {};
    params.songId = songId;
    return this._getSongsSetFromParams(params, "generateSongSimpleSetForSongId", "Get simple set for song id", false);
  },

  _getSongsSetFromParams: function (params, restApiName, actionName, isQueryForSongArray, noLogin) {
    const apiSelf = this;
    const startTime = new Date().getTime();
    let arrayOfSongs = null;
    let endTime = null;
    let result = null;
    const resolverFunc = function (resolve, reject) {
      $.post(_getApiBaseUrl() + "/" + restApiName, params)
        .done(function (response) {
          try {
            if (isQueryForSongArray) {
              arrayOfSongs = response.message;
              if (arrayOfSongs) {
                arrayOfSongs = arrayOfSongs ? arrayOfSongs : [];
                result = {};
                result.songs = arrayOfSongs;
                result.albums = apiSelf._getAlbumsArrayFromSongsJson(arrayOfSongs);
                result.artists = apiSelf._getArtistArrayFromAlbumsJson(result.albums);
                response.message = arrayOfSongs;
              }
            } else {
              const socialPlaylist = response.message;
              if (socialPlaylist) {
                arrayOfSongs = socialPlaylist ? socialPlaylist.songs : [];
                result = {};
                result.songs = arrayOfSongs;
                result.albums = apiSelf._getAlbumsArrayFromSongsJson(arrayOfSongs);
                result.artists = apiSelf._getArtistArrayFromAlbumsJson(result.albums);
                socialPlaylist.songs = arrayOfSongs;
                response.message = socialPlaylist;
              }
            }
            apiSelf._getDefaultResponseHandler(response, resolve, reject, undefined, actionName);
            endTime = new Date().getTime();
            if (window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
              window.trebbleAnalyticsHelper.trackEvent("backendCall", restApiName, actionName);
              window.trebbleAnalyticsHelper.trackTiming("Server API Call", endTime - startTime, "Success", actionName);
            }
          } catch (error) {
            apiSelf._getDefaultFailedResponseHandler(error, reject, undefined, actionName);
            endTime = new Date().getTime();
            if (window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
              window.trebbleAnalyticsHelper.trackEvent("backendCall", restApiName, actionName, -1);
              window.trebbleAnalyticsHelper.trackTiming(
                "Server API Call",
                endTime - startTime,
                "Error" + error,
                actionName,
              );
            }
          }
        })
        .fail(function (error) {
          apiSelf._getDefaultFailedResponseHandler(error, reject, undefined, actionName);
        });
    }.bind(this);

    if (noLogin) {
      return new RSVP.Promise(resolverFunc);
    }

    return this._doLogin().then(function () {
      return new RSVP.Promise(resolverFunc);
    });
  },

  _getSongsSetFromParamsViaGet: function (params, restApiName, actionName, isQueryForSongArray, noLogin) {
    const apiSelf = this;
    const startTime = new Date().getTime();
    let arrayOfSongs = null;
    let result = null;
    let endTime = null;
    const resolverFunc = function (resolve, reject) {
      $.get(_getApiBaseUrl() + "/" + restApiName, params)
        .done(function (response) {
          try {
            if (isQueryForSongArray) {
              if (arrayOfSongs) {
                arrayOfSongs = arrayOfSongs ? arrayOfSongs : [];
                result = {};
                result.songs = arrayOfSongs;
                result.albums = apiSelf._getAlbumsArrayFromSongsJson(arrayOfSongs);
                result.artists = apiSelf._getArtistArrayFromAlbumsJson(result.albums);
                response.message = arrayOfSongs;
              }
            } else {
              const socialPlaylist = response.message;
              if (socialPlaylist) {
                arrayOfSongs = socialPlaylist ? socialPlaylist.songs : [];
                result = {};
                result.songs = arrayOfSongs;
                result.albums = apiSelf._getAlbumsArrayFromSongsJson(arrayOfSongs);
                result.artists = apiSelf._getArtistArrayFromAlbumsJson(result.albums);
                socialPlaylist.songs = arrayOfSongs;
                response.message = socialPlaylist;
              }
            }
            apiSelf._getDefaultResponseHandler(response, resolve, reject, undefined, actionName);
            endTime = new Date().getTime();
            if (window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
              window.trebbleAnalyticsHelper.trackEvent("backendCall", restApiName, actionName);
              window.trebbleAnalyticsHelper.trackTiming("Server API Call", endTime - startTime, "Success", actionName);
            }
          } catch (error) {
            apiSelf._getDefaultFailedResponseHandler(error, reject, undefined, actionName);
            endTime = new Date().getTime();
            if (window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
              window.trebbleAnalyticsHelper.trackEvent("backendCall", restApiName, actionName, -1);
              window.trebbleAnalyticsHelper.trackTiming(
                "Server API Call",
                endTime - startTime,
                "Error" + error,
                actionName,
              );
            }
          }
        })
        .fail(function (error) {
          apiSelf._getDefaultFailedResponseHandler(error, reject, undefined, actionName);
        });
    }.bind(this);

    if (noLogin) {
      return new RSVP.Promise(resolverFunc);
    }

    return this._doLogin().then(function () {
      return new RSVP.Promise(resolverFunc);
    });
  },

  getAllSongInUserLibrary: function (username) {
    const apiSelf = this;
    const params = {};
    const startTime = new Date().getTime();
    let arrayOfSongs = null;
    let result = null;
    let endTime = null;
    params.username = username;
    const resolverFunc = function (resolve, reject) {
      $.post(_getApiBaseUrl() + "/getAllSongsInUserLibrary", params)
        .done(function (response) {
          try {
            arrayOfSongs = response.message;
            if (arrayOfSongs) {
              arrayOfSongs = arrayOfSongs ? arrayOfSongs : [];
              result = {};
              result.songs = arrayOfSongs;
              result.albums = apiSelf._getAlbumsArrayFromSongsJson(arrayOfSongs);
              result.artists = apiSelf._getArtistArrayFromAlbumsJson(result.albums);
              response.message = arrayOfSongs;
            }
            apiSelf._getDefaultResponseHandler(
              response,
              resolve,
              reject,
              undefined,
              "Get all songs in user personal library",
            );
            endTime = new Date().getTime();
            if (window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
              window.trebbleAnalyticsHelper.trackEvent(
                "backendCall",
                "getAllSongsInUserLibrary",
                "Get all songs in user personal library",
              );
              window.trebbleAnalyticsHelper.trackTiming(
                "Server API Call",
                endTime - startTime,
                "Success",
                "Get all songs in user personal library",
              );
            }
          } catch (error) {
            apiSelf._getDefaultFailedResponseHandler(
              error,
              reject,
              undefined,
              "Get all songs in user personal library",
            );
            endTime = new Date().getTime();
            if (window.trebbleAnalyticsHelper && ENABLE_BACKEND_CALL_ANAYLYTICS_TRACKING) {
              window.trebbleAnalyticsHelper.trackEvent(
                "backendCall",
                "getAllSongsInUserLibrary",
                "Get all songs in user personal library",
                -1,
              );
              window.trebbleAnalyticsHelper.trackTiming(
                "Server API Call",
                endTime - startTime,
                "Error" + error,
                "Get all songs in user personal library",
              );
            }
          }
        })
        .fail(function (error) {
          apiSelf._getDefaultFailedResponseHandler(error, reject, undefined, "Get all songs in user personal library");
        });
    }.bind(this);

    return this._doLogin().then(function () {
      return new RSVP.Promise(resolverFunc);
    });
  },

  getFollowersPersonalUserRadios: function (withPreviewOnly) {
    return this._makeApiServerCall(
      "getFollowersPersonalUserRadios",
      { withPreviewOnly: withPreviewOnly },
      "Get followers personal user Trebble",
    );
  },

  getFeaturedRadios: function (language, numberOfResults, pageOffset) {
    return this._makeApiServerCall(
      "getFeaturedRadios",
      { language: language, numberOfResults: numberOfResults, pageOffset: pageOffset },
      "Get featured trebbles",
      true,
    );
  },

  getRecentlyAddedRadios: function (language, showFeatured, numberOfResults, pageOffset) {
    return this._makeApiServerCall(
      "getRecentlyAddedRadios",
      { language: language, showFeatured: showFeatured, numberOfResults: numberOfResults, pageOffset: pageOffset },
      "Get recently added trebbles",
      true,
    );
  },

  getMyPersonalRadios: function () {
    return this._makeApiServerCall("getMyPersonalRadios", null, "Get my personal user Trebbles");
  },

  getTrebbleNamesAndLatestHeadlinesInUserSubsription: function () {
    return this._makeApiServerCall(
      "getTrebbleNamesAndLatestHeadlinesInUserSubsription",
      null,
      "Get trebble names and latest headlines for user id",
    );
  },

  getYoutubeDirectVideoUrl: function (videoId) {
    return this._makeApiServerCall(
      "getDirectYoutubeUrl",
      {
        videoId: videoId,
      },
      "Get youtube direct video URL",
    );
  },

  getStatisticsForMyTrebble: function (trebbleId) {
    return this._makeApiServerCall(
      "getStatisticsForMyTrebble",
      {
        radioId: trebbleId,
      },
      "Get statistics for trebble",
    );
  },

  getStatsForMyTrebble: function (trebbleId) {
    return this._makeApiServerCall(
      "getStatsForMyTrebble",
      {
        radioId: trebbleId,
      },
      "Get statistics for trebble",
    );
  },

  getStatisticsForSong: function (songTrebbleId) {
    return this._makeApiServerCall(
      "getStatisticsForSong",
      {
        songId: songTrebbleId,
      },
      "Get statistics for song",
    );
  },

  getStatisticsForCapsule: function (capsuleTrebbleId) {
    return this._makeApiServerCall(
      "getStatisticsForCapsule",
      {
        capsuleId: capsuleTrebbleId,
      },
      "Get statistics for capsule",
    );
  },

  enableEmailDigestNotification: function () {
    return this._makeApiServerCall(
      "enableEmailDigestNotification",
      null,
      "Enable Email Digest Notification",
      false,
      false,
      true,
    );
  },

  disableEmailDigestNotification: function () {
    return this._makeApiServerCall(
      "disableEmailDigestNotification",
      null,
      "Disable Email Digest Notification",
      false,
      false,
      true,
    );
  },

  getDecryptedYoutubeSignature: function (encryptedSignature, playerUrl) {
    return this._makeApiServerCall(
      "getDecipherSignature",
      {
        signature: encryptedSignature,
        playerUrl: playerUrl,
      },
      "Get decrypted youtube signature",
    );
  },

  syncSongsArrayWithDB: function (arrayOfSongsToSync, isFirstSync) {
    return this._makeApiServerCall(
      "resyncMySongLibrary",
      {
        model: arrayOfSongsToSync,
        isFirstSync: isFirstSync,
      },
      "Sync Songs",
      false,
      false,
      true,
    );
  },

  signup: function (params, callback, context) {
    const apiSelf = this;
    const language = window.getAppUsedLanguage();
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (window.trebble && window.trebble.adReference) {
      if (!context) {
        context = {};
      }
      context.environment = Utils.getInstance().getCurrentEnvironmentContext();
      context.adReference = window.trebble.adReference;
    }
    if (params) {
      if (context) {
        params.context = context;
      }
      params.language = language;
      params.timezone = timezone;
    }
    const resolverFunc = function (resolve, reject) {
      $.ajax(apiSelf._buildServerAjaxOptions("POST", "auth/password/signup", params, { skipStoredAuthToken: true }))
        .done(function (result) {
          apiSelf._getDefaultResponseHandler(result, resolve, reject, callback, "Signup");
        })
        .fail(function (error) {
          apiSelf._getDefaultFailedResponseHandler(error, reject, callback, "Signup");
        });
    };
    //return this._doLogin().then(function(){
    return new RSVP.Promise(resolverFunc).then(function (signupResult) {
      if (!signupResult || !signupResult.userCreated) {
        return signupResult;
      }

      // The legacy `/signup` (and its `auth/password/signup` alias) returns
      // `{userCreated, userInfo, tokenInfo: {token}}` — the JWT is nested
      // inside `tokenInfo`. The WorkOS-shaped response, by contrast, puts
      // `token` / `sessionTransport` at the top level next to userInfo.
      // _handleAuthenticatedTokenInfo expects the latter shape (it reads
      // `.token`, `.userInfo`, `.refreshToken` directly off the argument
      // and persists the whole object via
      // LocalStorageHelper.saveAuthentificationToken). Without normalizing,
      // a successful legacy-path signup returns 200 with a token but the
      // FE never persists it — auth never establishes, and any forward_url
      // redirect that follows lands on a route that bounces the
      // unauthenticated user right back to the signup page.
      var hasFlatSession = signupResult.token || signupResult.sessionTransport === "cookie";
      var nestedTokenInfo = signupResult.tokenInfo;
      var hasNestedSession = nestedTokenInfo && (nestedTokenInfo.token || nestedTokenInfo.sessionTransport === "cookie");

      if (hasFlatSession) {
        return apiSelf._finalizeAuthenticatedTokenInfo(signupResult).then(function () {
          return signupResult;
        });
      }

      if (hasNestedSession) {
        // Build the shape _finalizeAuthenticatedTokenInfo expects: token at
        // the top level, userInfo from whichever side carries it (the
        // legacy response writes userInfo as a sibling to tokenInfo; the
        // WorkOS path nests userInfo inside tokenInfo).
        var normalizedTokenInfo = Object.assign({}, nestedTokenInfo, {
          userInfo: (nestedTokenInfo && nestedTokenInfo.userInfo) || signupResult.userInfo || null,
        });
        return apiSelf._finalizeAuthenticatedTokenInfo(normalizedTokenInfo).then(function () {
          // Surface .token + .sessionTransport at the top level of the
          // returned signupResult so SignUpController.doSignup's
          // initialSessionEstablished check (which reads
          // `operationResult.token || operationResult.sessionTransport`)
          // correctly sees the established session and skips the
          // post-verification re-prompt path.
          return Object.assign({}, signupResult, {
            token: nestedTokenInfo.token || signupResult.token,
            sessionTransport: nestedTokenInfo.sessionTransport || signupResult.sessionTransport || null,
          });
        });
      }

      return signupResult;
    });
    //})
  },

  signupWithFacebook: function (
    facebookAccessToken,
    accessCode,
    context,
    trebbleName,
    trebbleDescription,
    trebbleCategoryId,
    trebbleCityId,
    trebbleCustomUrl,
    trebbleTimezone,
    trebbleLanguage,
    rssFeedUrlContentSource,
    profileType,
  ) {
    const apiSelf = this;
    const language = window.getAppUsedLanguage();
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (this._usesHostedWorkOSSocialAuth()) {
      return this._rejectUnsupportedHostedBrowserProvider("Facebook");
    }

    const params = {
      facebookAccessToken: facebookAccessToken,
      accessCode: accessCode,
      trebbleName: trebbleName,
      trebbleDescription: trebbleDescription,
      trebbleCategoryId: trebbleCategoryId,
      trebbleCustomUrl: trebbleCustomUrl,
      trebbleTimezone: trebbleTimezone,
      trebbleLanguage: trebbleLanguage,
      rssFeedUrlContentSource: rssFeedUrlContentSource,
      language: language,
      timezone: timezone,
      trebbleCityId: trebbleCityId,
      profileType: profileType,
    };
    if (window.trebble && window.trebble.adReference) {
      if (!context) {
        context = {};
      }
      context.adReference = window.trebble.adReference;
    }
    if (params && context) {
      params.context = context;
    }
    const resolverFunc = function (resolve, reject) {
      $.post(_getApiBaseUrl() + "/signupWithFacebookAccount", params)
        .done(function (result) {
          apiSelf._getDefaultResponseHandler(result, resolve, reject, undefined, "Signup With Facebook Account");
        })
        .fail(function (error) {
          apiSelf._getDefaultFailedResponseHandler(error, reject, undefined, "Signup With Facebook Account");
        });
    };
    //return this._doLogin().then(function(){
    return new RSVP.Promise(resolverFunc);
    //})
  },

  signupWithGoogle: function (
    googleAccessToken,
    accessCode,
    context,
    trebbleName,
    trebbleDescription,
    trebbleCategoryId,
    trebbleCityId,
    trebbleCustomUrl,
    trebbleTimezone,
    trebbleLanguage,
    rssFeedUrlContentSource,
    profileType,
    hostedAuthOptions,
  ) {
    const apiSelf = this;
    const language = window.getAppUsedLanguage();
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (window.trebble && window.trebble.adReference) {
      if (!context) {
        context = {};
      }
      context.adReference = window.trebble.adReference;
    }
    const hostedSignupContext = this._buildHostedBrowserSignupContext({
      accessCode: accessCode,
      profileType: profileType,
      trebbleName: trebbleName,
      trebbleDescription: trebbleDescription,
      trebbleCategoryId: trebbleCategoryId,
      trebbleCityId: trebbleCityId,
      trebbleCustomUrl: trebbleCustomUrl,
      trebbleTimezone: trebbleTimezone,
      trebbleLanguage: trebbleLanguage,
      rssFeedUrlContentSource: rssFeedUrlContentSource,
      context: context,
    });
    if (this._isBrowserHostedAuthEnvironment()) {
      return this._startHostedBrowserAuthRedirect("signup", this._getHostedBrowserSignupReturnUrl(), {
        provider: WORKOS_AUTH_PROVIDER_MAP.GOOGLE,
        signupContext: hostedSignupContext,
        pendingAction:
          hostedAuthOptions && hostedAuthOptions.pendingHostedAuthAction
            ? hostedAuthOptions.pendingHostedAuthAction
            : null,
      });
    }

    if (this._isCordovaHostedAuthEnvironment()) {
      return this._beginMobileHostedAuthFlow("signup", {
        provider: WORKOS_AUTH_PROVIDER_MAP.GOOGLE,
        signupContext: hostedSignupContext,
      }).then(function (result) {
        return {
          userCreated: result && result.userCreated !== undefined ? result.userCreated : true,
          tokenInfo: result ? result.tokenInfo : null,
          userInfo: result && result.tokenInfo ? result.tokenInfo.userInfo : null,
        };
      });
    }

    const params = {
      googleAccessToken: googleAccessToken,
      accessCode: accessCode,
      trebbleName: trebbleName,
      trebbleDescription: trebbleDescription,
      trebbleCategoryId: trebbleCategoryId,
      trebbleCustomUrl: trebbleCustomUrl,
      trebbleTimezone: trebbleTimezone,
      trebbleLanguage: trebbleLanguage,
      rssFeedUrlContentSource: rssFeedUrlContentSource,
      language: language,
      timezone: timezone,
      trebbleCityId: trebbleCityId,
      profileType: profileType,
    };
    if (params && context) {
      params.context = context;
    }
    const resolverFunc = function (resolve, reject) {
      $.post(_getApiBaseUrl() + "/signupWithGoogleAccount", params)
        .done(function (result) {
          apiSelf._getDefaultResponseHandler(result, resolve, reject, undefined, "Signup With Google Account");
        })
        .fail(function (error) {
          apiSelf._getDefaultFailedResponseHandler(error, reject, undefined, "Signup With Google Account");
        });
    };
    //return this._doLogin().then(function(){
    return new RSVP.Promise(resolverFunc);
    //})
  },

  signupWithApple: function (
    appleIdToken,
    accessCode,
    context,
    trebbleName,
    trebbleDescription,
    trebbleCategoryId,
    trebbleCityId,
    trebbleCustomUrl,
    trebbleTimezone,
    trebbleLanguage,
    rssFeedUrlContentSource,
    profileType,
    hostedAuthOptions,
  ) {
    if (!Utils.getInstance().shouldShowAppleAuthButtons()) {
      return RSVP.Promise.reject(window.getI18n(ti18n, "APPLE_SIGN_UP_TEMPORARILY_UNAVAILABLE"));
    }

    const apiSelf = this;
    const language = window.getAppUsedLanguage();
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (window.trebble && window.trebble.adReference) {
      if (!context) {
        context = {};
      }
      context.adReference = window.trebble.adReference;
    }
    const hostedSignupContext = this._buildHostedBrowserSignupContext({
      accessCode: accessCode,
      profileType: profileType,
      trebbleName: trebbleName,
      trebbleDescription: trebbleDescription,
      trebbleCategoryId: trebbleCategoryId,
      trebbleCityId: trebbleCityId,
      trebbleCustomUrl: trebbleCustomUrl,
      trebbleTimezone: trebbleTimezone,
      trebbleLanguage: trebbleLanguage,
      rssFeedUrlContentSource: rssFeedUrlContentSource,
      context: context,
    });
    if (this._isBrowserHostedAuthEnvironment()) {
      return this._startHostedBrowserAuthRedirect("signup", this._getHostedBrowserSignupReturnUrl(), {
        provider: WORKOS_AUTH_PROVIDER_MAP.APPLE,
        signupContext: hostedSignupContext,
        pendingAction:
          hostedAuthOptions && hostedAuthOptions.pendingHostedAuthAction
            ? hostedAuthOptions.pendingHostedAuthAction
            : null,
      });
    }

    if (this._isCordovaHostedAuthEnvironment()) {
      return this._beginMobileHostedAuthFlow("signup", {
        provider: WORKOS_AUTH_PROVIDER_MAP.APPLE,
        signupContext: hostedSignupContext,
      }).then(function (result) {
        return {
          userCreated: result && result.userCreated !== undefined ? result.userCreated : true,
          tokenInfo: result ? result.tokenInfo : null,
          userInfo: result && result.tokenInfo ? result.tokenInfo.userInfo : null,
        };
      });
    }

    const params = {
      appleIdToken: appleIdToken,
      accessCode: accessCode,
      trebbleName: trebbleName,
      trebbleDescription: trebbleDescription,
      trebbleCategoryId: trebbleCategoryId,
      trebbleCustomUrl: trebbleCustomUrl,
      trebbleTimezone: trebbleTimezone,
      trebbleLanguage: trebbleLanguage,
      rssFeedUrlContentSource: rssFeedUrlContentSource,
      language: language,
      timezone: timezone,
      trebbleCityId: trebbleCityId,
      profileType: profileType,
    };
    if (params && context) {
      params.context = context;
    }
    const resolverFunc = function (resolve, reject) {
      $.post(_getApiBaseUrl() + "/signupWithAppleAccount", params)
        .done(function (result) {
          apiSelf._getDefaultResponseHandler(result, resolve, reject, undefined, "Signup With Apple Account");
        })
        .fail(function (error) {
          apiSelf._getDefaultFailedResponseHandler(error, reject, undefined, "Signup With Apple Account");
        });
    };
    //return this._doLogin().then(function(){
    return new RSVP.Promise(resolverFunc);
    //})
  },

  updateGuestProfile: function (params, callback) {
    const apiSelf = this;
    const resolverFunc = function (resolve, reject) {
      $.post(_getApiBaseUrl() + "/updateGuestUserProfile", {
        updatedData: params,
      })
        .done(function (result) {
          apiSelf._getDefaultResponseHandler(result, resolve, reject, callback, "Update Guest User Profile");
        })
        .fail(function (error) {
          apiSelf._getDefaultFailedResponseHandler(error, reject, callback, "Update Guest User Profile");
        });
    };
    //return this._doLogin().then(function(){
    return this.doLoginAsGuest(true).then(
      function () {
        return new RSVP.Promise(resolverFunc);
      }.bind(this),
    );

    //})
  },

  updateLoggedInUserProfile: function (params, callback) {
    const apiSelf = this;
    const resolverFunc = function (resolve, reject) {
      $.post(_getApiBaseUrl() + "/updateMyProfileInfo", {
        updatedData: params,
      })
        .done(function (result) {
          apiSelf._getDefaultResponseHandler(result, resolve, reject, callback, "Update Logged In User Profile");
        })
        .fail(function (error) {
          apiSelf._getDefaultFailedResponseHandler(error, reject, callback, "Update Logged In User Profile");
        });
    };
    return this._doLogin().then(
      function () {
        return new RSVP.Promise(resolverFunc);
      }.bind(this),
    );
  },

  _getAlbumsArrayFromSongsJson: function (arrayOfSongs) {
    const albums = [];
    if (arrayOfSongs && arrayOfSongs.length > 0) {
      for (const songUri in arrayOfSongs) {
        const song = arrayOfSongs[songUri];
        if (song.albumJson) {
          let album = (album = albums[song.albumJson.albumId]);
          if (!album) {
            album = song.albumJson;
            album.songs = [];
            albums[album.albumId] = album;
          }
          album.songs.push(song);
        }
      }
    }
    return albums;
  },

  _getArtistArrayFromAlbumsJson: function (arrayOfAlbums) {
    const artists = [];
    if (arrayOfAlbums && arrayOfAlbums.length > 0) {
      for (const albumId in arrayOfAlbums) {
        const album = arrayOfAlbums[albumId];
        if (album.artistJson) {
          let artist = artists[album.artistJson.artistId];
          if (!artist) {
            artist = album.artistJson;
            artist.albums = [];
            artists[artist.artistId] = artist;
          }
          artist.albums.push(album);
        }
      }
    }
    return artists;
  },

  getAllSongsInAlbumFromGracenoteAlbumId: function (gracenoteAlbumId, callback) {
    const apiSelf = this;
    const resolverFunc = function (resolve, reject) {
      const postParams = {
        gracenoteAlbumId: gracenoteAlbumId,
      };
      $.post(_getApiBaseUrl() + "/getTrackListFromGracenoteId", postParams)
        .done(
          function (response) {
            try {
              const arrayOfSongs = response.message;
              const result = {};
              result.songs = arrayOfSongs;
              result.albums = apiSelf._getAlbumsArrayFromSongsJson(arrayOfSongs);
              result.artists = apiSelf._getArtistArrayFromAlbumsJson(result.albums);
              response.message = result;
              apiSelf._getDefaultResponseHandler(
                response,
                resolve,
                reject,
                undefined,
                "Get All Songs In Album From Gracenote Id",
              );
            } catch (error) {
              apiSelf._getDefaultFailedResponseHandler(
                error,
                reject,
                undefined,
                "Get All Songs In Album From Gracenote Id",
              );
            }
          }.bind(this),
        )
        .fail(
          function (error) {
            apiSelf._getDefaultFailedResponseHandler(
              error,
              reject,
              undefined,
              "Get All Songs In Album From Gracenote Id",
            );
          }.bind(this),
        );
    }.bind(this);
    return this._doLogin().then(
      function () {
        return new RSVP.Promise(resolverFunc);
      }.bind(this),
    );
  },

  getAllSongsInAlbumFromAlbumId: function (albumId, callback) {
    const apiSelf = this;
    const resolverFunc = function (resolve, reject) {
      const postParams = {
        albumId: albumId,
      };
      $.post(_getApiBaseUrl() + "/getCompleteAlbumDetailsByAlbumId", postParams)
        .done(
          function (response) {
            try {
              const completeAlbumInfo = response.message;
              const arrayOfSongs = completeAlbumInfo && completeAlbumInfo.songs ? completeAlbumInfo.songs : [];
              const result = {};
              result.songs = arrayOfSongs;
              const albumIdToAlbumMap = apiSelf._getAlbumsArrayFromSongsJson(arrayOfSongs);
              const artistIdToArtistMap = apiSelf._getArtistArrayFromAlbumsJson(result.albums);
              let albumInfoJson = null;
              for (const id in albumIdToAlbumMap) {
                albumInfoJson = albumIdToAlbumMap[id];
                break;
              }
              response.message = albumInfoJson;
              apiSelf._getDefaultResponseHandler(
                response,
                resolve,
                reject,
                undefined,
                "Get All Songs In Album From Album Id",
              );
            } catch (error) {
              apiSelf._getDefaultFailedResponseHandler(
                error,
                reject,
                undefined,
                "Get All Songs In Album From Album Id",
              );
            }
          }.bind(this),
        )
        .fail(
          function (error) {
            apiSelf._getDefaultFailedResponseHandler(error, reject, undefined, "Get All Songs In Album From Album Id");
          }.bind(this),
        );
    }.bind(this);
    return this._doLogin().then(
      function () {
        return new RSVP.Promise(resolverFunc);
      }.bind(this),
    );
  },

  addPlayActionToMyHistory: function (
    songTitle,
    artist,
    uri,
    actionTime,
    songJson,
    context,
    songRefSummary,
    schedulingPosition,
    playbackElapsedTime,
    callback,
  ) {
    this.addPlayerActionToMyHistory(
      _getApiBaseUrl() + "/addPlayActionToMyHistory",
      songTitle,
      artist,
      uri,
      actionTime,
      songJson,
      null,
      context,
      songRefSummary,
      schedulingPosition,
      playbackElapsedTime,
      callback,
    );
  },

  addFinishPlayingActionToMyHistory: function (
    songTitle,
    artist,
    uri,
    actionTime,
    songJson,
    context,
    songRefSummary,
    schedulingPosition,
    playbackElapsedTime,
    callback,
  ) {
    this.addPlayerActionToMyHistory(
      _getApiBaseUrl() + "/addFinishPlayingActionToMyHistory",
      songTitle,
      artist,
      uri,
      actionTime,
      songJson,
      null,
      context,
      songRefSummary,
      schedulingPosition,
      playbackElapsedTime,
      callback,
    );
  },

  addShareSongPageLaunchedActionToMyHistory: function (
    songTitle,
    artist,
    uri,
    actionTime,
    songJson,
    context,
    songRefSummary,
    schedulingPosition,
    playbackElapsedTime,
    callback,
  ) {
    this.addPlayerActionToMyHistory(
      _getApiBaseUrl() + "/addShareSongPageLaunchedActionToMyHistory",
      songTitle,
      artist,
      uri,
      actionTime,
      songJson,
      null,
      context,
      songRefSummary,
      schedulingPosition,
      playbackElapsedTime,
      callback,
    );
  },

  addViewExternalMediaSourcePageActionToMyHistory: function (
    songTitle,
    artist,
    uri,
    actionTime,
    songJson,
    mediaSourceExternalUrl,
    context,
    songRefSummary,
    schedulingPosition,
    playbackElapsedTime,
    callback,
  ) {
    this.addPlayerActionToMyHistory(
      _getApiBaseUrl() + "/addViewExternalMediaSourcePageActionToMyHistory",
      songTitle,
      artist,
      uri,
      actionTime,
      songJson,
      { mediaSourceExternalUrl: mediaSourceExternalUrl },
      context,
      songRefSummary,
      schedulingPosition,
      playbackElapsedTime,
      callback,
    );
  },

  addIndirectPlayActionToMyHistory: function (
    songTitle,
    artist,
    uri,
    actionTime,
    songJson,
    context,
    songRefSummary,
    schedulingPosition,
    playbackElapsedTime,
    callback,
  ) {
    this.addPlayerActionToMyHistory(
      _getApiBaseUrl() + "/addIndirectPlayActionToMyHistory",
      songTitle,
      artist,
      uri,
      actionTime,
      songJson,
      null,
      context,
      songRefSummary,
      schedulingPosition,
      playbackElapsedTime,
      callback,
    );
  },

  addFinishIndirectPlayingActionToMyHistory: function (
    songTitle,
    artist,
    uri,
    actionTime,
    songJson,
    context,
    songRefSummary,
    schedulingPosition,
    playbackElapsedTime,
    callback,
  ) {
    this.addPlayerActionToMyHistory(
      _getApiBaseUrl() + "/addFinishIndirectPlayingActionToMyHistory",
      songTitle,
      artist,
      uri,
      actionTime,
      songJson,
      null,
      context,
      songRefSummary,
      schedulingPosition,
      playbackElapsedTime,
      callback,
    );
  },

  addIndirectViewExternalMediaSourcePageActionToMyHistory: function (
    songTitle,
    artist,
    uri,
    actionTime,
    songJson,
    mediaSourceExternalUrl,
    context,
    songRefSummary,
    schedulingPosition,
    playbackElapsedTime,
    callback,
  ) {
    this.addPlayerActionToMyHistory(
      _getApiBaseUrl() + "/addIndirectViewExternalMediaSourcePageActionToMyHistory",
      songTitle,
      artist,
      uri,
      actionTime,
      songJson,
      { mediaSourceExternalUrl: mediaSourceExternalUrl },
      context,
      songRefSummary,
      schedulingPosition,
      playbackElapsedTime,
      callback,
    );
  },

  addLoopActionToMyHistory: function (
    songTitle,
    artist,
    uri,
    actionTime,
    songJson,
    numberOfTimes,
    context,
    songRefSummary,
    schedulingPosition,
    playbackElapsedTime,
    callback,
  ) {
    const additionalParams = {};
    additionalParams["numberOfTimes"] = numberOfTimes;
    this.addPlayerActionToMyHistory(
      _getApiBaseUrl() + "/addLoopActionToMyHistory",
      songTitle,
      artist,
      uri,
      actionTime,
      songJson,
      additionalParams,
      context,
      songRefSummary,
      schedulingPosition,
      playbackElapsedTime,
      callback,
    );
  },

  addSkipActionToMyHistory: function (
    songTitle,
    artist,
    uri,
    actionTime,
    songJson,
    context,
    songRefSummary,
    schedulingPosition,
    playbackElapsedTime,
    callback,
  ) {
    this.addPlayerActionToMyHistory(
      _getApiBaseUrl() + "/addSkipActionToMyHistory",
      songTitle,
      artist,
      uri,
      actionTime,
      songJson,
      null,
      context,
      songRefSummary,
      schedulingPosition,
      playbackElapsedTime,
      callback,
    );
  },

  addIndirectSkipActionToMyHistory: function (
    songTitle,
    artist,
    uri,
    actionTime,
    songJson,
    context,
    songRefSummary,
    schedulingPosition,
    playbackElapsedTime,
    skipReasonId,
    callback,
  ) {
    const additionalData = { skipReasonId: skipReasonId };
    this.addPlayerActionToMyHistory(
      _getApiBaseUrl() + "/addIndirectSkipActionToMyHistory",
      songTitle,
      artist,
      uri,
      actionTime,
      songJson,
      additionalData,
      context,
      songRefSummary,
      schedulingPosition,
      playbackElapsedTime,
      callback,
    );
  },

  addLiveLikeActionToMyHistory: function (
    songTitle,
    artist,
    uri,
    actionTime,
    songJson,
    context,
    songRefSummary,
    callback,
    weight,
    playbackElapsedTime,
  ) {
    this.addPlayerActionToMyHistory(
      _getApiBaseUrl() + "/addLiveLikeActionToMyHistory",
      songTitle,
      artist,
      uri,
      actionTime,
      songJson,
      null,
      context,
      songRefSummary,
      null,
      playbackElapsedTime,
      callback,
      weight,
    );
  },

  addTebbleLoadActionToMyHistory: function (
    radioLoaderKey,
    radioName,
    actionTime,
    additionalData,
    context,
    callback,
    sync,
    existingLogEntryIdToUpdate,
  ) {
    return this.addTrebbleActionToMyHistory(
      _getApiBaseUrl() + "/addRadioLoadedActionToHistory",
      radioLoaderKey,
      null,
      null,
      radioName,
      actionTime,
      additionalData,
      context,
      callback,
      sync,
      existingLogEntryIdToUpdate,
    );
  },

  addSimpleSongLoadActionToMyHistory: function (
    songId,
    actionTime,
    additionalData,
    context,
    callback,
    sync,
    existingLogEntryIdToUpdate,
  ) {
    return this.addTrebbleActionToMyHistory(
      _getApiBaseUrl() + "/addRadioLoadedActionToHistory",
      null,
      null,
      songId,
      null,
      actionTime,
      additionalData,
      context,
      callback,
      sync,
      existingLogEntryIdToUpdate,
    );
  },

  addSimpleCapsuleLadActionToMyHistory: function (
    capsuleId,
    actionTime,
    additionalData,
    context,
    callback,
    sync,
    existingLogEntryIdToUpdate,
  ) {
    return this.addTrebbleActionToMyHistory(
      _getApiBaseUrl() + "/addRadioLoadedActionToHistory",
      null,
      capsuleId,
      null,
      null,
      actionTime,
      additionalData,
      context,
      callback,
      sync,
      existingLogEntryIdToUpdate,
    );
  },

  addTebbleFinishPlayingActionToMyHistory: function (
    radioLoaderKey,
    radioName,
    actionTime,
    additionalData,
    context,
    callback,
    sync,
    existingLogEntryIdToUpdate,
  ) {
    return this.addTrebbleActionToMyHistory(
      _getApiBaseUrl() + "/addRadioFinishPlayingActionToHistory",
      radioLoaderKey,
      null,
      null,
      radioName,
      actionTime,
      additionalData,
      context,
      callback,
      sync,
      existingLogEntryIdToUpdate,
    );
  },

  addUserFeedPlayedActionToHistory: function (
    userFeedId,
    actionTime,
    additionalData,
    context,
    callback,
    sync,
    existingLogEntryIdToUpdate,
  ) {
    return this.addTrebbleActionToMyHistory(
      _getApiBaseUrl() + "/addUserFeedPlayedActionToHistory",
      userFeedId,
      null,
      null,
      null,
      actionTime,
      additionalData,
      context,
      callback,
      sync,
      existingLogEntryIdToUpdate,
    );
  },

  addCategoryShortcastRadioPlayedActionToHistory: function (
    categoryId,
    actionTime,
    additionalData,
    context,
    callback,
    sync,
    existingLogEntryIdToUpdate,
  ) {
    return this.addTrebbleActionToMyHistory(
      _getApiBaseUrl() + "/addCategoryShortcastRadioPlayedActionToHistory",
      null,
      null,
      null,
      null,
      actionTime,
      additionalData,
      context,
      callback,
      sync,
      existingLogEntryIdToUpdate,
      categoryId,
    );
  },

  //Only one from radioLoaderKey, capsuleId and songId should be specified
  addTrebbleActionToMyHistory: function (
    url,
    radioLoaderKey,
    capsuleId,
    songId,
    radioName,
    actionTime,
    additionalData,
    context,
    callback,
    sync,
    existingLogEntryIdToUpdate,
    categoryId,
  ) {
    const apiSelf = this;
    const dataToSend = {
      loaderKey: radioLoaderKey,
      trebbleId: radioLoaderKey,
      capsuleId: capsuleId,
      songId: songId,
      trebbleName: radioName,
      time: actionTime,
      additionalData: additionalData,
      actionContext: context,
      existingLogEntryIdToUpdate: existingLogEntryIdToUpdate,
      referrer: window.trebble.referrer,
      isEmbedded: window.isEmbedded,
      categoryId: categoryId,
      uniqueUserIdentifier: LocalStorageHelper.getInstance().getUniqueUserIdentifier(),
      customTrackingKey: window.trebble.customTrackingKey,
    };
    const resolveFunc = function (resolve, reject) {
      $.ajax(apiSelf._buildServerAjaxOptions("POST", url, dataToSend))
        .done(function (result) {
          apiSelf._getDefaultResponseHandler(result, resolve, reject, callback, "Add Player Action History");
        })
        .fail(function (error) {
          apiSelf._getDefaultFailedResponseHandler(error, reject, callback, "Add Player Action History");
        });
    };

    if (sync) {
      $.ajax(
        Object.assign(apiSelf._buildServerAjaxOptions("POST", url, dataToSend, { async: false }), {
          success: function (result) {
            apiSelf._getDefaultResponseHandler(
              result,
              function () {},
              function () {},
              callback,
              "Add Player Action History",
            );
          },
        }),
      );
      return RSVP.Promise.resolve();
    } else {
      return new RSVP.Promise(resolveFunc);
    }
  },

  addPlayerActionToMyHistory: function (
    url,
    songTitle,
    artist,
    uri,
    actionTime,
    songJson,
    additionalData,
    context,
    songRefSummary,
    schedulingPosition,
    playbackElapsedTime,
    callback,
    weight,
  ) {
    const apiSelf = this;
    const resolveFunc = function (resolve, reject) {
      $.ajax(
        apiSelf._buildServerAjaxOptions("POST", url, {
          songTitle: songTitle,
          artistName: artist,
          uri: uri,
          time: actionTime,
          songCachedData: songJson ? songJson._hiddedDBData : null,
          additionalData: additionalData,
          actionContext: context,
          songRefSummary: songRefSummary,
          schedulingPosition: schedulingPosition,
          playbackElapsedTime: playbackElapsedTime,
          weight: weight,
          referrer: window.trebble.referrer,
          isEmbedded: window.isEmbedded,
          uniqueUserIdentifier: LocalStorageHelper.getInstance().getUniqueUserIdentifier(),
          customTrackingKey: window.trebble.customTrackingKey,
        }),
      )
        .done(function (result) {
          apiSelf._getDefaultResponseHandler(result, resolve, reject, callback, "Add Player Action History");
        })
        .fail(function (error) {
          apiSelf._getDefaultFailedResponseHandler(error, reject, callback, "Add Player Action History");
        });
    };
    return new RSVP.Promise(resolveFunc);
  },

  getCaption: function (captionId) {
    return this._makeApiServerCall(
        `getCaption/${captionId}`,
        {
            id: captionId
        },
        "Get a caption by ID"
    );
  },

  getCaptions: function (filters = {}, workspaceId) {
    return this._makeApiServerCall(
        "getCaptions",
        this._appendWorkspaceIdParam({filters}, workspaceId),
        "Get all captions with optional filters"
    );
  },

  createCaption: function (captionData, workspaceId) {
    const effectiveWorkspaceId = this._resolveWorkspaceIdForScopedMutation(workspaceId);
    return this._makeApiServerCall(
        "createCaption",
        this._appendWorkspaceIdParam({captionDataString: JSON.stringify(captionData)}, effectiveWorkspaceId),
        "Create a new caption"
    );
  },

  updateCaption: function (captionId, captionData, workspaceId) {
    const effectiveWorkspaceId = this._resolveWorkspaceIdForScopedMutation(workspaceId);
    return this._makeApiServerCall(
        `updateCaption/${captionId}`,
        this._appendWorkspaceIdParam({
            id: captionId,
            captionDataString: JSON.stringify(captionData),
        }, effectiveWorkspaceId),
        "Update an existing caption"
    );
  },

  deleteCaption: function (captionId, workspaceId) {
    return this._makeApiServerCall(
        `deleteCaption/${captionId}`,
        this._appendWorkspaceIdParam({
            id: captionId
        }, workspaceId),
        "Delete a caption"
    );
  },

  // Guest / Collaboration methods

  inviteGuestToProject: function(params) {
    return this._makeApiServerCall("inviteGuestToProject", params, "Invite Guest To Project");
  },

  acceptGuestInvite: function(params) {
    return this._makeApiServerCall("acceptGuestInvite", params, "Accept Guest Invite");
  },

  declineGuestInvite: function(params) {
    return this._makeApiServerCall("declineGuestInvite", params, "Decline Guest Invite");
  },

  revokeGuestAccess: function(params) {
    var requestParams = Object.assign({}, params || {});
    if (requestParams.guestRecordId == null && requestParams.guestId != null) {
      requestParams.guestRecordId = requestParams.guestId;
    }
    if (requestParams.guestId != null) {
      delete requestParams.guestId;
    }
    return this._makeApiServerCall("revokeGuestAccess", requestParams, "Revoke Guest Access");
  },

  getGuestsForProject: function(params) {
    return this._makeApiServerCall("getGuestsForProject", params, "Get Guests For Project");
  },

  getProjectsSharedWithMe: function(params) {
    return this._makeApiServerCall("getProjectsSharedWithMe", params, "Get Projects Shared With Me");
  },

  getMyGuestInfo: function() {
    return this._makeApiServerCall("getMyGuestInfo", {}, "Get My Guest Info");
  },

  getMyAccessLevelForProject: function(params) {
    return this._makeApiServerCall("getMyAccessLevelForProject", params, "Get My Access Level For Project");
  },

  swapGuest: function(params) {
    return this._makeApiServerCall("swapGuest", params, "Swap Guest");
  },

  // Workspace CRUD methods

  createTeamWorkspace: function(params) {
    return this._makeApiServerCall("api/v1/workspace/create", params, "Create Team Workspace");
  },

  getWorkspace: function(params) {
    return this._makeApiServerCall("api/v1/workspace/get", params, "Get Workspace");
  },

  updateWorkspace: function(params) {
    return this._makeApiServerCall("api/v1/workspace/update", params, "Update Workspace");
  },

  getMyWorkspaces: function() {
    return this._makeApiServerCall("api/v1/workspace/getMyWorkspaces", {}, "Get My Workspaces");
  },

  switchWorkspace: function(params) {
    return this._makeApiServerCall("api/v1/workspace/switch", params, "Switch Workspace");
  },

  // Workspace Members

  inviteWorkspaceMember: function(params) {
    return this._makeApiServerCall("api/v1/workspace/member/invite", params, "Invite Workspace Member");
  },

  acceptWorkspaceMemberInvite: function(params) {
    return this._makeApiServerCall("api/v1/workspace/member/accept", params, "Accept Workspace Member Invite");
  },

  declineWorkspaceMemberInvite: function(params) {
    return this._makeApiServerCall("api/v1/workspace/member/decline", params, "Decline Workspace Member Invite");
  },

  removeWorkspaceMember: function(params) {
    return this._makeApiServerCall("api/v1/workspace/member/remove", params, "Remove Workspace Member");
  },

  listWorkspaceMembers: function(params) {
    return this._makeApiServerCall("api/v1/workspace/member/list", params, "List Workspace Members");
  },

  listWorkspaceReviewers: function(params) {
    return this._makeApiServerCall("api/v1/workspace/reviewer/list", params, "List Workspace Reviewers");
  },

  revokeWorkspaceReviewer: function(params) {
    var requestParams = Object.assign({}, params || {});
    if (requestParams.userUID == null && requestParams.userId != null) {
      requestParams.userUID = requestParams.userId;
    }
    if (requestParams.userId != null) {
      delete requestParams.userId;
    }
    return this._makeApiServerCall("api/v1/workspace/reviewer/revoke", requestParams, "Revoke Workspace Reviewer");
  },

  setWorkspaceMemberRole: function(params) {
    return this._makeApiServerCall("api/v1/workspace/member/setRole", params, "Set Workspace Member Role");
  },

  setWorkspaceMemberAdmin: function(params) {
    return this._makeApiServerCall("api/v1/workspace/member/setAdmin", params, "Set Workspace Member Admin");
  },

  leaveWorkspace: function(params) {
    return this._makeApiServerCall("api/v1/workspace/member/leave", params, "Leave Workspace");
  },

  // Workspace Logo

  getSignatureForWorkspaceLogoUpload: function(params) {
    return this._makeApiServerCall("getSignatureForWorkspaceLogoUpload", params, "Get Signature For Workspace Logo Upload");
  },

  updateWorkspaceLogo: function(params) {
    return this._makeApiServerCall("api/v1/workspace/updateLogo", params, "Update Workspace Logo");
  },

  deleteWorkspaceLogo: function(params) {
    return this._makeApiServerCall("api/v1/workspace/deleteLogo", params, "Delete Workspace Logo");
  },

  // Workspace Projects

  listWorkspaceProjects: function(params) {
    var requestParams = Object.assign({}, params || {});
    if (Object.prototype.hasOwnProperty.call(requestParams, "referenceProjectOnly")) {
      requestParams.referenceProjectOnly = requestParams.referenceProjectOnly ? "true" : "false";
    }
    if (Object.prototype.hasOwnProperty.call(requestParams, "unfiledOnly")) {
      requestParams.unfiledOnly = requestParams.unfiledOnly ? "true" : "false";
    }
    return this._makeApiServerCall("api/v1/workspace/project/list", requestParams, "List Workspace Projects");
  },

  setProjectVisibility: function(params) {
    return this._makeApiServerCall("api/v1/workspace/project/setVisibility", params, "Set Project Visibility");
  },

  listProjectFolders: function(params) {
    return this._makeApiServerCall("api/v1/project-folder/list", params, "List Project Folders");
  },

  createProjectFolder: function(params) {
    return this._makeApiServerCall("api/v1/project-folder/create", params, "Create Project Folder");
  },

  assignProjectFolderItem: function(params) {
    return this._makeApiServerCall("api/v1/project-folder/assignItem", params, "Assign Project Folder Item");
  },

  deleteProjectFolder: function(params) {
    return this._makeApiServerCall("api/v1/project-folder/delete", params, "Delete Project Folder");
  },

  renameProjectFolder: function(params) {
    return this._makeApiServerCall("api/v1/project-folder/rename", params, "Rename Project Folder");
  },

  moveProjectFolder: function(params) {
    return this._makeApiServerCall("api/v1/project-folder/move", params, "Move Project Folder");
  },

  listAssets: function(params) {
    return this._makeApiServerCall("api/v1/asset/list", params, "List Assets");
  },

  deleteAsset: function(params) {
    return this._makeApiServerCall("api/v1/asset/delete", params, "Delete Asset");
  },

  listRecordings: function(params) {
    return this._makeApiServerCall("api/v1/recording/list", params, "List Recordings");
  },

  deleteRecording: function(params) {
    return this._makeApiServerCall("api/v1/recording/delete", params, "Delete Recording");
  },

  listAssetFolders: function(params) {
    return this._makeApiServerCall("api/v1/asset-folder/list", params, "List Asset Folders");
  },

  createAssetFolder: function(params) {
    return this._makeApiServerCall("api/v1/asset-folder/create", params, "Create Asset Folder");
  },

  assignAssetFolderItem: function(params) {
    return this._makeApiServerCall("api/v1/asset-folder/assignItem", params, "Assign Asset Folder Item");
  },

  deleteAssetFolder: function(params) {
    return this._makeApiServerCall("api/v1/asset-folder/delete", params, "Delete Asset Folder");
  },

  renameAssetFolder: function(params) {
    return this._makeApiServerCall("api/v1/asset-folder/rename", params, "Rename Asset Folder");
  },

  moveAssetFolder: function(params) {
    return this._makeApiServerCall("api/v1/asset-folder/move", params, "Move Asset Folder");
  },

  // Workspace Billing

  /**
   * Fetch the centralized billing plan catalog (plans + add-ons with live
   * Stripe prices). Safe to call without authentication; the endpoint is
   * public so it can be used from pricing UIs pre-login.
   */
  getBillingPlans: function(params) {
    const apiSelf = this;
    return new RSVP.Promise(function(resolve, reject) {
      $.ajax(apiSelf._buildServerAjaxOptions("GET", "api/v1/billing/plans", params || {}, {
        skipStoredAuthToken: true
      }))
        .done(function(response) {
          apiSelf._getDefaultResponseHandler(response, resolve, reject, null, "Get Billing Plans");
        })
        .fail(function(error) {
          apiSelf._getDefaultFailedResponseHandler(error, reject, null, "Get Billing Plans");
        });
    });
  },

  createTeamSubscription: function(params) {
    return this._makeApiServerCall("api/v1/workspace/billing/createTeamSubscription", params, "Create Team Subscription");
  },

  getWorkspaceBillingPortalUrl: function(params) {
    return this._makeApiServerCall("api/v1/workspace/billing/getPortalUrl", params, "Get Workspace Billing Portal");
  },

  /**
   * Create a Stripe Checkout Session in setup-mode so a workspace owner can
   * attach a FIRST payment method to their workspace. The Customer Portal
   * endpoint (`getWorkspaceBillingPortalUrl`) requires an existing customer
   * with a default source - workspaces on Free/Starter that never upgraded
   * have neither, and the portal call throws. Use this endpoint for the
   * "Add Payment Method" flow and reserve the portal for existing methods.
   */
  createWorkspaceSetupCheckoutSession: function(params) {
    return this._makeApiServerCall("api/v1/workspace/billing/createSetupCheckoutSession", params, "Create Workspace Setup Checkout Session");
  },

  getWorkspaceUsage: function(params) {
    return this._makeApiServerCall("api/v1/workspace/billing/getUsage", params, "Get Workspace Usage");
  },

  /**
   * Personal-space (default workspace) storage usage. Mirrors getWorkspaceUsage
   * but for the workspaceId === null context. Backed by POST
   * /api/v1/storage/usage in routes/storageRoutes.js (the same handler is
   * registered for both GET and POST; we use POST here because
   * _makeApiServerCall is hardcoded to POST and unwraps the legacy
   * `message` envelope for us). Gated on STORAGE_SERVICE_ENABLED on the
   * backend; returns 503 when disabled, in which case callers should
   * treat the usage as unknown (UI shows "--").
   *
   * Response shape (per StorageService.getUsage):
   *   { quotaUsedBytes, quotaLimitBytes, activeBytes, trashedBytes, … }
   */
  getMyStorageUsage: function(params) {
    return this._makeApiServerCall("api/v1/storage/usage", params || {}, "Get My Storage Usage");
  },

  cancelWorkspaceSubscription: function(params) {
    return this._makeApiServerCall("api/v1/workspace/billing/cancelSubscription", params, "Cancel Workspace Subscription");
  },

  updateWorkspaceSeatCount: function(params) {
    return this._makeApiServerCall("api/v1/workspace/billing/updateSeatCount", params, "Update Workspace Seat Count");
  },

  // Pro to Team Migration

  migrateProToTeam: function(params) {
    return this._makeApiServerCall("api/v1/workspace/migrateProToTeam", params, "Migrate Pro To Team");
  },

  // Workspace Lifecycle

  deleteWorkspace: function(params) {
    return this._makeApiServerCall("api/v1/workspace/delete", params, "Delete Workspace");
  },

  transferWorkspaceOwnership: function(params) {
    return this._makeApiServerCall("api/v1/workspace/transferOwnership", params, "Transfer Workspace Ownership");
  },

  // Workspace Billing (additional)

  changeWorkspacePlan: function(params) {
    params = params || {};
    const workspaceId = params.workspaceId;
    const requestParams = Object.assign({}, params);
    if (!requestParams.targetPlanType && requestParams.planType) {
      requestParams.targetPlanType = requestParams.planType;
    }
    delete requestParams.planType;
    const endpoint = workspaceId
      ? "api/v1/workspace/" + encodeURIComponent(workspaceId) + "/billing/changePlan"
      : "api/v1/workspace/billing/changePlan";
    return this._makeApiServerCall(endpoint, requestParams, "Change Workspace Plan");
  },

  purchaseHourPack: function(params) {
    return this._makeApiServerCall("api/v1/workspace/billing/purchaseHourPack", params, "Purchase Hour Pack");
  },

  purchaseStorageAddon: function(params) {
    return this._makeApiServerCall("api/v1/workspace/billing/purchaseStorageAddon", params, "Purchase Storage Add-on");
  },

  getWorkspaceBilling: function(params) {
    return this._makeApiServerCall("api/v1/workspace/billing/getBilling", params, "Get Workspace Billing");
  },

  // Workspace Upgrade Flow

  /**
   * Start a workspace upgrade. Creates a pending workspace and returns a Stripe clientSecret.
   * @param {{name: string, planType: string, billingCycle: string}} params
   */
  startWorkspaceUpgrade: function(params) {
    return this._makeApiServerCall("api/v1/workspace/upgrade/start", params, "Start Workspace Upgrade");
  },

  /**
   * Finalize a workspace upgrade after successful payment.
   * @param {{workspaceId: string}} params
   */
  finalizeWorkspaceUpgrade: function(params) {
    return this._makeApiServerCall("api/v1/workspace/upgrade/finalize", params, "Finalize Workspace Upgrade");
  },

  /**
   * Cancel a pending workspace upgrade (e.g. user backed out of payment step).
   *
   * When mode is 'in_place', the backend releases the upgradeInProgress
   * guard + detaches the unconfirmed subscription WITHOUT deleting the
   * workspace row (because the Free workspace must stay alive).
   *
   * @param {{workspaceId: string, mode?: 'create'|'in_place'}} params
   */
  cancelWorkspaceUpgrade: function(params) {
    return this._makeApiServerCall("api/v1/workspace/upgrade/cancel", params, "Cancel Workspace Upgrade");
  },


  // Project Sharing (Reviewer)

  shareProject: function(params) {
    return this._makeApiServerCall("api/v1/project/share", params, "Share Project");
  },

  removeProjectShare: function(params) {
    return this._makeApiServerCall("api/v1/project/removeShare", params, "Remove Project Share");
  },

  getSharedWithMeProjects: function(params) {
    return this._makeApiServerCall("api/v1/project/getSharedWithMe", params || {}, "Get Shared With Me Projects");
  },

  // Turbo Editor Comments

  listTurboEditorComments: function(params) {
    return this._makeApiServerCall("api/v1/turbo-editor/comments/list", params || {}, "List Turbo Editor Comments");
  },

  createTurboEditorComment: function(params) {
    return this._makeApiServerCall("api/v1/turbo-editor/comments/create", params || {}, "Create Turbo Editor Comment");
  },

  replyToTurboEditorComment: function(params) {
    return this._makeApiServerCall("api/v1/turbo-editor/comments/reply", params || {}, "Reply To Turbo Editor Comment");
  },

  updateTurboEditorComment: function(params) {
    return this._makeApiServerCall("api/v1/turbo-editor/comments/update", params || {}, "Update Turbo Editor Comment");
  },

  listTurboEditorCommentMentionCandidates: function(params) {
    return this._makeApiServerCall("api/v1/turbo-editor/comments/mentions", params || {}, "List Turbo Editor Comment Mention Candidates");
  },

  // Concurrent Edit
  //
  // Presence/lifecycle endpoints are fire-and-forget — they must not trigger
  // _doLogin or force logout on 401. A logged-out heartbeat is expected (e.g.,
  // tab left open through a session expiration) and should be ignored
  // silently rather than yanking the user out of their session.
  _makeProjectPresenceApiCall: function (apiName, params, actionLogName) {
    const apiSelf = this;
    return new RSVP.Promise(function (resolve) {
      apiSelf
        ._executeServerAjaxRequest("POST", apiName, params)
        .then(function (result) {
          if (result && result.error) {
            window.log(
              "Presence call '" + actionLogName + "' returned a soft error: " +
                JSON.stringify(result.error),
            );
            resolve(null);
            return;
          }
          if (result && result.success) {
            resolve(result.message);
            return;
          }
          resolve(result);
        })
        .catch(function (errorObj) {
          window.log(
            "Presence call '" + actionLogName + "' failed (ignored): " +
              (errorObj && errorObj.status ? errorObj.status : "unknown"),
          );
          resolve(null);
        });
    });
  },

  markProjectOpen: function(params) {
    return this._makeProjectPresenceApiCall("api/v1/project/editor/open", params, "Mark Project Open");
  },

  markProjectClosed: function(params) {
    return this._makeProjectPresenceApiCall("api/v1/project/editor/close", params, "Mark Project Closed");
  },

  projectEditorHeartbeat: function(params) {
    return this._makeProjectPresenceApiCall("api/v1/project/editor/heartbeat", params, "Project Editor Heartbeat");
  },

  getProjectActiveEditors: function(params) {
    return this._makeProjectPresenceApiCall("api/v1/project/editor/list", params, "Get Project Active Editors");
  },

  downloadWaveformPeaks: function (audioUrl) {
    return this._makeApiServerCall(
        "api/v1/audio/getWaveformPeaks",
        { audioUrl: audioUrl },
        "Download waveform peaks from S3"
    );
  },
});

const TrebbleClientAPI = new TrebbleClientAPIModel();

export default {
  getInstance: function () {
    return TrebbleClientAPI;
  },
};
